webpackJsonp([114276838955818,60335399758886],{

/***/ 227:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Portfolio | Dave Pack"}}},"layoutContext":{}}

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(272);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(227);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(41);
	
	var emptyObject = __webpack_require__(162);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(160);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(360);
	var isArguments = __webpack_require__(359);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(418);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(358);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(400);
	
	var _HelmetConstants = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(41);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(367));
	var shallowEqual = _interopDefault(__webpack_require__(423));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 *  Copyright (c) 2015-present, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var GLOBAL = typeof window === 'undefined' ? global : window;
	
	var setter = function(_setter, _clearer, array) {
	  return function(callback, delta) {
	    var id = _setter(function() {
	      _clearer.call(this, id);
	      callback.apply(this, arguments);
	    }.bind(this), delta);
	
	    if (!this[array]) {
	      this[array] = [id];
	    } else {
	      this[array].push(id);
	    }
	    return id;
	  };
	};
	
	var clearer = function(_clearer, array) {
	  return function(id) {
	    if (this[array]) {
	      var index = this[array].indexOf(id);
	      if (index !== -1) {
	        this[array].splice(index, 1);
	      }
	    }
	    _clearer(id);
	  };
	};
	
	var _timeouts = 'TimerMixin_timeouts';
	var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
	var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);
	
	var _intervals = 'TimerMixin_intervals';
	var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
	var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);
	
	var _immediates = 'TimerMixin_immediates';
	var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
	var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);
	
	var _rafs = 'TimerMixin_rafs';
	var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
	var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);
	
	var TimerMixin = {
	  componentWillUnmount: function() {
	    this[_timeouts] && this[_timeouts].forEach(function(id) {
	      GLOBAL.clearTimeout(id);
	    });
	    this[_timeouts] = null;
	    this[_intervals] && this[_intervals].forEach(function(id) {
	      GLOBAL.clearInterval(id);
	    });
	    this[_intervals] = null;
	    this[_immediates] && this[_immediates].forEach(function(id) {
	      GLOBAL.clearImmediate(id);
	    });
	    this[_immediates] = null;
	    this[_rafs] && this[_rafs].forEach(function(id) {
	      GLOBAL.cancelAnimationFrame(id);
	    });
	    this[_rafs] = null;
	  },
	
	  setTimeout: _setTimeout,
	  clearTimeout: _clearTimeout,
	
	  setInterval: _setInterval,
	  clearInterval: _clearInterval,
	
	  setImmediate: _setImmediate,
	  clearImmediate: _clearImmediate,
	
	  requestAnimationFrame: _requestAnimationFrame,
	  cancelAnimationFrame: _cancelAnimationFrame,
	};
	
	module.exports = TimerMixin;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ExLink = function ExLink(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['to', 'children']);
	
	  return _react2.default.createElement(
	    _.Text,
	    { style: styles.link },
	    _react2.default.createElement(
	      'a',
	      { href: to, target: 'blank' },
	      children
	    )
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  link: {
	    fontWeight: '100'
	  }
	});
	
	exports.default = ExLink;
	module.exports = exports['default'];

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(78);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteTitle = _ref.siteTitle,
	      subtitle = _ref.subtitle,
	      location = _ref.location;
	  return _react2.default.createElement(
	    _View2.default,
	    { style: styles.container },
	    _react2.default.createElement(
	      _View2.default,
	      { style: styles.titleContainer },
	      _react2.default.createElement(
	        _.Text,
	        { type: 'h1', style: styles.titleText },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            style: {
	              color: 'whitesmoke',
	              textDecoration: 'none'
	            }
	          },
	          siteTitle
	        )
	      ),
	      _react2.default.createElement(
	        _.Text,
	        { type: 'h3', style: styles.subtitleText },
	        subtitle
	      ),
	      _react2.default.createElement(
	        _.Text,
	        { type: 'h5', style: styles.locationText },
	        location
	      )
	    )
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  container: {
	    backgroundColor: 'steelblue'
	    // marginBottom: '1.45rem',
	  },
	  titleContainer: {
	    alignSelf: 'center',
	    width: '100%',
	    maxWidth: 960,
	    paddingVertical: '1.45rem',
	    paddingHorizontal: '1.0875rem'
	  },
	  titleText: {
	    fontWeight: '100',
	    letterSpacing: 2,
	    marginBottom: 0,
	    marginTop: 0
	  },
	  subtitleText: {
	    color: 'whitesmoke',
	    fontWeight: '100',
	    letterSpacing: 1,
	    marginBottom: 0,
	    marginTop: 0
	  },
	  locationText: {
	    color: 'whitesmoke',
	    fontWeight: '100',
	    letterSpacing: 1,
	    marginBottom: 0,
	    marginTop: 5
	  }
	});
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animated = __webpack_require__(24);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _gatsbyLink = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TINY = 200;
	var SMALL = 400;
	var MED = 800;
	
	var Image = function Image(_ref) {
	  var fileName = _ref.fileName,
	      width = _ref.width,
	      height = _ref.height,
	      style = _ref.style,
	      props = _objectWithoutProperties(_ref, ['fileName', 'width', 'height', 'style']);
	
	  if (height <= TINY && width <= TINY) {
	    fileName += '-tiny.jpg';
	  } else if (height <= SMALL && width <= SMALL) {
	    fileName += '-small.jpg';
	  } else if (height <= MED && width <= MED) {
	    fileName += '-medium.jpg';
	  } else {
	    fileName += '.jpg';
	  }
	
	  var uri = (0, _gatsbyLink.withPrefix)('/images/' + fileName);
	
	  return _react2.default.createElement(_Animated2.default.Image, _extends({ source: { uri: uri }, style: style }, props));
	};
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _exlink = __webpack_require__(93);
	
	Object.defineProperty(exports, 'ExLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_exlink).default;
	  }
	});
	
	var _header = __webpack_require__(94);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_header).default;
	  }
	});
	
	var _image = __webpack_require__(95);
	
	Object.defineProperty(exports, 'Image', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_image).default;
	  }
	});
	
	var _projects = __webpack_require__(42);
	
	Object.defineProperty(exports, 'Projects', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_projects).default;
	  }
	});
	
	var _section = __webpack_require__(97);
	
	Object.defineProperty(exports, 'Section', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_section).default;
	  }
	});
	
	var _text = __webpack_require__(98);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.debounce = exports.MAXSIZE = exports.DURATION = exports.MARGIN = exports.CARDSIZE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animated = __webpack_require__(24);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _ScrollView = __webpack_require__(25);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TouchableOpacity = __webpack_require__(39);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ = __webpack_require__(13);
	
	var _project = __webpack_require__(96);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CARDSIZE = exports.CARDSIZE = 280;
	var MARGIN = exports.MARGIN = 19.2;
	var DURATION = exports.DURATION = 200;
	var MAXSIZE = exports.MAXSIZE = 960;
	
	// from https://davidwalsh.name/javascript-debounce-function
	var debounce = exports.debounce = function debounce(func, wait, immediate) {
	  var timeout;
	  return function () {
	    var context = this,
	        args = arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) func.apply(context, args);
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) func.apply(context, args);
	  };
	};
	
	var Projects = function (_Component) {
	  _inherits(Projects, _Component);
	
	  function Projects(props) {
	    _classCallCheck(this, Projects);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visibleCards = [];
	    var projectsLayout = props.projects.map(function (p, i) {
	      visibleCards.push(i);
	      return {
	        xW: null,
	        yW: null,
	        xP: null,
	        yP: null,
	        animatedSize: {
	          width: new _Animated2.default.Value(CARDSIZE + 2 * MARGIN),
	          height: new _Animated2.default.Value(CARDSIZE + 2 * MARGIN)
	        },
	        animatedPosition: {
	          top: new _Animated2.default.Value(0),
	          left: new _Animated2.default.Value(0)
	        },
	        cardPosition: {
	          top: new _Animated2.default.Value(0),
	          left: new _Animated2.default.Value(0)
	        },
	        cardSize: {
	          width: new _Animated2.default.Value(CARDSIZE),
	          height: new _Animated2.default.Value(CARDSIZE)
	        },
	        cardOpacity: new _Animated2.default.Value(1),
	        genericValue: new _Animated2.default.Value(0),
	        animatedStyle: {
	          position: 'relative'
	        },
	        containerStyle: {
	          zIndex: 0
	        },
	        cardStyle: {
	          boxShadow: '3px 3px 15px gray'
	        }
	      };
	    });
	    _this.state = {
	      visibleCards: visibleCards,
	      projectIndex: null,
	      projectsLayout: projectsLayout,
	      animatedValue: new _Animated2.default.Value(0)
	    };
	    return _this;
	  }
	
	  Projects.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var selectedTag = _ref.selectedTag;
	
	    this.arrangeCards(selectedTag);
	  };
	
	  Projects.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        projects = _props.projects,
	        skills = _props.skills;
	    var _state = this.state,
	        animatedValue = _state.animatedValue,
	        projectsLayout = _state.projectsLayout,
	        projectIndex = _state.projectIndex,
	        visibleCards = _state.visibleCards;
	
	
	    var backgroundColor = animatedValue.interpolate({
	      inputRange: [0, 1],
	      outputRange: ['rgba(105,105,105,0)', 'rgba(25, 25, 25, 0.9)']
	    });
	
	    var zIndex = animatedValue.interpolate({
	      inputRange: [0, 1],
	      outputRange: [0, 99]
	    });
	
	    return _react2.default.createElement(
	      _View2.default,
	      {
	        style: styles.projectsContainer,
	        ref: function ref(c) {
	          return _this2.projectsContainerRef = c;
	        }
	      },
	      _react2.default.createElement(_Animated2.default.View, {
	        pointerEvents: 'box-none',
	        style: {
	          position: 'fixed',
	          left: 0,
	          top: 0,
	          right: 0,
	          bottom: 0,
	          zIndex: projectIndex >= 0 ? 99 : 0,
	          backgroundColor: backgroundColor
	        }
	      }),
	      projects.map(function (project, i) {
	        var projectIsOpen = projectIndex === i;
	        return _react2.default.createElement(_project2.default, {
	          key: 'project-' + i,
	          projectRef: function projectRef(c) {
	            return _this2.projectRefs[i] = c;
	          },
	          onProjectPress: _this2.onProjectPress(i),
	          onProjectLayout: debounce(_this2.onProjectLayout(i), 250),
	          projectLayout: projectsLayout[i],
	          project: project,
	          disablePress: projectIsOpen || !visibleCards.includes(i),
	          skills: skills,
	          projectIsOpen: projectIsOpen
	        });
	      })
	    );
	  };
	
	  return Projects;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.projectsContainerRef = null;
	  this.projectRefs = [];
	
	  this.measureProject = function (index, callback) {
	    var projectRef = _this3.projectRefs[index];
	    if (projectRef) {
	      projectRef.measureInWindow(function (xW, yW) {
	        var projectsLayout = [].concat(_this3.state.projectsLayout);
	        projectsLayout[index] = _extends({}, projectsLayout[index], {
	          xW: xW,
	          yW: yW
	        });
	
	        _this3.setState({ projectsLayout: projectsLayout }, callback);
	      });
	    }
	  };
	
	  this.openCard = function (index, callback) {
	    var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	    projectsLayout[index] = _extends({}, projectsLayout[index], {
	      animatedStyle: { position: 'absolute' },
	      containerStyle: { zIndex: 9999 },
	      cardStyle: {
	        boxShadow: 'unset'
	      }
	    });
	
	    _this3.setState({ projectsLayout: projectsLayout }, function () {
	      var _projectsLayout$index = projectsLayout[index],
	          animatedSize = _projectsLayout$index.animatedSize,
	          animatedPosition = _projectsLayout$index.animatedPosition,
	          cardPosition = _projectsLayout$index.cardPosition,
	          cardSize = _projectsLayout$index.cardSize,
	          xW = _projectsLayout$index.xW,
	          yW = _projectsLayout$index.yW,
	          genericValue = _projectsLayout$index.genericValue;
	
	
	      var toCardWidth = Math.min(MAXSIZE, window.innerHeight, window.innerWidth) - 2 * MARGIN;
	      var toCardHeight = Math.min(MAXSIZE, window.innerHeight) - 2 * MARGIN;
	
	      var duration = DURATION;
	      _Animated2.default.sequence([_Animated2.default.parallel([_Animated2.default.timing(_this3.state.animatedValue, {
	        toValue: 1,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.height, {
	        toValue: window.innerHeight,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.width, {
	        toValue: window.innerWidth,
	        duration: duration
	      }), _Animated2.default.timing(cardPosition.top, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(cardPosition.left, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.width, {
	        toValue: toCardWidth,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.height, {
	        toValue: toCardHeight,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.left, {
	        toValue: -xW,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: -yW,
	        duration: duration
	      }), _Animated2.default.timing(genericValue, {
	        toValue: 1,
	        duration: duration
	      })]), _Animated2.default.parallel([_Animated2.default.timing(animatedPosition.left, {
	        toValue: 0,
	        duration: 0
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: 0,
	        duration: 0
	      })])]).start(callback);
	    });
	  };
	
	  this.closeCard = function (index, callback) {
	    var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	    projectsLayout[index] = _extends({}, projectsLayout[index], {
	      animatedStyle: { position: 'absolute' },
	      cardStyle: {
	        boxShadow: '3px 3px 15px gray'
	      }
	    });
	
	    _this3.setState({ projectsLayout: projectsLayout }, function () {
	      var _projectsLayout$index2 = projectsLayout[index],
	          animatedSize = _projectsLayout$index2.animatedSize,
	          animatedPosition = _projectsLayout$index2.animatedPosition,
	          cardSize = _projectsLayout$index2.cardSize,
	          xW = _projectsLayout$index2.xW,
	          yW = _projectsLayout$index2.yW,
	          genericValue = _projectsLayout$index2.genericValue;
	
	      var toAnimatedSize = CARDSIZE + 2 * MARGIN;
	      var toPosition = {
	        top: 0,
	        left: 0
	      };
	
	      var duration = DURATION;
	      _Animated2.default.sequence([_Animated2.default.parallel([_Animated2.default.timing(animatedPosition.left, {
	        toValue: -xW,
	        duration: 0
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: -yW,
	        duration: 0
	      })]), _Animated2.default.parallel([_Animated2.default.timing(_this3.state.animatedValue, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.height, {
	        toValue: toAnimatedSize,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.width, {
	        toValue: toAnimatedSize,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.width, {
	        toValue: CARDSIZE,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.height, {
	        toValue: CARDSIZE,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.left, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(genericValue, {
	        toValue: 0,
	        duration: duration
	      }), _this3.moveCards(_this3.state.visibleCards)])]).start(callback);
	    });
	  };
	
	  this.fixCardOpen = function (index, callback) {
	    var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	    var width = Math.min(window.innerWidth, window.innerHeight);
	    var height = width;
	    projectsLayout[index] = _extends({}, projectsLayout[index], {
	      animatedStyle: {
	        position: 'fixed'
	      }
	    });
	
	    _this3.setState({ projectsLayout: projectsLayout }, function () {
	      if (callback) callback();
	    });
	  };
	
	  this.onProjectPress = function (index) {
	    return function () {
	      _this3.measureProject(index, function () {
	        var oldIndex = _this3.state.projectIndex;
	
	        var projectIndex = oldIndex === index ? null : index;
	
	        if (oldIndex === index) {
	          // close card
	          var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	          projectsLayout[index] = _extends({}, projectsLayout[index], {
	            animatedStyle: { position: 'relative', top: 0, left: 0 },
	            containerStyle: { zIndex: 0 },
	            cardStyle: { boxShadow: '3px 3px 15px gray' }
	          });
	
	          _this3.closeCard(index, function () {
	            _this3.setState({
	              projectIndex: projectIndex,
	              projectsLayout: projectsLayout
	            });
	          });
	        } else {
	          // open card
	          _this3.setState({ projectIndex: projectIndex }, function () {
	            _this3.openCard(index, function () {
	              _this3.fixCardOpen(index);
	            });
	          });
	        }
	      });
	    };
	  };
	
	  this.onProjectLayout = function (index) {
	    return function (_ref2) {
	      var _ref2$nativeEvent$lay = _ref2.nativeEvent.layout,
	          xP = _ref2$nativeEvent$lay.x,
	          yP = _ref2$nativeEvent$lay.y,
	          width = _ref2$nativeEvent$lay.width,
	          height = _ref2$nativeEvent$lay.height;
	
	      // console.log('on project layout');
	      var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	      projectsLayout[index] = _extends({}, projectsLayout[index], {
	        xP: xP,
	        yP: yP
	      });
	
	      _this3.setState({ projectsLayout: projectsLayout });
	    };
	  };
	
	  this.disappearCards = function (removeArr) {
	    var removimationArr = [];
	
	    removeArr.forEach(function (index) {
	      var cardOpacity = _this3.state.projectsLayout[index].cardOpacity;
	
	
	      removimationArr.push(_Animated2.default.timing(cardOpacity, {
	        toValue: 0,
	        duration: DURATION
	      }));
	    });
	
	    return _Animated2.default.parallel(removimationArr);
	  };
	
	  this.appearCards = function (appearArr) {
	    var appearimationArr = [];
	
	    appearArr.forEach(function (index) {
	      var cardOpacity = _this3.state.projectsLayout[index].cardOpacity;
	
	
	      appearimationArr.push(_Animated2.default.timing(cardOpacity, {
	        toValue: 1,
	        duration: DURATION
	      }));
	    });
	
	    return _Animated2.default.parallel(appearimationArr);
	  };
	
	  this.moveCards = function (moveArr) {
	    var movimationArr = [];
	
	    moveArr.forEach(function (index, newIndex) {
	      var projectsLayout = _this3.state.projectsLayout;
	      var _projectsLayout$index3 = projectsLayout[index],
	          cardPosition = _projectsLayout$index3.cardPosition,
	          xP = _projectsLayout$index3.xP,
	          yP = _projectsLayout$index3.yP;
	      var _projectsLayout$newIn = projectsLayout[newIndex],
	          newX = _projectsLayout$newIn.xP,
	          newY = _projectsLayout$newIn.yP;
	
	
	      var toTopValue = newY - yP;
	      var toLeftValue = newX - xP;
	
	      movimationArr.push(_Animated2.default.timing(cardPosition.top, {
	        toValue: toTopValue,
	        duration: DURATION
	      }), _Animated2.default.timing(cardPosition.left, {
	        toValue: toLeftValue,
	        duration: DURATION
	      }));
	    });
	
	    return _Animated2.default.parallel(movimationArr);
	  };
	
	  this.arrangeCards = function (selectedTag) {
	    // animate card position in list
	    var projects = _this3.props.projects;
	    var _state2 = _this3.state,
	        visibleCards = _state2.visibleCards,
	        projectsLayout = _state2.projectsLayout;
	
	
	    var appearArr = [];
	    var moveArr = [];
	    var removeArr = [];
	
	    projects.forEach(function (_ref3, i) {
	      var tags = _ref3.tags;
	
	      if (!selectedTag) {
	        if (!visibleCards.includes(i)) {
	          appearArr.push(i);
	        }
	        moveArr.push(i);
	        return;
	      }
	
	      if (tags.includes(selectedTag)) {
	        if (!visibleCards.includes(i)) {
	          appearArr.push(i);
	        }
	        moveArr.push(i);
	      } else {
	        removeArr.push(i);
	      }
	    });
	
	    _Animated2.default.parallel([_this3.disappearCards(removeArr), _this3.appearCards(appearArr), _this3.moveCards(moveArr)]).start();
	
	    _this3.setState({ visibleCards: moveArr });
	  };
	};
	
	exports.default = Projects;
	
	
	var styles = _StyleSheet2.default.create({
	  projectsContainer: {
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    justifyContent: 'center',
	    margin: -MARGIN
	  }
	});

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animated = __webpack_require__(24);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _ScrollView = __webpack_require__(25);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TouchableOpacity = __webpack_require__(39);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ = __webpack_require__(13);
	
	var _2 = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(_ref) {
	  var project = _ref.project,
	      onProjectPress = _ref.onProjectPress,
	      onProjectLayout = _ref.onProjectLayout,
	      projectLayout = _ref.projectLayout,
	      projectRef = _ref.projectRef,
	      disablePress = _ref.disablePress,
	      skills = _ref.skills,
	      projectIsOpen = _ref.projectIsOpen;
	  var title = project.title,
	      mainImage = project.mainImage,
	      blurb = project.blurb,
	      tags = project.tags,
	      roles = project.roles,
	      links = project.links,
	      timeFrame = project.timeFrame;
	  var containerStyle = projectLayout.containerStyle,
	      animatedPosition = projectLayout.animatedPosition,
	      animatedSize = projectLayout.animatedSize,
	      animatedStyle = projectLayout.animatedStyle,
	      cardPosition = projectLayout.cardPosition,
	      cardSize = projectLayout.cardSize,
	      cardOpacity = projectLayout.cardOpacity,
	      cardStyle = projectLayout.cardStyle,
	      genericValue = projectLayout.genericValue;
	
	
	  var titleFontSize = genericValue.interpolate({
	    inputRange: [0, 1],
	    outputRange: ['20px', '30px']
	  });
	
	  return _react2.default.createElement(
	    _View2.default,
	    {
	      ref: projectRef,
	      onLayout: onProjectLayout,
	      style: [styles.projectContainer, containerStyle, {
	        height: _2.CARDSIZE + 2 * _2.MARGIN,
	        width: _2.CARDSIZE + 2 * _2.MARGIN
	        // borderWidth: 2,
	        // borderColor: 'purple',
	      }]
	    },
	    _react2.default.createElement(
	      _Animated2.default.View,
	      {
	        style: [{
	          height: animatedSize.height,
	          width: animatedSize.width,
	          top: animatedPosition.top,
	          left: animatedPosition.left,
	          padding: _2.MARGIN,
	          alignItems: 'center',
	          justifyContent: 'center'
	          // borderWidth: 2,
	          // borderColor: 'red',
	        }, animatedStyle]
	      },
	      _react2.default.createElement(
	        _Animated2.default.View,
	        {
	          style: [styles.projectCard, {
	            width: cardSize.width,
	            height: cardSize.height,
	            opacity: cardOpacity,
	            top: cardPosition.top,
	            left: cardPosition.left,
	            maxHeight: _2.MAXSIZE,
	            maxWidth: _2.MAXSIZE
	          }, cardStyle]
	        },
	        _react2.default.createElement(
	          _TouchableOpacity2.default,
	          {
	            onPress: onProjectPress,
	            activeOpacity: 0.7,
	            disabled: disablePress,
	            style: { height: '100%' }
	          },
	          _react2.default.createElement(_.Image, {
	            fileName: mainImage,
	            width: _2.CARDSIZE,
	            height: _2.CARDSIZE,
	            style: { height: cardSize.width, width: cardSize.width },
	            resizeMode: 'cover'
	          }),
	          _react2.default.createElement(
	            _View2.default,
	            { style: styles.blurbContainer },
	            _react2.default.createElement(
	              _ScrollView2.default,
	              {
	                style: styles.scrollView,
	                contentContainerStyle: {
	                  overflow: projectIsOpen ? undefined : 'hidden'
	                }
	              },
	              _react2.default.createElement(
	                _Animated2.default.Text,
	                {
	                  // numberOfLines={1}
	                  title: title,
	                  style: {
	                    lineHeight: '1.1',
	                    fontSize: titleFontSize,
	                    marginBottom: 15,
	                    marginTop: 20
	                  }
	                },
	                title
	              ),
	              _react2.default.createElement(
	                _Animated2.default.Text,
	                { style: { lineHeight: '1.1', fontSize: 16 } },
	                blurb
	              ),
	              _react2.default.createElement(
	                _Animated2.default.View,
	                {
	                  style: {
	                    opacity: genericValue,
	                    marginBottom: 15,
	                    height: projectIsOpen ? undefined : 0
	                  }
	                },
	                _react2.default.createElement(
	                  _.Text,
	                  { type: 'h4' },
	                  'Roles'
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  null,
	                  roles.join(', ')
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  { type: 'h4' },
	                  'Skills'
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  null,
	                  tags.map(function (tag) {
	                    return skills[tag];
	                  }).join(', ')
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  { type: 'h4' },
	                  'Links'
	                ),
	                links.map(function (_ref2) {
	                  var title = _ref2.title,
	                      url = _ref2.url,
	                      desc = _ref2.desc;
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    { key: url },
	                    _react2.default.createElement(
	                      _.ExLink,
	                      { to: url },
	                      title
	                    ),
	                    desc && _react2.default.createElement(
	                      _.Text,
	                      null,
	                      desc
	                    )
	                  );
	                }),
	                _react2.default.createElement(_.Text, null),
	                _react2.default.createElement(
	                  _TouchableOpacity2.default,
	                  {
	                    onPress: onProjectPress,
	                    disabled: !disablePress,
	                    style: { marginVertical: 20 }
	                  },
	                  _react2.default.createElement(
	                    _.Text,
	                    null,
	                    'Close'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  projectContainer: {
	    //
	  },
	  projectCard: {
	    backgroundColor: 'white',
	    borderRadius: 30,
	    overflow: 'hidden',
	    height: '100%'
	    // borderWidth: 2,
	    // borderColor: 'pink',
	  },
	  titleText: {
	    fontSize: '100%'
	  },
	  blurbContainer: {
	    position: 'absolute',
	    bottom: 0,
	    left: 0,
	    right: 0,
	    height: '65%',
	    backgroundColor: 'white',
	    boxShadow: '1px 1px 5px gray'
	  },
	  scrollView: {
	    paddingHorizontal: 20,
	    boxSizing: 'border-box',
	    // borderWidth: 3,
	    // borderColor: 'lightblue',
	    marginBottom: 15
	  }
	});
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.render = function render() {
	    return _react2.default.createElement(
	      _View2.default,
	      { style: styles.container },
	      _react2.default.createElement(
	        _View2.default,
	        { style: styles.section },
	        this.props.children
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	
	
	var styles = _StyleSheet2.default.create({
	  container: {
	    //
	  },
	  section: {
	    // padding: 20,
	    alignSelf: 'center',
	    width: '100%',
	    maxWidth: 960,
	    paddingVertical: '1.45rem',
	    paddingHorizontal: '1.0875rem'
	  }
	});
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _Text = __webpack_require__(51);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Text = function Text(_ref) {
	  var style = _ref.style,
	      textStyle = _ref.textStyle,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? 'p' : _ref$type,
	      _ref$headingLine = _ref.headingLine,
	      headingLine = _ref$headingLine === undefined ? false : _ref$headingLine,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['style', 'textStyle', 'type', 'headingLine', 'children']);
	
	  return _react2.default.createElement(
	    _Text2.default,
	    _extends({ style: [styles.base, styles[type], style] }, props),
	    children
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  h1: {
	    fontSize: '2.25rem'
	  },
	  h2: {
	    fontSize: '1.62671rem'
	  },
	  h3: {
	    fontSize: '1.38316rem'
	  },
	  h4: {
	    fontSize: '1.2rem'
	  },
	  h5: {
	    fontSize: '1rem'
	  },
	  p: {
	    fontSize: 16,
	    marginTop: 0,
	    marginBottom: 0
	  },
	  base: {
	    lineHeight: '1.1',
	    marginTop: 15,
	    marginBottom: 5
	  }
	});
	
	exports.default = Text;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var profile = exports.profile = {
	  name: {
	    first: 'Dave',
	    last: 'Pack'
	  },
	  title: 'Front End Engineer',
	  location: 'Mountain View, CA',
	  blurb: 'Strong front-end engineer, experience building mobile apps with React Native and web apps with React. Comfortable in the back-end working on the server, databases, or API design.\n\nI’m a big picture thinker. I love ideas and problem solving, learning about everything, finding connections and deep insights, and thinking outside the box.',
	  status: 'Currently looking for jobs in or near Mountain View, open to commuting to SF or San Jose.',
	  ideals: ['Work on an interdisciplinary team.', 'Collaborate in designing and implementing new products and features.', 'Contribute meaningfully to product strategy, design, and development.', 'Grow my current skills, learn new skills, mentor and teach others.', 'Give back through open source contribution.'],
	  goals: [{
	    title: '1 year',
	    blurb: 'Give my first conference talk.'
	  }, {
	    title: '3 years',
	    blurb: 'Cofound a successfully funded startup.'
	  }, {
	    title: '5 years',
	    blurb: 'Speak in 5 different countries.'
	  }, {
	    title: '10 years',
	    blurb: 'Live in a tiny house and travel the world.'
	  }],
	  profilePic: 'Profile-square',
	  links: [['https://twitter.com/dave_pack', 'Twitter'], ['https://github.com/davepack', 'GitHub'], ['https://www.linkedin.com/in/dpack', 'LinkedIn']]
	};
	
	var skills = exports.skills = {
	  'react-native': 'React Native',
	  react: 'React',
	  javascript: 'JavaScript',
	  'front-end': 'Front End',
	  'open-source': 'Open Source',
	  'api-design': 'API Design',
	  'ui-design': 'UI Design',
	  'mobile-design': 'Mobile Design',
	  ux: 'UX',
	  firebase: 'Firebase',
	  'realm-db': 'Realm Mobile DB',
	  'react-native-web': 'React Native Web',
	  animation: 'Animation',
	  'web-development': 'Web Development',
	  'mobile-development': 'Mobile Development'
	};
	
	var projects = exports.projects = [{
	  title: 'Personal Portfolio (this website)',
	  mainImage: 'Portfolio',
	  blurb: 'My personal site for showcasing my work and skills. Built with Gatsby static site generator and react-native-web.',
	  tags: ['react-native-web', 'react-native', 'react', 'javascript', 'ui-design', 'animation', 'front-end', 'web-development'],
	  roles: ['creator', 'designer', 'developer'],
	  links: [{
	    title: 'Source code',
	    url: 'https://github.com/davepack/davepack.github.io/tree/source'
	  }, {
	    title: 'React Native Web project',
	    url: 'https://github.com/necolas/react-native-web'
	  }],
	  timeFrame: [[2018, 4], [2018, 5]]
	}, {
	  title: 'SafeAreaView for React Native',
	  mainImage: 'SafeArea-square',
	  blurb: 'Library for supporting Safe Area insets on iPhone X. Originally written for react-navigation.',
	  tags: ['react-native', 'react', 'javascript', 'open-source', 'api-design', 'front-end', 'mobile-design'],
	  roles: ['creator', 'active maintainer'],
	  links: [{
	    title: 'Project source on GitHub',
	    url: 'https://github.com/react-community/react-native-safe-area-view'
	  }],
	  timeFrame: [[2017, 8], [2017, 11]]
	}, {
	  title: 'KnoWhy by Book of Mormon Central',
	  mainImage: 'KnoWhy-square',
	  blurb: 'Cross platform app written in React Native (JavaScript).',
	  tags: ['react-native', 'react', 'javascript', 'firebase', 'realm-db', 'front-end', 'ui-design', 'ux', 'mobile-design', 'mobile-development'],
	  roles: ['designer', 'developer'],
	  links: [{
	    title: 'Run the app on your phone',
	    url: 'https://expo.io/@davepack/knowhy',
	    desc: 'I modified the code to run in Expo, though it runs a bit slower than it originally did.'
	  }],
	  timeFrame: [[2016, 4], [2017, 6]]
	}];

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(399);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	__webpack_require__(368);
	
	var _components = __webpack_require__(13);
	
	var _data = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
	    }),
	    _react2.default.createElement(_components.Header, {
	      siteTitle: 'Dave Pack',
	      subtitle: _data.profile.title,
	      location: _data.profile.location
	    }),
	    children()
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AnimatedImplementation = __webpack_require__(135);
	
	var _AnimatedImplementation2 = _interopRequireDefault(_AnimatedImplementation);
	
	var _Image = __webpack_require__(80);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ScrollView = __webpack_require__(25);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _Text = __webpack_require__(51);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) {
	     return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var Animated = _extends({}, _AnimatedImplementation2.default, {
	     Image: _AnimatedImplementation2.default.createAnimatedComponent(_Image2.default),
	     ScrollView: _AnimatedImplementation2.default.createAnimatedComponent(_ScrollView2.default),
	     View: _AnimatedImplementation2.default.createAnimatedComponent(_View2.default),
	     Text: _AnimatedImplementation2.default.createAnimatedComponent(_Text2.default)
	}); /**
	     * Copyright (c) 2016-present, Nicolas Gallagher.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     *
	     * 
	     */
	
	exports.default = Animated;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _debounce = __webpack_require__(35);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	} /**
	   * Copyright (c) 2015-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var win = _ExecutionEnvironment.canUseDOM ? window : {
	  devicePixelRatio: undefined,
	  innerHeight: undefined,
	  innerWidth: undefined,
	  screen: {
	    height: undefined,
	    width: undefined
	  }
	};
	
	var dimensions = {};
	var listeners = {};
	
	var Dimensions = function () {
	  function Dimensions() {
	    _classCallCheck(this, Dimensions);
	  }
	
	  Dimensions.get = function get(dimension) {
	    (0, _invariant2.default)(dimensions[dimension], 'No dimension set for key ' + dimension);
	    return dimensions[dimension];
	  };
	
	  Dimensions.set = function set(initialDimensions) {
	    if (initialDimensions) {
	      if (_ExecutionEnvironment.canUseDOM) {
	        (0, _invariant2.default)(false, 'Dimensions cannot be set in the browser');
	      } else {
	        dimensions.screen = initialDimensions.screen;
	        dimensions.window = initialDimensions.window;
	      }
	    }
	  };
	
	  Dimensions._update = function _update() {
	    dimensions.window = {
	      fontScale: 1,
	      height: win.innerHeight,
	      scale: win.devicePixelRatio || 1,
	      width: win.innerWidth
	    };
	
	    dimensions.screen = {
	      fontScale: 1,
	      height: win.screen.height,
	      scale: win.devicePixelRatio || 1,
	      width: win.screen.width
	    };
	
	    if (Array.isArray(listeners['change'])) {
	      listeners['change'].forEach(function (handler) {
	        return handler(dimensions);
	      });
	    }
	  };
	
	  Dimensions.addEventListener = function addEventListener(type, handler) {
	    listeners[type] = listeners[type] || [];
	    listeners[type].push(handler);
	  };
	
	  Dimensions.removeEventListener = function removeEventListener(type, handler) {
	    if (Array.isArray(listeners[type])) {
	      listeners[type] = listeners[type].filter(function (_handler) {
	        return _handler !== handler;
	      });
	    }
	  };
	
	  return Dimensions;
	}();
	
	exports.default = Dimensions;
	
	Dimensions._update();
	
	if (_ExecutionEnvironment.canUseDOM) {
	  window.addEventListener('resize', (0, _debounce2.default)(Dimensions._update, 16), false);
	}

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ImageResizeMode = {
	  center: 'center',
	  contain: 'contain',
	  cover: 'cover',
	  none: 'none',
	  repeat: 'repeat',
	  stretch: 'stretch'
	};
	
	exports.default = ImageResizeMode;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AnimationPropTypes = __webpack_require__(56);
	
	var _AnimationPropTypes2 = _interopRequireDefault(_AnimationPropTypes);
	
	var _BorderPropTypes = __webpack_require__(57);
	
	var _BorderPropTypes2 = _interopRequireDefault(_BorderPropTypes);
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ImageResizeMode = __webpack_require__(45);
	
	var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);
	
	var _InteractionPropTypes = __webpack_require__(58);
	
	var _InteractionPropTypes2 = _interopRequireDefault(_InteractionPropTypes);
	
	var _LayoutPropTypes = __webpack_require__(59);
	
	var _LayoutPropTypes2 = _interopRequireDefault(_LayoutPropTypes);
	
	var _ShadowPropTypes = __webpack_require__(61);
	
	var _ShadowPropTypes2 = _interopRequireDefault(_ShadowPropTypes);
	
	var _TransformPropTypes = __webpack_require__(63);
	
	var _TransformPropTypes2 = _interopRequireDefault(_TransformPropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var ImageStylePropTypes = _extends({}, _AnimationPropTypes2.default, _BorderPropTypes2.default, _InteractionPropTypes2.default, _LayoutPropTypes2.default, _ShadowPropTypes2.default, _TransformPropTypes2.default, {
	  backgroundColor: _ColorPropType2.default,
	  opacity: _propTypes.number,
	  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
	  /**
	   * @platform unsupported
	   */
	  overlayColor: _propTypes.string,
	  tintColor: _ColorPropType2.default,
	  /**
	   * @platform web
	   */
	  boxShadow: _propTypes.string,
	  filter: _propTypes.string
	});
	
	exports.default = ImageStylePropTypes;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var dataUriPattern = /^data:/;
	
	var ImageUriCache = function () {
	  function ImageUriCache() {
	    _classCallCheck(this, ImageUriCache);
	  }
	
	  ImageUriCache.has = function has(uri) {
	    var entries = ImageUriCache._entries;
	    var isDataUri = dataUriPattern.test(uri);
	    return isDataUri || Boolean(entries[uri]);
	  };
	
	  ImageUriCache.add = function add(uri) {
	    var entries = ImageUriCache._entries;
	    var lastUsedTimestamp = Date.now();
	    if (entries[uri]) {
	      entries[uri].lastUsedTimestamp = lastUsedTimestamp;
	      entries[uri].refCount += 1;
	    } else {
	      entries[uri] = {
	        lastUsedTimestamp: lastUsedTimestamp,
	        refCount: 1
	      };
	    }
	  };
	
	  ImageUriCache.remove = function remove(uri) {
	    var entries = ImageUriCache._entries;
	    if (entries[uri]) {
	      entries[uri].refCount -= 1;
	    }
	    // Free up entries when the cache is "full"
	    ImageUriCache._cleanUpIfNeeded();
	  };
	
	  ImageUriCache._cleanUpIfNeeded = function _cleanUpIfNeeded() {
	    var entries = ImageUriCache._entries;
	    var imageUris = Object.keys(entries);
	
	    if (imageUris.length + 1 > ImageUriCache._maximumEntries) {
	      var leastRecentlyUsedKey = void 0;
	      var leastRecentlyUsedEntry = void 0;
	
	      imageUris.forEach(function (uri) {
	        var entry = entries[uri];
	        if ((!leastRecentlyUsedEntry || entry.lastUsedTimestamp < leastRecentlyUsedEntry.lastUsedTimestamp) && entry.refCount === 0) {
	          leastRecentlyUsedKey = uri;
	          leastRecentlyUsedEntry = entry;
	        }
	      });
	
	      if (leastRecentlyUsedKey) {
	        delete entries[leastRecentlyUsedKey];
	      }
	    }
	  };
	
	  return ImageUriCache;
	}();
	
	ImageUriCache._maximumEntries = 256;
	ImageUriCache._entries = {};
	exports.default = ImageUriCache;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _createElement = __webpack_require__(27);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _AssetRegistry = __webpack_require__(122);
	
	var _ImageLoader = __webpack_require__(123);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _ImageResizeMode = __webpack_require__(45);
	
	var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);
	
	var _ImageStylePropTypes = __webpack_require__(100);
	
	var _ImageStylePropTypes2 = _interopRequireDefault(_ImageStylePropTypes);
	
	var _ImageUriCache = __webpack_require__(101);
	
	var _ImageUriCache2 = _interopRequireDefault(_ImageUriCache);
	
	var _requestIdleCallback = __webpack_require__(134);
	
	var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetPropType = __webpack_require__(30);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var emptyObject = {};
	
	var STATUS_ERRORED = 'ERRORED';
	var STATUS_LOADED = 'LOADED';
	var STATUS_LOADING = 'LOADING';
	var STATUS_PENDING = 'PENDING';
	var STATUS_IDLE = 'IDLE';
	
	var ImageSourcePropType = (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.shape)({
	  height: _propTypes.number,
	  uri: _propTypes.string.isRequired,
	  width: _propTypes.number
	}), _propTypes.string]);
	
	var getImageState = function getImageState(uri, shouldDisplaySource) {
	  return shouldDisplaySource ? STATUS_LOADED : uri ? STATUS_PENDING : STATUS_IDLE;
	};
	
	var resolveAssetDimensions = function resolveAssetDimensions(source) {
	  if (typeof source === 'number') {
	    var _getAssetByID = (0, _AssetRegistry.getAssetByID)(source),
	        height = _getAssetByID.height,
	        width = _getAssetByID.width;
	
	    return { height: height, width: width };
	  } else if (typeof source === 'object') {
	    var _height = source.height,
	        _width = source.width;
	
	    return { height: _height, width: _width };
	  }
	};
	
	var svgDataUriPattern = /^(data:image\/svg\+xml;utf8,)(.*)/;
	var resolveAssetSource = function resolveAssetSource(source) {
	  var uri = void 0;
	  if (typeof source === 'number') {
	    // get the URI from the packager
	    var asset = (0, _AssetRegistry.getAssetByID)(source);
	    var scale = asset.scales[0];
	    var scaleSuffix = scale !== 1 ? '@' + scale + 'x' : '';
	    uri = asset ? asset.httpServerLocation + '/' + asset.name + scaleSuffix + '.' + asset.type : '';
	  } else if (source && source.uri) {
	    uri = source.uri;
	  } else {
	    uri = source || '';
	  }
	
	  var match = uri.match(svgDataUriPattern);
	  // inline SVG markup may contain characters (e.g., #, ") that need to be escaped
	  if (match) {
	    var prefix = match[1],
	        svg = match[2];
	
	    var encodedSvg = encodeURIComponent(svg);
	    return '' + prefix + encodedSvg;
	  }
	
	  return uri;
	};
	
	var getAssetTimeout = function getAssetTimeout(source) {
	  return typeof source === 'object' && source.timeout ? source.timeout : 1000;
	};
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  Image.getSize = function getSize(uri, success, failure) {
	    _ImageLoader2.default.getSize(uri, success, failure);
	  };
	
	  Image.prefetch = function prefetch(uri) {
	    return _ImageLoader2.default.prefetch(uri);
	  };
	
	  function Image(props, context) {
	    _classCallCheck(this, Image);
	
	    // If an image has been loaded before, render it immediately
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this._imageRequestId = null;
	    _this._imageState = null;
	    _this._isMounted = false;
	    _this._loadRequest = null;
	
	    _this._onError = function () {
	      var _this$props = _this.props,
	          onError = _this$props.onError,
	          source = _this$props.source;
	
	      _this._updateImageState(STATUS_ERRORED);
	      if (onError) {
	        onError({
	          nativeEvent: {
	            error: 'Failed to load resource ' + resolveAssetSource(source) + ' (404)'
	          }
	        });
	      }
	      _this._onLoadEnd();
	    };
	
	    _this._onLoad = function (e) {
	      var _this$props2 = _this.props,
	          onLoad = _this$props2.onLoad,
	          source = _this$props2.source;
	
	      var event = { nativeEvent: e };
	      _ImageUriCache2.default.add(resolveAssetSource(source));
	      _this._updateImageState(STATUS_LOADED);
	      if (onLoad) {
	        onLoad(event);
	      }
	      _this._onLoadEnd();
	    };
	
	    var uri = resolveAssetSource(props.source);
	    var shouldDisplaySource = _ImageUriCache2.default.has(uri);
	    _this.state = { shouldDisplaySource: shouldDisplaySource };
	    _this._imageState = getImageState(uri, shouldDisplaySource);
	    shouldDisplaySource && _ImageUriCache2.default.add(uri);
	    return _this;
	  }
	
	  Image.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this._imageState === STATUS_PENDING) {
	      this._createImageLoader();
	    } else if (this._imageState === STATUS_LOADED) {
	      var onLoad = this.props.onLoad;
	
	      onLoad && onLoad();
	    }
	  };
	
	  Image.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._imageState === STATUS_PENDING) {
	      this._createImageLoader();
	    }
	  };
	
	  Image.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var uri = resolveAssetSource(this.props.source);
	    var nextUri = resolveAssetSource(nextProps.source);
	    if (uri !== nextUri) {
	      _ImageUriCache2.default.remove(uri);
	      var isPreviouslyLoaded = _ImageUriCache2.default.has(nextUri);
	      isPreviouslyLoaded && _ImageUriCache2.default.add(nextUri);
	      this._updateImageState(getImageState(nextUri, isPreviouslyLoaded));
	    }
	  };
	
	  Image.prototype.componentWillUnmount = function componentWillUnmount() {
	    _ImageUriCache2.default.remove(resolveAssetSource(this.props.source));
	    this._destroyImageLoader();
	    this._isMounted = false;
	  };
	
	  Image.prototype.render = function render() {
	    var shouldDisplaySource = this.state.shouldDisplaySource;
	
	    var _props = this.props,
	        accessibilityLabel = _props.accessibilityLabel,
	        accessible = _props.accessible,
	        defaultSource = _props.defaultSource,
	        draggable = _props.draggable,
	        onLayout = _props.onLayout,
	        source = _props.source,
	        testID = _props.testID,
	        blurRadius = _props.blurRadius,
	        capInsets = _props.capInsets,
	        onError = _props.onError,
	        onLoad = _props.onLoad,
	        onLoadEnd = _props.onLoadEnd,
	        onLoadStart = _props.onLoadStart,
	        resizeMethod = _props.resizeMethod,
	        resizeMode = _props.resizeMode,
	        other = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessible', 'defaultSource', 'draggable', 'onLayout', 'source', 'testID', 'blurRadius', 'capInsets', 'onError', 'onLoad', 'onLoadEnd', 'onLoadStart', 'resizeMethod', 'resizeMode']);
	
	    var displayImage = resolveAssetSource(shouldDisplaySource ? source : defaultSource);
	    var imageSizeStyle = resolveAssetDimensions(shouldDisplaySource ? source : defaultSource);
	    var backgroundImage = displayImage ? 'url("' + displayImage + '")' : null;
	    var originalStyle = _StyleSheet2.default.flatten(this.props.style);
	    var finalResizeMode = resizeMode || originalStyle.resizeMode || _ImageResizeMode2.default.cover;
	
	    var style = _StyleSheet2.default.flatten([styles.initial, imageSizeStyle, originalStyle, resizeModeStyles[finalResizeMode], this.context.isInAParentText && styles.inline, backgroundImage && { backgroundImage: backgroundImage }]);
	    // View doesn't support these styles
	    delete style.overlayColor;
	    delete style.resizeMode;
	    delete style.tintColor;
	
	    // Allows users to trigger the browser's image context menu
	    var hiddenImage = displayImage ? (0, _createElement2.default)('img', {
	      alt: accessibilityLabel || '',
	      draggable: draggable,
	      src: displayImage,
	      style: styles.img
	    }) : null;
	
	    if (false) {
	      if (this.props.src) {
	        console.warn('The <Image> component requires a `source` property rather than `src`.');
	      }
	
	      if (this.props.children) {
	        throw new Error('The <Image> component cannot contain children. If you want to render content on top of the image, consider using the <ImageBackground> component or absolute positioning.');
	      }
	    }
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      accessibilityLabel: accessibilityLabel,
	      accessible: accessible,
	      onLayout: onLayout,
	      style: style,
	      testID: testID
	    }), hiddenImage);
	  };
	
	  Image.prototype._createImageLoader = function _createImageLoader() {
	    var _this2 = this;
	
	    var source = this.props.source;
	
	    this._destroyImageLoader();
	    this._loadRequest = (0, _requestIdleCallback2.default)(function () {
	      var uri = resolveAssetSource(source);
	      _this2._imageRequestId = _ImageLoader2.default.load(uri, _this2._onLoad, _this2._onError);
	      _this2._onLoadStart();
	    }, { timeout: getAssetTimeout(source) });
	  };
	
	  Image.prototype._destroyImageLoader = function _destroyImageLoader() {
	    if (this._loadRequest) {
	      (0, _requestIdleCallback.cancelIdleCallback)(this._loadRequest);
	      this._loadRequest = null;
	    }
	
	    if (this._imageRequestId) {
	      _ImageLoader2.default.abort(this._imageRequestId);
	      this._imageRequestId = null;
	    }
	  };
	
	  Image.prototype._onLoadEnd = function _onLoadEnd() {
	    var onLoadEnd = this.props.onLoadEnd;
	
	    if (onLoadEnd) {
	      onLoadEnd();
	    }
	  };
	
	  Image.prototype._onLoadStart = function _onLoadStart() {
	    var onLoadStart = this.props.onLoadStart;
	
	    this._updateImageState(STATUS_LOADING);
	    if (onLoadStart) {
	      onLoadStart();
	    }
	  };
	
	  Image.prototype._updateImageState = function _updateImageState(status) {
	    this._imageState = status;
	    var shouldDisplaySource = this._imageState === STATUS_LOADED || this._imageState === STATUS_LOADING;
	    // only triggers a re-render when the image is loading (to support PJEG), loaded, or failed
	    if (shouldDisplaySource !== this.state.shouldDisplaySource) {
	      if (this._isMounted) {
	        this.setState(function () {
	          return { shouldDisplaySource: shouldDisplaySource };
	        });
	      }
	    }
	  };
	
	  return Image;
	}(_react.Component);
	
	Image.displayName = 'Image';
	Image.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Image.defaultProps = {
	  style: emptyObject
	};
	Image.resizeMode = _ImageResizeMode2.default;
	Image.propTypes =  false ? _extends2({}, _ViewPropTypes2.default, {
	  defaultSource: ImageSourcePropType,
	  draggable: _propTypes.bool,
	  onError: _propTypes.func,
	  onLayout: _propTypes.func,
	  onLoad: _propTypes.func,
	  onLoadEnd: _propTypes.func,
	  onLoadStart: _propTypes.func,
	  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
	  source: ImageSourcePropType,
	  style: (0, _StyleSheetPropType2.default)(_ImageStylePropTypes2.default),
	  // compatibility with React Native
	  /* eslint-disable react/sort-prop-types */
	  blurRadius: _propTypes.number,
	  capInsets: (0, _propTypes.shape)({ top: _propTypes.number, left: _propTypes.number, bottom: _propTypes.number, right: _propTypes.number }),
	  resizeMethod: (0, _propTypes.oneOf)(['auto', 'resize', 'scale'])
	  /* eslint-enable react/sort-prop-types */
	}) : {};
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    backgroundColor: 'transparent',
	    backgroundPosition: 'center',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover',
	    zIndex: 0
	  },
	  inline: {
	    display: 'inline-flex'
	  },
	  img: _extends2({}, _StyleSheet2.default.absoluteFillObject, {
	    height: '100%',
	    opacity: 0,
	    width: '100%',
	    zIndex: -1
	  })
	});
	
	var resizeModeStyles = _StyleSheet2.default.create({
	  center: {
	    backgroundSize: 'auto',
	    backgroundPosition: 'center'
	  },
	  contain: {
	    backgroundSize: 'contain'
	  },
	  cover: {
	    backgroundSize: 'cover'
	  },
	  none: {
	    backgroundSize: 'auto'
	  },
	  repeat: {
	    backgroundSize: 'auto',
	    backgroundRepeat: 'repeat'
	  },
	  stretch: {
	    backgroundSize: '100% 100%'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(Image);

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var InteractionManager = {
	  Events: {
	    interactionStart: 'interactionStart',
	    interactionComplete: 'interactionComplete'
	  },
	
	  /**
	   * Schedule a function to run after all interactions have completed.
	   */
	  runAfterInteractions: function runAfterInteractions(task) {
	    console.warn('InteractionManager is not supported on web');
	    var promise = new Promise(function (resolve) {
	      if (task) {
	        resolve(task());
	      }
	    });
	    return {
	      then: promise.then.bind(promise),
	      done: function done() {},
	      cancel: function cancel() {}
	    };
	  },
	
	  /**
	   * Notify manager that an interaction has started.
	   */
	  createInteractionHandle: function createInteractionHandle() {
	    return 1;
	  },
	
	  /**
	   * Notify manager that an interaction has completed.
	   */
	  clearInteractionHandle: function clearInteractionHandle(handle) {
	    (0, _invariant2.default)(!!handle, 'Must provide a handle to clear.');
	  },
	
	  addListener: function addListener() {}
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = InteractionManager;

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	"use strict";
	
	// NativeModules shim
	
	var NativeModules = {};
	module.exports = NativeModules;

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var Platform = {
	  OS: 'web',
	  select: function select(obj) {
	    return 'web' in obj ? obj.web : obj.default;
	  }
	};
	
	exports.default = Platform;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _debounce = __webpack_require__(35);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var normalizeScrollEvent = function normalizeScrollEvent(e) {
	  return {
	    nativeEvent: {
	      contentOffset: {
	        get x() {
	          return e.target.scrollLeft;
	        },
	        get y() {
	          return e.target.scrollTop;
	        }
	      },
	      contentSize: {
	        get height() {
	          return e.target.scrollHeight;
	        },
	        get width() {
	          return e.target.scrollWidth;
	        }
	      },
	      layoutMeasurement: {
	        get height() {
	          return e.target.offsetHeight;
	        },
	        get width() {
	          return e.target.offsetWidth;
	        }
	      }
	    },
	    timeStamp: Date.now()
	  };
	};
	
	/**
	 * Encapsulates the Web-specific scroll throttling and disabling logic
	 */
	
	var ScrollViewBase = function (_Component) {
	  _inherits(ScrollViewBase, _Component);
	
	  function ScrollViewBase() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollViewBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._debouncedOnScrollEnd = (0, _debounce2.default)(_this._handleScrollEnd, 100), _this._state = { isScrolling: false, scrollLastTick: 0 }, _this._createPreventableScrollHandler = function (handler) {
	      return function (e) {
	        if (_this.props.scrollEnabled) {
	          if (handler) {
	            handler(e);
	          }
	        } else {
	          // To disable scrolling in all browsers except Chrome
	          e.preventDefault();
	        }
	      };
	    }, _this._handleScroll = function (e) {
	      e.persist();
	      e.stopPropagation();
	      var scrollEventThrottle = _this.props.scrollEventThrottle;
	      // A scroll happened, so the scroll bumps the debounce.
	
	      _this._debouncedOnScrollEnd(e);
	      if (_this._state.isScrolling) {
	        // Scroll last tick may have changed, check if we need to notify
	        if (_this._shouldEmitScrollEvent(_this._state.scrollLastTick, scrollEventThrottle)) {
	          _this._handleScrollTick(e);
	        }
	      } else {
	        // Weren't scrolling, so we must have just started
	        _this._handleScrollStart(e);
	      }
	    }, _this._setViewRef = function (element) {
	      _this._viewRef = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScrollViewBase.prototype.setNativeProps = function setNativeProps(props) {
	    if (this._viewRef) {
	      this._viewRef.setNativeProps(props);
	    }
	  };
	
	  ScrollViewBase.prototype.render = function render() {
	    var _props = this.props,
	        scrollEnabled = _props.scrollEnabled,
	        style = _props.style,
	        alwaysBounceHorizontal = _props.alwaysBounceHorizontal,
	        alwaysBounceVertical = _props.alwaysBounceVertical,
	        automaticallyAdjustContentInsets = _props.automaticallyAdjustContentInsets,
	        bounces = _props.bounces,
	        bouncesZoom = _props.bouncesZoom,
	        canCancelContentTouches = _props.canCancelContentTouches,
	        centerContent = _props.centerContent,
	        contentInset = _props.contentInset,
	        contentInsetAdjustmentBehavior = _props.contentInsetAdjustmentBehavior,
	        contentOffset = _props.contentOffset,
	        decelerationRate = _props.decelerationRate,
	        directionalLockEnabled = _props.directionalLockEnabled,
	        endFillColor = _props.endFillColor,
	        indicatorStyle = _props.indicatorStyle,
	        keyboardShouldPersistTaps = _props.keyboardShouldPersistTaps,
	        maximumZoomScale = _props.maximumZoomScale,
	        minimumZoomScale = _props.minimumZoomScale,
	        onMomentumScrollBegin = _props.onMomentumScrollBegin,
	        onMomentumScrollEnd = _props.onMomentumScrollEnd,
	        onScrollBeginDrag = _props.onScrollBeginDrag,
	        onScrollEndDrag = _props.onScrollEndDrag,
	        overScrollMode = _props.overScrollMode,
	        pinchGestureEnabled = _props.pinchGestureEnabled,
	        removeClippedSubviews = _props.removeClippedSubviews,
	        scrollEventThrottle = _props.scrollEventThrottle,
	        scrollIndicatorInsets = _props.scrollIndicatorInsets,
	        scrollPerfTag = _props.scrollPerfTag,
	        scrollsToTop = _props.scrollsToTop,
	        showsHorizontalScrollIndicator = _props.showsHorizontalScrollIndicator,
	        showsVerticalScrollIndicator = _props.showsVerticalScrollIndicator,
	        snapToInterval = _props.snapToInterval,
	        snapToAlignment = _props.snapToAlignment,
	        zoomScale = _props.zoomScale,
	        other = _objectWithoutProperties(_props, ['scrollEnabled', 'style', 'alwaysBounceHorizontal', 'alwaysBounceVertical', 'automaticallyAdjustContentInsets', 'bounces', 'bouncesZoom', 'canCancelContentTouches', 'centerContent', 'contentInset', 'contentInsetAdjustmentBehavior', 'contentOffset', 'decelerationRate', 'directionalLockEnabled', 'endFillColor', 'indicatorStyle', 'keyboardShouldPersistTaps', 'maximumZoomScale', 'minimumZoomScale', 'onMomentumScrollBegin', 'onMomentumScrollEnd', 'onScrollBeginDrag', 'onScrollEndDrag', 'overScrollMode', 'pinchGestureEnabled', 'removeClippedSubviews', 'scrollEventThrottle', 'scrollIndicatorInsets', 'scrollPerfTag', 'scrollsToTop', 'showsHorizontalScrollIndicator', 'showsVerticalScrollIndicator', 'snapToInterval', 'snapToAlignment', 'zoomScale']);
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      onScroll: this._handleScroll,
	      onTouchMove: this._createPreventableScrollHandler(this.props.onTouchMove),
	      onWheel: this._createPreventableScrollHandler(this.props.onWheel),
	      ref: this._setViewRef,
	      style: [style, !scrollEnabled && styles.scrollDisabled]
	    }));
	  };
	
	  ScrollViewBase.prototype._handleScrollStart = function _handleScrollStart(e) {
	    this._state.isScrolling = true;
	    this._state.scrollLastTick = Date.now();
	  };
	
	  ScrollViewBase.prototype._handleScrollTick = function _handleScrollTick(e) {
	    var onScroll = this.props.onScroll;
	
	    this._state.scrollLastTick = Date.now();
	    if (onScroll) {
	      onScroll(normalizeScrollEvent(e));
	    }
	  };
	
	  ScrollViewBase.prototype._handleScrollEnd = function _handleScrollEnd(e) {
	    var onScroll = this.props.onScroll;
	
	    this._state.isScrolling = false;
	    if (onScroll) {
	      onScroll(normalizeScrollEvent(e));
	    }
	  };
	
	  ScrollViewBase.prototype._shouldEmitScrollEvent = function _shouldEmitScrollEvent(lastTick, eventThrottle) {
	    var timeSinceLastTick = Date.now() - lastTick;
	    return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
	  };
	
	  return ScrollViewBase;
	}(_react.Component);
	
	// Chrome doesn't support e.preventDefault in this case; touch-action must be
	// used to disable scrolling.
	// https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	
	ScrollViewBase.defaultProps = {
	  scrollEnabled: true,
	  scrollEventThrottle: 0
	};
	exports.default = ScrollViewBase;
	ScrollViewBase.propTypes =  false ? _extends2({}, _ViewPropTypes2.default, {
	  onMomentumScrollBegin: _propTypes.func,
	  onMomentumScrollEnd: _propTypes.func,
	  onScroll: _propTypes.func,
	  onScrollBeginDrag: _propTypes.func,
	  onScrollEndDrag: _propTypes.func,
	  onTouchMove: _propTypes.func,
	  onWheel: _propTypes.func,
	  removeClippedSubviews: _propTypes.bool,
	  scrollEnabled: _propTypes.bool,
	  scrollEventThrottle: _propTypes.number,
	  showsHorizontalScrollIndicator: _propTypes.bool,
	  showsVerticalScrollIndicator: _propTypes.bool
	}) : {};
	var styles = _StyleSheet2.default.create({
	  scrollDisabled: {
	    touchAction: 'none'
	  }
	});

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _dismissKeyboard = __webpack_require__(127);
	
	var _dismissKeyboard2 = _interopRequireDefault(_dismissKeyboard);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ScrollResponder = __webpack_require__(126);
	
	var _ScrollResponder2 = _interopRequireDefault(_ScrollResponder);
	
	var _ScrollViewBase = __webpack_require__(105);
	
	var _ScrollViewBase2 = _interopRequireDefault(_ScrollViewBase);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	var emptyObject = {};
	
	/* eslint-disable react/prefer-es6-class, react/prop-types */
	var ScrollView = (0, _createReactClass2.default)({
	  displayName: 'ScrollView',
	
	  propTypes: _extends2({}, _ViewPropTypes2.default, {
	    contentContainerStyle: _ViewPropTypes2.default.style,
	    horizontal: _propTypes.bool,
	    keyboardDismissMode: (0, _propTypes.oneOf)(['none', 'interactive', 'on-drag']),
	    onContentSizeChange: _propTypes.func,
	    onScroll: _propTypes.func,
	    pagingEnabled: _propTypes.bool,
	    refreshControl: _propTypes.element,
	    scrollEnabled: _propTypes.bool,
	    scrollEventThrottle: _propTypes.number,
	    style: _ViewPropTypes2.default.style
	  }),
	
	  mixins: [_ScrollResponder2.default.Mixin],
	
	  getInitialState: function getInitialState() {
	    return this.scrollResponderMixinGetInitialState();
	  },
	  setNativeProps: function setNativeProps(props) {
	    if (this._scrollViewRef) {
	      this._scrollViewRef.setNativeProps(props);
	    }
	  },
	
	  /**
	   * Returns a reference to the underlying scroll responder, which supports
	   * operations like `scrollTo`. All ScrollView-like components should
	   * implement this method so that they can be composed while providing access
	   * to the underlying scroll responder's methods.
	   */
	  getScrollResponder: function getScrollResponder() {
	    return this;
	  },
	  getScrollableNode: function getScrollableNode() {
	    return (0, _findNodeHandle2.default)(this._scrollViewRef);
	  },
	  getInnerViewNode: function getInnerViewNode() {
	    return (0, _findNodeHandle2.default)(this._innerViewRef);
	  },
	
	  /**
	   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
	   * Syntax:
	   *
	   * scrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
	   *
	   * Note: The weird argument signature is due to the fact that, for historical reasons,
	   * the function also accepts separate arguments as as alternative to the options object.
	   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
	   */
	  scrollTo: function scrollTo(y, x, animated) {
	    if (typeof y === 'number') {
	      console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');
	    } else {
	      var _ref = y || emptyObject;
	
	      x = _ref.x;
	      y = _ref.y;
	      animated = _ref.animated;
	    }
	
	    this.getScrollResponder().scrollResponderScrollTo({
	      x: x || 0,
	      y: y || 0,
	      animated: animated !== false
	    });
	  },
	
	  /**
	   * If this is a vertical ScrollView scrolls to the bottom.
	   * If this is a horizontal ScrollView scrolls to the right.
	   *
	   * Use `scrollToEnd({ animated: true })` for smooth animated scrolling,
	   * `scrollToEnd({ animated: false })` for immediate scrolling.
	   * If no options are passed, `animated` defaults to true.
	   */
	  scrollToEnd: function scrollToEnd(options) {
	    // Default to true
	    var animated = (options && options.animated) !== false;
	    var horizontal = this.props.horizontal;
	
	    var scrollResponder = this.getScrollResponder();
	    var scrollResponderNode = scrollResponder.scrollResponderGetScrollableNode();
	    var x = horizontal ? scrollResponderNode.scrollWidth : 0;
	    var y = horizontal ? 0 : scrollResponderNode.scrollHeight;
	    scrollResponder.scrollResponderScrollTo({ x: x, y: y, animated: animated });
	  },
	
	  /**
	   * Deprecated, do not use.
	   */
	  scrollWithoutAnimationTo: function scrollWithoutAnimationTo() {
	    var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    console.warn('`scrollWithoutAnimationTo` is deprecated. Use `scrollTo` instead');
	    this.scrollTo({ x: x, y: y, animated: false });
	  },
	  render: function render() {
	    var _props = this.props,
	        contentContainerStyle = _props.contentContainerStyle,
	        horizontal = _props.horizontal,
	        onContentSizeChange = _props.onContentSizeChange,
	        refreshControl = _props.refreshControl,
	        keyboardDismissMode = _props.keyboardDismissMode,
	        onScroll = _props.onScroll,
	        pagingEnabled = _props.pagingEnabled,
	        stickyHeaderIndices = _props.stickyHeaderIndices,
	        other = _objectWithoutProperties(_props, ['contentContainerStyle', 'horizontal', 'onContentSizeChange', 'refreshControl', 'keyboardDismissMode', 'onScroll', 'pagingEnabled', 'stickyHeaderIndices']);
	
	    if (false) {
	      var style = _StyleSheet2.default.flatten(this.props.style);
	      var childLayoutProps = ['alignItems', 'justifyContent'].filter(function (prop) {
	        return style && style[prop] !== undefined;
	      });
	      (0, _invariant2.default)(childLayoutProps.length === 0, 'ScrollView child layout (' + JSON.stringify(childLayoutProps) + ') ' + 'must be applied through the contentContainerStyle prop.');
	    }
	
	    var contentSizeChangeProps = {};
	    if (onContentSizeChange) {
	      contentSizeChangeProps = {
	        onLayout: this._handleContentOnLayout
	      };
	    }
	
	    var contentContainer = _react2.default.createElement(_View2.default, _extends({}, contentSizeChangeProps, {
	      children: this.props.children,
	      collapsable: false,
	      ref: this._setInnerViewRef,
	      style: [horizontal && styles.contentContainerHorizontal, contentContainerStyle]
	    }));
	
	    var props = _extends2({}, other, {
	      style: [styles.base, horizontal && styles.baseHorizontal, this.props.style],
	      onTouchStart: this.scrollResponderHandleTouchStart,
	      onTouchMove: this.scrollResponderHandleTouchMove,
	      onTouchEnd: this.scrollResponderHandleTouchEnd,
	      onScrollBeginDrag: this.scrollResponderHandleScrollBeginDrag,
	      onScrollEndDrag: this.scrollResponderHandleScrollEndDrag,
	      onMomentumScrollBegin: this.scrollResponderHandleMomentumScrollBegin,
	      onMomentumScrollEnd: this.scrollResponderHandleMomentumScrollEnd,
	      onStartShouldSetResponder: this.scrollResponderHandleStartShouldSetResponder,
	      onStartShouldSetResponderCapture: this.scrollResponderHandleStartShouldSetResponderCapture,
	      onScrollShouldSetResponder: this.scrollResponderHandleScrollShouldSetResponder,
	      onScroll: this._handleScroll,
	      onResponderGrant: this.scrollResponderHandleResponderGrant,
	      onResponderTerminationRequest: this.scrollResponderHandleTerminationRequest,
	      onResponderTerminate: this.scrollResponderHandleTerminate,
	      onResponderRelease: this.scrollResponderHandleResponderRelease,
	      onResponderReject: this.scrollResponderHandleResponderReject
	    });
	
	    var ScrollViewClass = _ScrollViewBase2.default;
	
	    (0, _invariant2.default)(ScrollViewClass !== undefined, 'ScrollViewClass must not be undefined');
	
	    if (refreshControl) {
	      return _react2.default.cloneElement(refreshControl, { style: props.style }, _react2.default.createElement(ScrollViewClass, _extends({}, props, { ref: this._setScrollViewRef, style: styles.base }), contentContainer));
	    }
	
	    return _react2.default.createElement(ScrollViewClass, _extends({}, props, { ref: this._setScrollViewRef, style: props.style }), contentContainer);
	  },
	  _handleContentOnLayout: function _handleContentOnLayout(e) {
	    var _e$nativeEvent$layout = e.nativeEvent.layout,
	        width = _e$nativeEvent$layout.width,
	        height = _e$nativeEvent$layout.height;
	
	    this.props.onContentSizeChange(width, height);
	  },
	  _handleScroll: function _handleScroll(e) {
	    if (false) {
	      if (this.props.onScroll && !this.props.scrollEventThrottle) {
	        console.log('You specified `onScroll` on a <ScrollView> but not ' + '`scrollEventThrottle`. You will only receive one event. ' + 'Using `16` you get all the events but be aware that it may ' + "cause frame drops, use a bigger number if you don't need as " + 'much precision.');
	      }
	    }
	
	    if (this.props.keyboardDismissMode === 'on-drag') {
	      (0, _dismissKeyboard2.default)();
	    }
	
	    this.scrollResponderHandleScroll(e);
	  },
	  _setInnerViewRef: function _setInnerViewRef(component) {
	    this._innerViewRef = component;
	  },
	  _setScrollViewRef: function _setScrollViewRef(component) {
	    this._scrollViewRef = component;
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  base: {
	    flex: 1,
	    overflowX: 'hidden',
	    overflowY: 'auto',
	    WebkitOverflowScrolling: 'touch',
	    // Enable hardware compositing in modern browsers.
	    // Creates a new layer with its own backing surface that can significantly
	    // improve scroll performance.
	    transform: [{ translateZ: 0 }]
	  },
	  baseHorizontal: {
	    flexDirection: 'row',
	    overflowX: 'auto',
	    overflowY: 'hidden'
	  },
	  contentContainerHorizontal: {
	    flexDirection: 'row'
	  }
	});
	
	exports.default = ScrollView;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetPropType = __webpack_require__(30);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _TextStylePropTypes = __webpack_require__(115);
	
	var _TextStylePropTypes2 = _interopRequireDefault(_TextStylePropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var TextPropTypes = {
	  accessibilityComponentType: _propTypes.string,
	  accessibilityLabel: _propTypes.string,
	  accessibilityLiveRegion: (0, _propTypes.oneOf)(['assertive', 'none', 'polite']),
	  accessibilityRole: (0, _propTypes.oneOf)(['button', 'heading', 'label', 'link', 'listitem']),
	  accessibilityTraits: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
	  accessible: _propTypes.bool,
	  children: _propTypes.any,
	  importantForAccessibility: (0, _propTypes.oneOf)(['auto', 'no', 'no-hide-descendants', 'yes']),
	  numberOfLines: _propTypes.number,
	  onBlur: _propTypes.func,
	  onContextMenu: _propTypes.func,
	  onFocus: _propTypes.func,
	  onLayout: _propTypes.func,
	  onPress: _propTypes.func,
	  selectable: _propTypes.bool,
	  style: (0, _StyleSheetPropType2.default)(_TextStylePropTypes2.default),
	  testID: _propTypes.string
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = TextPropTypes;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ViewStylePropTypes = __webpack_require__(26);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]); /**
	                                                                                         * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                         * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                         *
	                                                                                         * This source code is licensed under the MIT license found in the
	                                                                                         * LICENSE file in the root directory of this source tree.
	                                                                                         *
	                                                                                         * 
	                                                                                         */
	
	var TextStylePropTypes = _extends({}, _ViewStylePropTypes2.default, {
	  color: _ColorPropType2.default,
	  fontFamily: _propTypes.string,
	  fontFeatureSettings: _propTypes.string,
	  fontSize: numberOrString,
	  fontStyle: _propTypes.string,
	  fontWeight: _propTypes.string,
	  fontVariant: _propTypes.array,
	  letterSpacing: numberOrString,
	  lineHeight: numberOrString,
	  textAlign: (0, _propTypes.oneOf)(['center', 'end', 'inherit', 'justify', 'justify-all', 'left', 'right', 'start']),
	  textAlignVertical: _propTypes.string,
	  textDecorationColor: _ColorPropType2.default,
	  textDecorationLine: _propTypes.string,
	  textDecorationStyle: _propTypes.string,
	  textShadowColor: _ColorPropType2.default,
	  textShadowOffset: (0, _propTypes.shape)({ width: _propTypes.number, height: _propTypes.number }),
	  textShadowRadius: _propTypes.number,
	  writingDirection: (0, _propTypes.oneOf)(['auto', 'ltr', 'rtl']),
	  /* @platform web */
	  textIndent: numberOrString,
	  textOverflow: _propTypes.string,
	  textRendering: (0, _propTypes.oneOf)(['auto', 'geometricPrecision', 'optimizeLegibility', 'optimizeSpeed']),
	  textTransform: (0, _propTypes.oneOf)(['capitalize', 'lowercase', 'none', 'uppercase']),
	  unicodeBidi: (0, _propTypes.oneOf)(['normal', 'bidi-override', 'embed', 'isolate', 'isolate-override', 'plaintext']),
	  whiteSpace: _propTypes.string,
	  wordWrap: _propTypes.string,
	  MozOsxFontSmoothing: _propTypes.string,
	  WebkitFontSmoothing: _propTypes.string
	});
	
	exports.default = TextStylePropTypes;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applyLayout = __webpack_require__(64);
	
	var _applyLayout2 = _interopRequireDefault(_applyLayout);
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _propTypes = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _createElement = __webpack_require__(27);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TextPropTypes = __webpack_require__(114);
	
	var _TextPropTypes2 = _interopRequireDefault(_TextPropTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2015-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var Text = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    _classCallCheck(this, Text);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Text.prototype.getChildContext = function getChildContext() {
	    return { isInAParentText: true };
	  };
	
	  Text.prototype.render = function render() {
	    var _props = this.props,
	        dir = _props.dir,
	        numberOfLines = _props.numberOfLines,
	        onPress = _props.onPress,
	        selectable = _props.selectable,
	        style = _props.style,
	        adjustsFontSizeToFit = _props.adjustsFontSizeToFit,
	        allowFontScaling = _props.allowFontScaling,
	        ellipsizeMode = _props.ellipsizeMode,
	        lineBreakMode = _props.lineBreakMode,
	        minimumFontScale = _props.minimumFontScale,
	        onLayout = _props.onLayout,
	        onLongPress = _props.onLongPress,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        selectionColor = _props.selectionColor,
	        suppressHighlighting = _props.suppressHighlighting,
	        textBreakStrategy = _props.textBreakStrategy,
	        tvParallaxProperties = _props.tvParallaxProperties,
	        otherProps = _objectWithoutProperties(_props, ['dir', 'numberOfLines', 'onPress', 'selectable', 'style', 'adjustsFontSizeToFit', 'allowFontScaling', 'ellipsizeMode', 'lineBreakMode', 'minimumFontScale', 'onLayout', 'onLongPress', 'pressRetentionOffset', 'selectionColor', 'suppressHighlighting', 'textBreakStrategy', 'tvParallaxProperties']);
	
	    var isInAParentText = this.context.isInAParentText;
	
	    if (onPress) {
	      otherProps.accessible = true;
	      otherProps.onClick = this._createPressHandler(onPress);
	      otherProps.onKeyDown = this._createEnterHandler(onPress);
	    }
	
	    // allow browsers to automatically infer the language writing direction
	    otherProps.dir = dir !== undefined ? dir : 'auto';
	    otherProps.style = [styles.initial, this.context.isInAParentText === true && styles.isInAParentText, style, selectable === false && styles.notSelectable, numberOfLines === 1 && styles.singleLineStyle, onPress && styles.pressable];
	
	    var component = isInAParentText ? 'span' : 'div';
	
	    return (0, _createElement2.default)(component, otherProps);
	  };
	
	  Text.prototype._createEnterHandler = function _createEnterHandler(fn) {
	    return function (e) {
	      if (e.keyCode === 13) {
	        fn && fn(e);
	      }
	    };
	  };
	
	  Text.prototype._createPressHandler = function _createPressHandler(fn) {
	    return function (e) {
	      e.stopPropagation();
	      fn && fn(e);
	    };
	  };
	
	  return Text;
	}(_react.Component);
	
	Text.displayName = 'Text';
	Text.childContextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Text.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Text.propTypes =  false ? _TextPropTypes2.default : {};
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    borderWidth: 0,
	    boxSizing: 'border-box',
	    color: 'inherit',
	    display: 'inline',
	    fontFamily: 'System',
	    fontSize: 14,
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit',
	    margin: 0,
	    padding: 0,
	    textDecorationLine: 'none',
	    whiteSpace: 'pre-wrap',
	    wordWrap: 'break-word'
	  },
	  isInAParentText: {
	    // inherit parent font styles
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    whiteSpace: 'inherit'
	  },
	  notSelectable: {
	    userSelect: 'none'
	  },
	  pressable: {
	    cursor: 'pointer'
	  },
	  singleLineStyle: {
	    maxWidth: '100%',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap'
	  }
	});
	
	exports.default = (0, _applyLayout2.default)((0, _applyNativeMethods2.default)(Text));

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PooledClass = __webpack_require__(71);
	
	var _PooledClass2 = _interopRequireDefault(_PooledClass);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var twoArgumentPooler = _PooledClass2.default.twoArgumentPooler;
	
	/**
	 * PooledClass representing the bounding rectangle of a region.
	 */
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function BoundingDimensions(width, height) {
	  this.width = width;
	  this.height = height;
	}
	
	BoundingDimensions.prototype.destructor = function () {
	  this.width = null;
	  this.height = null;
	};
	
	BoundingDimensions.getPooledFromElement = function (element) {
	  return BoundingDimensions.getPooled(element.offsetWidth, element.offsetHeight);
	};
	
	_PooledClass2.default.addPoolingTo(BoundingDimensions, twoArgumentPooler);
	
	exports.default = BoundingDimensions;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PooledClass = __webpack_require__(71);
	
	var _PooledClass2 = _interopRequireDefault(_PooledClass);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var twoArgumentPooler = _PooledClass2.default.twoArgumentPooler; /**
	                                                                  * Copyright (c) 2015-present, Facebook, Inc.
	                                                                  *
	                                                                  * This source code is licensed under the MIT license found in the
	                                                                  * LICENSE file in the root directory of this source tree.
	                                                                  *
	                                                                  * @noflow
	                                                                  */
	
	function Position(left, top) {
	  this.left = left;
	  this.top = top;
	}
	
	Position.prototype.destructor = function () {
	  this.left = null;
	  this.top = null;
	};
	
	_PooledClass2.default.addPoolingTo(Position, twoArgumentPooler);
	
	exports.default = Position;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var ensurePositiveDelayProps = function ensurePositiveDelayProps(props) {
	    (0, _invariant2.default)(!(props.delayPressIn < 0 || props.delayPressOut < 0 || props.delayLongPress < 0), 'Touchable components cannot have negative delay properties');
	}; /**
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = ensurePositiveDelayProps;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AccessibilityUtil = __webpack_require__(28);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _BoundingDimensions = __webpack_require__(116);
	
	var _BoundingDimensions2 = _interopRequireDefault(_BoundingDimensions);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _normalizeCssColor = __webpack_require__(19);
	
	var _normalizeCssColor2 = _interopRequireDefault(_normalizeCssColor);
	
	var _Position = __webpack_require__(117);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TouchEventUtils = __webpack_require__(221);
	
	var _TouchEventUtils2 = _interopRequireDefault(_TouchEventUtils);
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * `Touchable`: Taps done right.
	 *
	 * You hook your `ResponderEventPlugin` events into `Touchable`. `Touchable`
	 * will measure time/geometry and tells you when to give feedback to the user.
	 *
	 * ====================== Touchable Tutorial ===============================
	 * The `Touchable` mixin helps you handle the "press" interaction. It analyzes
	 * the geometry of elements, and observes when another responder (scroll view
	 * etc) has stolen the touch lock. It notifies your component when it should
	 * give feedback to the user. (bouncing/highlighting/unhighlighting).
	 *
	 * - When a touch was activated (typically you highlight)
	 * - When a touch was deactivated (typically you unhighlight)
	 * - When a touch was "pressed" - a touch ended while still within the geometry
	 *   of the element, and no other element (like scroller) has "stolen" touch
	 *   lock ("responder") (Typically you bounce the element).
	 *
	 * A good tap interaction isn't as simple as you might think. There should be a
	 * slight delay before showing a highlight when starting a touch. If a
	 * subsequent touch move exceeds the boundary of the element, it should
	 * unhighlight, but if that same touch is brought back within the boundary, it
	 * should rehighlight again. A touch can move in and out of that boundary
	 * several times, each time toggling highlighting, but a "press" is only
	 * triggered if that touch ends while within the element's boundary and no
	 * scroller (or anything else) has stolen the lock on touches.
	 *
	 * To create a new type of component that handles interaction using the
	 * `Touchable` mixin, do the following:
	 *
	 * - Initialize the `Touchable` state.
	 *
	 *   getInitialState: function() {
	 *     return merge(this.touchableGetInitialState(), yourComponentState);
	 *   }
	 *
	 * - Choose the rendered component who's touches should start the interactive
	 *   sequence. On that rendered node, forward all `Touchable` responder
	 *   handlers. You can choose any rendered node you like. Choose a node whose
	 *   hit target you'd like to instigate the interaction sequence:
	 *
	 *   // In render function:
	 *   return (
	 *     <View
	 *       onStartShouldSetResponder={this.touchableHandleStartShouldSetResponder}
	 *       onResponderTerminationRequest={this.touchableHandleResponderTerminationRequest}
	 *       onResponderGrant={this.touchableHandleResponderGrant}
	 *       onResponderMove={this.touchableHandleResponderMove}
	 *       onResponderRelease={this.touchableHandleResponderRelease}
	 *       onResponderTerminate={this.touchableHandleResponderTerminate}>
	 *       <View>
	 *         Even though the hit detection/interactions are triggered by the
	 *         wrapping (typically larger) node, we usually end up implementing
	 *         custom logic that highlights this inner one.
	 *       </View>
	 *     </View>
	 *   );
	 *
	 * - You may set up your own handlers for each of these events, so long as you
	 *   also invoke the `touchable*` handlers inside of your custom handler.
	 *
	 * - Implement the handlers on your component class in order to provide
	 *   feedback to the user. See documentation for each of these class methods
	 *   that you should implement.
	 *
	 *   touchableHandlePress: function() {
	 *      this.performBounceAnimation();  // or whatever you want to do.
	 *   },
	 *   touchableHandleActivePressIn: function() {
	 *     this.beginHighlighting(...);  // Whatever you like to convey activation
	 *   },
	 *   touchableHandleActivePressOut: function() {
	 *     this.endHighlighting(...);  // Whatever you like to convey deactivation
	 *   },
	 *
	 * - There are more advanced methods you can implement (see documentation below):
	 *   touchableGetHighlightDelayMS: function() {
	 *     return 20;
	 *   }
	 *   // In practice, *always* use a predeclared constant (conserve memory).
	 *   touchableGetPressRectOffset: function() {
	 *     return {top: 20, left: 20, right: 20, bottom: 100};
	 *   }
	 */
	
	/**
	 * Touchable states.
	 */
	var States = {
	  NOT_RESPONDER: 'NOT_RESPONDER', // Not the responder
	  RESPONDER_INACTIVE_PRESS_IN: 'RESPONDER_INACTIVE_PRESS_IN', // Responder, inactive, in the `PressRect`
	  RESPONDER_INACTIVE_PRESS_OUT: 'RESPONDER_INACTIVE_PRESS_OUT', // Responder, inactive, out of `PressRect`
	  RESPONDER_ACTIVE_PRESS_IN: 'RESPONDER_ACTIVE_PRESS_IN', // Responder, active, in the `PressRect`
	  RESPONDER_ACTIVE_PRESS_OUT: 'RESPONDER_ACTIVE_PRESS_OUT', // Responder, active, out of `PressRect`
	  RESPONDER_ACTIVE_LONG_PRESS_IN: 'RESPONDER_ACTIVE_LONG_PRESS_IN', // Responder, active, in the `PressRect`, after long press threshold
	  RESPONDER_ACTIVE_LONG_PRESS_OUT: 'RESPONDER_ACTIVE_LONG_PRESS_OUT', // Responder, active, out of `PressRect`, after long press threshold
	  ERROR: 'ERROR'
	};
	
	/**
	 * Quick lookup map for states that are considered to be "active"
	 */
	/* eslint-disable react/prop-types */
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var IsActive = {
	  RESPONDER_ACTIVE_PRESS_OUT: true,
	  RESPONDER_ACTIVE_PRESS_IN: true
	};
	
	/**
	 * Quick lookup for states that are considered to be "pressing" and are
	 * therefore eligible to result in a "selection" if the press stops.
	 */
	var IsPressingIn = {
	  RESPONDER_INACTIVE_PRESS_IN: true,
	  RESPONDER_ACTIVE_PRESS_IN: true,
	  RESPONDER_ACTIVE_LONG_PRESS_IN: true
	};
	
	var IsLongPressingIn = {
	  RESPONDER_ACTIVE_LONG_PRESS_IN: true
	};
	
	/**
	 * Inputs to the state machine.
	 */
	var Signals = {
	  DELAY: 'DELAY',
	  RESPONDER_GRANT: 'RESPONDER_GRANT',
	  RESPONDER_RELEASE: 'RESPONDER_RELEASE',
	  RESPONDER_TERMINATED: 'RESPONDER_TERMINATED',
	  ENTER_PRESS_RECT: 'ENTER_PRESS_RECT',
	  LEAVE_PRESS_RECT: 'LEAVE_PRESS_RECT',
	  LONG_PRESS_DETECTED: 'LONG_PRESS_DETECTED'
	};
	
	/**
	 * Mapping from States x Signals => States
	 */
	var Transitions = {
	  NOT_RESPONDER: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
	    RESPONDER_RELEASE: States.ERROR,
	    RESPONDER_TERMINATED: States.ERROR,
	    ENTER_PRESS_RECT: States.ERROR,
	    LEAVE_PRESS_RECT: States.ERROR,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_INACTIVE_PRESS_IN: {
	    DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_INACTIVE_PRESS_OUT: {
	    DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_ACTIVE_PRESS_IN: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
	  },
	  RESPONDER_ACTIVE_PRESS_OUT: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_ACTIVE_LONG_PRESS_IN: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
	  },
	  RESPONDER_ACTIVE_LONG_PRESS_OUT: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  error: {
	    DELAY: States.NOT_RESPONDER,
	    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.NOT_RESPONDER,
	    LEAVE_PRESS_RECT: States.NOT_RESPONDER,
	    LONG_PRESS_DETECTED: States.NOT_RESPONDER
	  }
	};
	
	// ==== Typical Constants for integrating into UI components ====
	// var HIT_EXPAND_PX = 20;
	// var HIT_VERT_OFFSET_PX = 10;
	var HIGHLIGHT_DELAY_MS = 130;
	
	var PRESS_EXPAND_PX = 20;
	
	var LONG_PRESS_THRESHOLD = 500;
	
	var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
	
	var LONG_PRESS_ALLOWED_MOVEMENT = 10;
	
	// Default amount "active" region protrudes beyond box
	
	/**
	 * By convention, methods prefixed with underscores are meant to be @private,
	 * and not @protected. Mixers shouldn't access them - not even to provide them
	 * as callback handlers.
	 *
	 *
	 * ========== Geometry =========
	 * `Touchable` only assumes that there exists a `HitRect` node. The `PressRect`
	 * is an abstract box that is extended beyond the `HitRect`.
	 *
	 *  +--------------------------+
	 *  |                          | - "Start" events in `HitRect` cause `HitRect`
	 *  |  +--------------------+  |   to become the responder.
	 *  |  |  +--------------+  |  | - `HitRect` is typically expanded around
	 *  |  |  |              |  |  |   the `VisualRect`, but shifted downward.
	 *  |  |  |  VisualRect  |  |  | - After pressing down, after some delay,
	 *  |  |  |              |  |  |   and before letting up, the Visual React
	 *  |  |  +--------------+  |  |   will become "active". This makes it eligible
	 *  |  |     HitRect        |  |   for being highlighted (so long as the
	 *  |  +--------------------+  |   press remains in the `PressRect`).
	 *  |        PressRect     o   |
	 *  +----------------------|---+
	 *           Out Region    |
	 *                         +-----+ This gap between the `HitRect` and
	 *                                 `PressRect` allows a touch to move far away
	 *                                 from the original hit rect, and remain
	 *                                 highlighted, and eligible for a "Press".
	 *                                 Customize this via
	 *                                 `touchableGetPressRectOffset()`.
	 *
	 *
	 *
	 * ======= State Machine =======
	 *
	 * +-------------+ <---+ RESPONDER_RELEASE
	 * |NOT_RESPONDER|
	 * +-------------+ <---+ RESPONDER_TERMINATED
	 *     +
	 *     | RESPONDER_GRANT (HitRect)
	 *     v
	 * +---------------------------+  DELAY   +-------------------------+  T + DELAY     +------------------------------+
	 * |RESPONDER_INACTIVE_PRESS_IN|+-------->|RESPONDER_ACTIVE_PRESS_IN| +------------> |RESPONDER_ACTIVE_LONG_PRESS_IN|
	 * +---------------------------+          +-------------------------+                +------------------------------+
	 *     +            ^                         +           ^                                 +           ^
	 *     |LEAVE_      |ENTER_                   |LEAVE_     |ENTER_                           |LEAVE_     |ENTER_
	 *     |PRESS_RECT  |PRESS_RECT               |PRESS_RECT |PRESS_RECT                       |PRESS_RECT |PRESS_RECT
	 *     |            |                         |           |                                 |           |
	 *     v            +                         v           +                                 v           +
	 * +----------------------------+  DELAY  +--------------------------+               +-------------------------------+
	 * |RESPONDER_INACTIVE_PRESS_OUT|+------->|RESPONDER_ACTIVE_PRESS_OUT|               |RESPONDER_ACTIVE_LONG_PRESS_OUT|
	 * +----------------------------+         +--------------------------+               +-------------------------------+
	 *
	 * T + DELAY => LONG_PRESS_DELAY_MS + DELAY
	 *
	 * Not drawn are the side effects of each transition. The most important side
	 * effect is the `touchableHandlePress` abstract method invocation that occurs
	 * when a responder is released while in either of the "Press" states.
	 *
	 * The other important side effects are the highlight abstract method
	 * invocations (internal callbacks) to be implemented by the mixer.
	 *
	 *
	 * @lends Touchable.prototype
	 */
	var TouchableMixin = {
	  // HACK (part 1): basic support for touchable interactions using a keyboard
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this._touchableNode = (0, _findNodeHandle2.default)(this);
	    if (this._touchableNode && this._touchableNode.addEventListener) {
	      this._touchableBlurListener = function (e) {
	        if (_this._isTouchableKeyboardActive) {
	          if (_this.state.touchable.touchState && _this.state.touchable.touchState !== States.NOT_RESPONDER) {
	            _this.touchableHandleResponderTerminate({ nativeEvent: e });
	          }
	          _this._isTouchableKeyboardActive = false;
	        }
	      };
	      this._touchableNode.addEventListener('blur', this._touchableBlurListener);
	    }
	  },
	
	  /**
	   * Clear all timeouts on unmount
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._touchableNode && this._touchableNode.addEventListener) {
	      this._touchableNode.removeEventListener('blur', this._touchableBlurListener);
	    }
	    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
	    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
	    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
	  },
	
	  /**
	   * It's prefer that mixins determine state in this way, having the class
	   * explicitly mix the state in the one and only `getInitialState` method.
	   *
	   * @return {object} State object to be placed inside of
	   * `this.state.touchable`.
	   */
	  touchableGetInitialState: function touchableGetInitialState() {
	    return {
	      touchable: { touchState: undefined, responderID: null }
	    };
	  },
	
	  // ==== Hooks to Gesture Responder system ====
	  /**
	   * Must return true if embedded in a native platform scroll view.
	   */
	  touchableHandleResponderTerminationRequest: function touchableHandleResponderTerminationRequest() {
	    return !this.props.rejectResponderTermination;
	  },
	
	  /**
	   * Must return true to start the process of `Touchable`.
	   */
	  touchableHandleStartShouldSetResponder: function touchableHandleStartShouldSetResponder() {
	    return !this.props.disabled;
	  },
	
	  /**
	   * Return true to cancel press on long press.
	   */
	  touchableLongPressCancelsPress: function touchableLongPressCancelsPress() {
	    return true;
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderGrant` event.
	   */
	  touchableHandleResponderGrant: function touchableHandleResponderGrant(e) {
	    var dispatchID = e.currentTarget;
	    // Since e is used in a callback invoked on another event loop
	    // (as in setTimeout etc), we need to call e.persist() on the
	    // event to make sure it doesn't get reused in the event object pool.
	    e.persist();
	    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
	    this.pressOutDelayTimeout = null;
	
	    this.state.touchable.touchState = States.NOT_RESPONDER;
	    this.state.touchable.responderID = dispatchID;
	    this._receiveSignal(Signals.RESPONDER_GRANT, e);
	    var delayMS = this.touchableGetHighlightDelayMS !== undefined ? Math.max(this.touchableGetHighlightDelayMS(), 0) : HIGHLIGHT_DELAY_MS;
	    delayMS = isNaN(delayMS) ? HIGHLIGHT_DELAY_MS : delayMS;
	    if (delayMS !== 0) {
	      this.touchableDelayTimeout = setTimeout(this._handleDelay.bind(this, e), delayMS);
	    } else {
	      this.state.touchable.positionOnActivate = null;
	      this._handleDelay(e);
	    }
	
	    var longDelayMS = this.touchableGetLongPressDelayMS !== undefined ? Math.max(this.touchableGetLongPressDelayMS(), 10) : LONG_PRESS_DELAY_MS;
	    longDelayMS = isNaN(longDelayMS) ? LONG_PRESS_DELAY_MS : longDelayMS;
	    this.longPressDelayTimeout = setTimeout(this._handleLongDelay.bind(this, e), longDelayMS + delayMS);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderRelease` event.
	   */
	  touchableHandleResponderRelease: function touchableHandleResponderRelease(e) {
	    this._receiveSignal(Signals.RESPONDER_RELEASE, e);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderTerminate` event.
	   */
	  touchableHandleResponderTerminate: function touchableHandleResponderTerminate(e) {
	    this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderMove` event.
	   */
	  touchableHandleResponderMove: function touchableHandleResponderMove(e) {
	    // Not enough time elapsed yet, wait for highlight -
	    // this is just a perf optimization.
	    if (this.state.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
	      return;
	    }
	
	    // Measurement may not have returned yet.
	    if (!this.state.touchable.positionOnActivate) {
	      return;
	    }
	
	    var positionOnActivate = this.state.touchable.positionOnActivate;
	    var dimensionsOnActivate = this.state.touchable.dimensionsOnActivate;
	    var pressRectOffset = this.touchableGetPressRectOffset ? this.touchableGetPressRectOffset() : {
	      left: PRESS_EXPAND_PX,
	      right: PRESS_EXPAND_PX,
	      top: PRESS_EXPAND_PX,
	      bottom: PRESS_EXPAND_PX
	    };
	
	    var pressExpandLeft = pressRectOffset.left;
	    var pressExpandTop = pressRectOffset.top;
	    var pressExpandRight = pressRectOffset.right;
	    var pressExpandBottom = pressRectOffset.bottom;
	
	    var hitSlop = this.touchableGetHitSlop ? this.touchableGetHitSlop() : null;
	
	    if (hitSlop) {
	      pressExpandLeft += hitSlop.left;
	      pressExpandTop += hitSlop.top;
	      pressExpandRight += hitSlop.right;
	      pressExpandBottom += hitSlop.bottom;
	    }
	
	    var touch = _TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);
	    var pageX = touch && touch.pageX;
	    var pageY = touch && touch.pageY;
	
	    if (this.pressInLocation) {
	      var movedDistance = this._getDistanceBetweenPoints(pageX, pageY, this.pressInLocation.pageX, this.pressInLocation.pageY);
	      if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
	        this._cancelLongPressDelayTimeout();
	      }
	    }
	
	    var isTouchWithinActive = pageX > positionOnActivate.left - pressExpandLeft && pageY > positionOnActivate.top - pressExpandTop && pageX < positionOnActivate.left + dimensionsOnActivate.width + pressExpandRight && pageY < positionOnActivate.top + dimensionsOnActivate.height + pressExpandBottom;
	    if (isTouchWithinActive) {
	      this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
	      var curState = this.state.touchable.touchState;
	      if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
	        // fix for t7967420
	        this._cancelLongPressDelayTimeout();
	      }
	    } else {
	      this._cancelLongPressDelayTimeout();
	      this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
	    }
	  },
	
	  // ==== Abstract Application Callbacks ====
	
	  /**
	   * Invoked when the item should be highlighted. Mixers should implement this
	   * to visually distinguish the `VisualRect` so that the user knows that
	   * releasing a touch will result in a "selection" (analog to click).
	   *
	   * @abstract
	   * touchableHandleActivePressIn: function,
	   */
	
	  /**
	   * Invoked when the item is "active" (in that it is still eligible to become
	   * a "select") but the touch has left the `PressRect`. Usually the mixer will
	   * want to unhighlight the `VisualRect`. If the user (while pressing) moves
	   * back into the `PressRect` `touchableHandleActivePressIn` will be invoked
	   * again and the mixer should probably highlight the `VisualRect` again. This
	   * event will not fire on an `touchEnd/mouseUp` event, only move events while
	   * the user is depressing the mouse/touch.
	   *
	   * @abstract
	   * touchableHandleActivePressOut: function
	   */
	
	  /**
	   * Invoked when the item is "selected" - meaning the interaction ended by
	   * letting up while the item was either in the state
	   * `RESPONDER_ACTIVE_PRESS_IN` or `RESPONDER_INACTIVE_PRESS_IN`.
	   *
	   * @abstract
	   * touchableHandlePress: function
	   */
	
	  /**
	   * Invoked when the item is long pressed - meaning the interaction ended by
	   * letting up while the item was in `RESPONDER_ACTIVE_LONG_PRESS_IN`. If
	   * `touchableHandleLongPress` is *not* provided, `touchableHandlePress` will
	   * be called as it normally is. If `touchableHandleLongPress` is provided, by
	   * default any `touchableHandlePress` callback will not be invoked. To
	   * override this default behavior, override `touchableLongPressCancelsPress`
	   * to return false. As a result, `touchableHandlePress` will be called when
	   * lifting up, even if `touchableHandleLongPress` has also been called.
	   *
	   * @abstract
	   * touchableHandleLongPress: function
	   */
	
	  /**
	   * Returns the number of millis to wait before triggering a highlight.
	   *
	   * @abstract
	   * touchableGetHighlightDelayMS: function
	   */
	
	  /**
	   * Returns the amount to extend the `HitRect` into the `PressRect`. Positive
	   * numbers mean the size expands outwards.
	   *
	   * @abstract
	   * touchableGetPressRectOffset: function
	   */
	
	  // ==== Internal Logic ====
	
	  /**
	   * Measures the `HitRect` node on activation. The Bounding rectangle is with
	   * respect to viewport - not page, so adding the `pageXOffset/pageYOffset`
	   * should result in points that are in the same coordinate system as an
	   * event's `globalX/globalY` data values.
	   *
	   * - Consider caching this for the lifetime of the component, or possibly
	   *   being able to share this cache between any `ScrollMap` view.
	   *
	   * @sideeffects
	   * @private
	   */
	  _remeasureMetricsOnActivation: function _remeasureMetricsOnActivation() {
	    var tag = this.state.touchable.responderID;
	    if (tag == null) {
	      return;
	    }
	
	    _UIManager2.default.measure(tag, this._handleQueryLayout);
	  },
	
	  _handleQueryLayout: function _handleQueryLayout(x, y, width, height, globalX, globalY) {
	    // don't do anything if UIManager failed to measure node
	    if (!x && !y && !width && !height && !globalX && !globalY) {
	      return;
	    }
	    this.state.touchable.positionOnActivate && _Position2.default.release(this.state.touchable.positionOnActivate);
	    this.state.touchable.dimensionsOnActivate &&
	    // $FlowFixMe
	    _BoundingDimensions2.default.release(this.state.touchable.dimensionsOnActivate);
	    this.state.touchable.positionOnActivate = _Position2.default.getPooled(globalX, globalY);
	    // $FlowFixMe
	    this.state.touchable.dimensionsOnActivate = _BoundingDimensions2.default.getPooled(width, height);
	  },
	
	  _handleDelay: function _handleDelay(e) {
	    this.touchableDelayTimeout = null;
	    this._receiveSignal(Signals.DELAY, e);
	  },
	
	  _handleLongDelay: function _handleLongDelay(e) {
	    this.longPressDelayTimeout = null;
	    var curState = this.state.touchable.touchState;
	    if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
	      console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
	    } else {
	      this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
	    }
	  },
	
	  /**
	   * Receives a state machine signal, performs side effects of the transition
	   * and stores the new state. Validates the transition as well.
	   *
	   * @param {Signals} signal State machine signal.
	   * @throws Error if invalid state transition or unrecognized signal.
	   * @sideeffects
	   */
	  _receiveSignal: function _receiveSignal(signal, e) {
	    var responderID = this.state.touchable.responderID;
	    var curState = this.state.touchable.touchState;
	    var nextState = Transitions[curState] && Transitions[curState][signal];
	    if (!responderID && signal === Signals.RESPONDER_RELEASE) {
	      return;
	    }
	    if (!nextState) {
	      throw new Error('Unrecognized signal `' + signal + '` or state `' + curState + '` for Touchable responder `' + responderID + '`');
	    }
	    if (nextState === States.ERROR) {
	      throw new Error('Touchable cannot transition from `' + curState + '` to `' + signal + '` for responder `' + responderID + '`');
	    }
	    if (curState !== nextState) {
	      this._performSideEffectsForTransition(curState, nextState, signal, e);
	      this.state.touchable.touchState = nextState;
	    }
	  },
	
	  _cancelLongPressDelayTimeout: function _cancelLongPressDelayTimeout() {
	    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
	    this.longPressDelayTimeout = null;
	  },
	
	  _isHighlight: function _isHighlight(state) {
	    return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
	  },
	
	  _savePressInLocation: function _savePressInLocation(e) {
	    var touch = _TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);
	    var pageX = touch && touch.pageX;
	    var pageY = touch && touch.pageY;
	    var locationX = touch && touch.locationX;
	    var locationY = touch && touch.locationY;
	    this.pressInLocation = { pageX: pageX, pageY: pageY, locationX: locationX, locationY: locationY };
	  },
	
	  _getDistanceBetweenPoints: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
	    var deltaX = aX - bX;
	    var deltaY = aY - bY;
	    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
	  },
	
	  /**
	   * Will perform a transition between touchable states, and identify any
	   * highlighting or unhighlighting that must be performed for this particular
	   * transition.
	   *
	   * @param {States} curState Current Touchable state.
	   * @param {States} nextState Next Touchable state.
	   * @param {Signal} signal Signal that triggered the transition.
	   * @param {Event} e Native event.
	   * @sideeffects
	   */
	  _performSideEffectsForTransition: function _performSideEffectsForTransition(curState, nextState, signal, e) {
	    var curIsHighlight = this._isHighlight(curState);
	    var newIsHighlight = this._isHighlight(nextState);
	
	    var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;
	
	    if (isFinalSignal) {
	      this._cancelLongPressDelayTimeout();
	    }
	
	    if (!IsActive[curState] && IsActive[nextState]) {
	      this._remeasureMetricsOnActivation();
	    }
	
	    if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
	      this.touchableHandleLongPress && this.touchableHandleLongPress(e);
	    }
	
	    if (newIsHighlight && !curIsHighlight) {
	      this._startHighlight(e);
	    } else if (!newIsHighlight && curIsHighlight) {
	      this._endHighlight(e);
	    }
	
	    if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
	      var hasLongPressHandler = !!this.props.onLongPress;
	      var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && ( // We *are* long pressing..
	      !hasLongPressHandler || // But either has no long handler
	      !this.touchableLongPressCancelsPress()); // or we're told to ignore it.
	
	      var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
	      if (shouldInvokePress && this.touchableHandlePress) {
	        if (!newIsHighlight && !curIsHighlight) {
	          // we never highlighted because of delay, but we should highlight now
	          this._startHighlight(e);
	          this._endHighlight(e);
	        }
	        this.touchableHandlePress(e);
	      }
	    }
	
	    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
	    this.touchableDelayTimeout = null;
	  },
	
	  _startHighlight: function _startHighlight(e) {
	    this._savePressInLocation(e);
	    this.touchableHandleActivePressIn && this.touchableHandleActivePressIn(e);
	  },
	
	  _endHighlight: function _endHighlight(e) {
	    var _this2 = this;
	
	    if (this.touchableHandleActivePressOut) {
	      if (this.touchableGetPressOutDelayMS && this.touchableGetPressOutDelayMS()) {
	        this.pressOutDelayTimeout = setTimeout(function () {
	          _this2.touchableHandleActivePressOut(e);
	        }, this.touchableGetPressOutDelayMS());
	      } else {
	        this.touchableHandleActivePressOut(e);
	      }
	    }
	  },
	
	  // HACK (part 2): basic support for touchable interactions using a keyboard (including
	  // delays and longPress)
	  touchableHandleKeyEvent: function touchableHandleKeyEvent(e) {
	    var ENTER = 13;
	    var SPACE = 32;
	    var type = e.type,
	        which = e.which;
	
	    if (which === ENTER || which === SPACE) {
	      if (type === 'keydown') {
	        if (!this._isTouchableKeyboardActive) {
	          if (!this.state.touchable.touchState || this.state.touchable.touchState === States.NOT_RESPONDER) {
	            this.touchableHandleResponderGrant(e);
	            this._isTouchableKeyboardActive = true;
	          }
	        }
	      } else if (type === 'keyup') {
	        if (this._isTouchableKeyboardActive) {
	          if (this.state.touchable.touchState && this.state.touchable.touchState !== States.NOT_RESPONDER) {
	            this.touchableHandleResponderRelease(e);
	            this._isTouchableKeyboardActive = false;
	          }
	        }
	      }
	      e.stopPropagation();
	      // prevent the default behaviour unless the Touchable functions as a link
	      // and Enter is pressed
	      if (!(which === ENTER && _AccessibilityUtil2.default.propsToAriaRole(this.props) === 'link')) {
	        e.preventDefault();
	      }
	    }
	  }
	};
	
	var Touchable = {
	  Mixin: TouchableMixin,
	  TOUCH_TARGET_DEBUG: false, // Highlights all touchable targets. Toggle with Inspector.
	  /**
	   * Renders a debugging overlay to visualize touch target with hitSlop (might not work on Android).
	   */
	  renderDebugView: function renderDebugView(_ref) {
	    var color = _ref.color,
	        hitSlop = _ref.hitSlop;
	
	    if (false) {
	      if (!Touchable.TOUCH_TARGET_DEBUG) {
	        return null;
	      }
	      var debugHitSlopStyle = {};
	      hitSlop = hitSlop || { top: 0, bottom: 0, left: 0, right: 0 };
	      for (var key in hitSlop) {
	        debugHitSlopStyle[key] = -hitSlop[key];
	      }
	      var hexColor = '#' + ('00000000' + (0, _normalizeCssColor2.default)(color).toString(16)).substr(-8);
	      return _react2.default.createElement(_View2.default, {
	        pointerEvents: 'none',
	        style: _extends({
	          position: 'absolute',
	          borderColor: hexColor.slice(0, -2) + '55', // More opaque
	          borderWidth: 1,
	          borderStyle: 'dashed',
	          backgroundColor: hexColor.slice(0, -2) + '0F' }, debugHitSlopStyle)
	      });
	    }
	  }
	};
	
	exports.default = Touchable;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ensurePositiveDelayProps = __webpack_require__(52);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _propTypes = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _Touchable = __webpack_require__(53);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _TouchableWithoutFeedback = __webpack_require__(118);
	
	var _TouchableWithoutFeedback2 = _interopRequireDefault(_TouchableWithoutFeedback);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	var flattenStyle = _StyleSheet2.default.flatten;
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * A wrapper for making views respond properly to touches.
	 * On press down, the opacity of the wrapped view is decreased, dimming it.
	 *
	 * Opacity is controlled by wrapping the children in a View, which is
	 * added to the view hiearchy. Be aware that this can affect layout.
	 *
	 * Example:
	 *
	 * ```
	 * renderButton: function() {
	 *   return (
	 *     <TouchableOpacity onPress={this._onPressButton}>
	 *       <Image
	 *         style={styles.button}
	 *         source={require('./myButton.png')}
	 *       />
	 *     </TouchableOpacity>
	 *   );
	 * },
	 * ```
	 */
	
	/* eslint-disable react/prefer-es6-class */
	var TouchableOpacity = (0, _createReactClass2.default)({
	  displayName: 'TouchableOpacity',
	  mixins: [_Touchable2.default.Mixin],
	
	  propTypes: _extends2({}, _TouchableWithoutFeedback2.default.propTypes, {
	    /**
	     * Determines what the opacity of the wrapped view should be when touch is
	     * active.
	     */
	    activeOpacity: _propTypes.number,
	    focusedOpacity: _propTypes.number
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activeOpacity: 0.2,
	      focusedOpacity: 0.7
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return this.touchableGetInitialState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	  },
	
	  /**
	   * Animate the touchable to a new opacity.
	   */
	  setOpacityTo: function setOpacityTo(value, duration) {
	    this.setNativeProps({
	      style: {
	        opacity: value,
	        transitionDuration: duration ? duration / 1000 + 's' : '0s'
	      }
	    });
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    if (e.dispatchConfig.registrationName === 'onResponderGrant') {
	      this._opacityActive(0);
	    } else {
	      this._opacityActive(150);
	    }
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    this._opacityInactive(250);
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn || 0;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut;
	  },
	
	  _opacityActive: function _opacityActive(duration) {
	    this.setOpacityTo(this.props.activeOpacity, duration);
	  },
	
	  _opacityInactive: function _opacityInactive(duration) {
	    this.setOpacityTo(this._getChildStyleOpacityWithDefault(), duration);
	  },
	
	  _opacityFocused: function _opacityFocused() {
	    this.setOpacityTo(this.props.focusedOpacity);
	  },
	
	  _getChildStyleOpacityWithDefault: function _getChildStyleOpacityWithDefault() {
	    var childStyle = flattenStyle(this.props.style) || {};
	    return childStyle.opacity === undefined ? 1 : childStyle.opacity;
	  },
	
	  render: function render() {
	    var _props = this.props,
	        activeOpacity = _props.activeOpacity,
	        focusedOpacity = _props.focusedOpacity,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['activeOpacity', 'focusedOpacity', 'delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      accessible: this.props.accessible !== false,
	      onKeyDown: this.touchableHandleKeyEvent,
	      onKeyUp: this.touchableHandleKeyEvent,
	      onResponderGrant: this.touchableHandleResponderGrant,
	      onResponderMove: this.touchableHandleResponderMove,
	      onResponderRelease: this.touchableHandleResponderRelease,
	      onResponderTerminate: this.touchableHandleResponderTerminate,
	      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	      style: [styles.root, !this.props.disabled && styles.actionable, this.props.style]
	    }), this.props.children, _Touchable2.default.renderDebugView({ color: 'blue', hitSlop: this.props.hitSlop }));
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    transitionProperty: 'opacity',
	    transitionDuration: '0.15s',
	    userSelect: 'none'
	  },
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(TouchableOpacity);

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _EdgeInsetsPropType = __webpack_require__(43);
	
	var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);
	
	var _ensurePositiveDelayProps = __webpack_require__(52);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _reactTimerMixin = __webpack_require__(179);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _Touchable = __webpack_require__(53);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * Do not use unless you have a very good reason. All elements that
	 * respond to press should have a visual feedback when touched.
	 *
	 * TouchableWithoutFeedback supports only one child.
	 * If you wish to have several child components, wrap them in a View.
	 */
	
	/* eslint-disable react/prefer-es6-class, react/prop-types */
	var TouchableWithoutFeedback = (0, _createReactClass2.default)({
	  displayName: 'TouchableWithoutFeedback',
	  mixins: [_reactTimerMixin2.default, _Touchable2.default.Mixin],
	
	  propTypes: {
	    accessibilityComponentType: _ViewPropTypes2.default.accessibilityComponentType,
	    accessibilityLabel: _propTypes.string,
	    accessibilityRole: _ViewPropTypes2.default.accessibilityRole,
	    accessibilityTraits: _ViewPropTypes2.default.accessibilityTraits,
	    accessible: _propTypes.bool,
	    children: _propTypes.any,
	    /**
	     * Delay in ms, from onPressIn, before onLongPress is called.
	     */
	    delayLongPress: _propTypes.number,
	    /**
	     * Delay in ms, from the start of the touch, before onPressIn is called.
	     */
	    delayPressIn: _propTypes.number,
	    /**
	     * Delay in ms, from the release of the touch, before onPressOut is called.
	     */
	    delayPressOut: _propTypes.number,
	    /**
	     * If true, disable all interactions for this component.
	     */
	    disabled: _propTypes.bool,
	    /**
	     * This defines how far your touch can start away from the button. This is
	     * added to `pressRetentionOffset` when moving off of the button.
	     */
	    // $FlowFixMe(>=0.41.0)
	    hitSlop: _EdgeInsetsPropType2.default,
	    /**
	     * Invoked on mount and layout changes with
	     *
	     *   `{nativeEvent: {layout: {x, y, width, height}}}`
	     */
	    onLayout: _propTypes.func,
	    onLongPress: _propTypes.func,
	    /**
	     * Called when the touch is released, but not if cancelled (e.g. by a scroll
	     * that steals the responder lock).
	     */
	    onPress: _propTypes.func,
	    onPressIn: _propTypes.func,
	    onPressOut: _propTypes.func,
	    /**
	     * When the scroll view is disabled, this defines how far your touch may
	     * move off of the button, before deactivating the button. Once deactivated,
	     * try moving it back and you'll see that the button is once again
	     * reactivated! Move it back and forth several times while the scroll view
	     * is disabled. Ensure you pass in a constant to reduce memory allocations.
	     */
	    // $FlowFixMe
	    pressRetentionOffset: _EdgeInsetsPropType2.default,
	    testID: _propTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return this.touchableGetInitialState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn || 0;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut || 0;
	  },
	
	  render: function render() {
	    var _props = this.props,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    // Note(avik): remove dynamic typecast once Flow has been upgraded
	    // $FlowFixMe
	
	
	    var child = _react2.default.Children.only(this.props.children);
	    var children = child.props.children;
	    (0, _warning2.default)(!child.type || child.type.displayName !== 'Text', 'TouchableWithoutFeedback does not work well with Text children. Wrap children in a View instead. See ' + (child._owner && child._owner.getName && child._owner.getName() || '<unknown>'));
	    if (false) {
	      children = _react2.default.Children.toArray(children);
	      children.push(_Touchable2.default.renderDebugView({ color: 'red', hitSlop: this.props.hitSlop }));
	    }
	    var style = _Touchable2.default.TOUCH_TARGET_DEBUG && child.type && child.type.displayName === 'Text' ? [!this.props.disabled && styles.actionable, child.props.style, { color: 'red' }] : [!this.props.disabled && styles.actionable, child.props.style];
	    return _react2.default.cloneElement(child, _extends({}, other, {
	      accessible: this.props.accessible !== false,
	      children: children,
	      onKeyDown: this.touchableHandleKeyEvent,
	      onKeyUp: this.touchableHandleKeyEvent,
	      onResponderGrant: this.touchableHandleResponderGrant,
	      onResponderMove: this.touchableHandleResponderMove,
	      onResponderRelease: this.touchableHandleResponderRelease,
	      onResponderTerminate: this.touchableHandleResponderTerminate,
	      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	      style: style
	    }));
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = TouchableWithoutFeedback;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ViewPropTypes = __webpack_require__(54);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _ViewPropTypes2.default;

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.registerAsset = registerAsset;
	exports.getAssetByID = getAssetByID;
	
	var assets = []; /**
	                  * Copyright (c) 2015-present, Facebook, Inc.
	                  *
	                  * This source code is licensed under the MIT license found in the
	                  * LICENSE file in the root directory of this source tree.
	                  *
	                  * 
	                  */
	
	function registerAsset(asset) {
	  // `push` returns new array length, so the first asset will
	  // get id 1 (not 0) to make the value truthy
	  return assets.push(asset);
	}
	
	function getAssetByID(assetId) {
	  return assets[assetId - 1];
	}

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var id = 0;
	var requests = {};
	
	var ImageLoader = {
	  abort: function abort(requestId) {
	    var image = requests['' + requestId];
	    if (image) {
	      image.onerror = image.onload = image = null;
	      delete requests['' + requestId];
	    }
	  },
	  getSize: function getSize(uri, success, failure) {
	    var complete = false;
	    var interval = setInterval(callback, 16);
	    var requestId = ImageLoader.load(uri, callback, errorCallback);
	
	    function callback() {
	      var image = requests['' + requestId];
	      if (image) {
	        var naturalHeight = image.naturalHeight,
	            naturalWidth = image.naturalWidth;
	
	        if (naturalHeight && naturalWidth) {
	          success(naturalWidth, naturalHeight);
	          complete = true;
	        }
	      }
	      if (complete) {
	        ImageLoader.abort(requestId);
	        clearInterval(interval);
	      }
	    }
	
	    function errorCallback() {
	      if (typeof failure === 'function') {
	        failure();
	      }
	      ImageLoader.abort(requestId);
	      clearInterval(interval);
	    }
	  },
	  load: function load(uri, onLoad, onError) {
	    id += 1;
	    var image = new window.Image();
	    image.onerror = onError;
	    image.onload = onLoad;
	    image.src = uri;
	    requests['' + id] = image;
	    return id;
	  },
	  prefetch: function prefetch(uri) {
	    return new Promise(function (resolve, reject) {
	      ImageLoader.load(uri, resolve, reject);
	    });
	  }
	};
	
	exports.default = ImageLoader;

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var NativeEventEmitter = function () {
	  function NativeEventEmitter() {
	    _classCallCheck(this, NativeEventEmitter);
	  }
	
	  NativeEventEmitter.prototype.addListener = function addListener() {};
	
	  NativeEventEmitter.prototype.emit = function emit() {};
	
	  NativeEventEmitter.prototype.listeners = function listeners() {};
	
	  NativeEventEmitter.prototype.once = function once() {};
	
	  NativeEventEmitter.prototype.removeAllListeners = function removeAllListeners() {};
	
	  NativeEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {};
	
	  NativeEventEmitter.prototype.removeListener = function removeListener() {};
	
	  NativeEventEmitter.prototype.removeSubscription = function removeSubscription() {};
	
	  return NativeEventEmitter;
	}();
	
	module.exports = NativeEventEmitter;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dimensions = __webpack_require__(99);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Platform = __webpack_require__(104);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _TextInputState = __webpack_require__(62);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Mixin that can be integrated in order to handle scrolling that plays well
	 * with `ResponderEventPlugin`. Integrate with your platform specific scroll
	 * views, or even your custom built (every-frame animating) scroll views so that
	 * all of these systems play well with the `ResponderEventPlugin`.
	 *
	 * iOS scroll event timing nuances:
	 * ===============================
	 *
	 *
	 * Scrolling without bouncing, if you touch down:
	 * -------------------------------
	 *
	 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
	 *    ... physical touch starts ...
	 * 2. `onTouchStartCapture`   (when you press down to stop the scroll)
	 * 3. `onTouchStart`          (same, but bubble phase)
	 * 4. `onResponderRelease`    (when lifting up - you could pause forever before * lifting)
	 * 5. `onMomentumScrollEnd`
	 *
	 *
	 * Scrolling with bouncing, if you touch down:
	 * -------------------------------
	 *
	 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
	 *    ... bounce begins ...
	 *    ... some time elapses ...
	 *    ... physical touch during bounce ...
	 * 2. `onMomentumScrollEnd`   (Makes no sense why this occurs first during bounce)
	 * 3. `onTouchStartCapture`   (immediately after `onMomentumScrollEnd`)
	 * 4. `onTouchStart`          (same, but bubble phase)
	 * 5. `onTouchEnd`            (You could hold the touch start for a long time)
	 * 6. `onMomentumScrollBegin` (When releasing the view starts bouncing back)
	 *
	 * So when we receive an `onTouchStart`, how can we tell if we are touching
	 * *during* an animation (which then causes the animation to stop)? The only way
	 * to tell is if the `touchStart` occurred immediately after the
	 * `onMomentumScrollEnd`.
	 *
	 * This is abstracted out for you, so you can just call this.scrollResponderIsAnimating() if
	 * necessary
	 *
	 * `ScrollResponder` also includes logic for blurring a currently focused input
	 * if one is focused while scrolling. The `ScrollResponder` is a natural place
	 * to put this logic since it can support not dismissing the keyboard while
	 * scrolling, unless a recognized "tap"-like gesture has occurred.
	 *
	 * The public lifecycle API includes events for keyboard interaction, responder
	 * interaction, and scrolling (among others). The keyboard callbacks
	 * `onKeyboardWill/Did/*` are *global* events, but are invoked on scroll
	 * responder's props so that you can guarantee that the scroll responder's
	 * internal state has been updated accordingly (and deterministically) by
	 * the time the props callbacks are invoke. Otherwise, you would always wonder
	 * if the scroll responder is currently in a state where it recognizes new
	 * keyboard positions etc. If coordinating scrolling with keyboard movement,
	 * *always* use these hooks instead of listening to your own global keyboard
	 * events.
	 *
	 * Public keyboard lifecycle API: (props callbacks)
	 *
	 * Standard Keyboard Appearance Sequence:
	 *
	 *   this.props.onKeyboardWillShow
	 *   this.props.onKeyboardDidShow
	 *
	 * `onScrollResponderKeyboardDismissed` will be invoked if an appropriate
	 * tap inside the scroll responder's scrollable region was responsible
	 * for the dismissal of the keyboard. There are other reasons why the
	 * keyboard could be dismissed.
	 *
	 *   this.props.onScrollResponderKeyboardDismissed
	 *
	 * Standard Keyboard Hide Sequence:
	 *
	 *   this.props.onKeyboardWillHide
	 *   this.props.onKeyboardDidHide
	 */
	
	var emptyObject = {}; /**
	                       * Copyright (c) 2016-present, Nicolas Gallagher.
	                       * Copyright (c) 2015-present, Facebook, Inc.
	                       *
	                       * This source code is licensed under the MIT license found in the
	                       * LICENSE file in the root directory of this source tree.
	                       *
	                       * 
	                       */
	
	var IS_ANIMATING_TOUCH_START_THRESHOLD_MS = 16;
	
	var ScrollResponderMixin = {
	  // mixins: [Subscribable.Mixin],
	  scrollResponderMixinGetInitialState: function scrollResponderMixinGetInitialState() {
	    return {
	      isTouching: false,
	      lastMomentumScrollBeginTime: 0,
	      lastMomentumScrollEndTime: 0,
	
	      // Reset to false every time becomes responder. This is used to:
	      // - Determine if the scroll view has been scrolled and therefore should
	      // refuse to give up its responder lock.
	      // - Determine if releasing should dismiss the keyboard when we are in
	      // tap-to-dismiss mode (!this.props.keyboardShouldPersistTaps).
	      observedScrollSinceBecomingResponder: false,
	      becameResponderWhileAnimating: false
	    };
	  },
	
	  /**
	   * Invoke this from an `onScroll` event.
	   */
	  scrollResponderHandleScrollShouldSetResponder: function scrollResponderHandleScrollShouldSetResponder() {
	    return this.state.isTouching;
	  },
	
	  /**
	   * Merely touch starting is not sufficient for a scroll view to become the
	   * responder. Being the "responder" means that the very next touch move/end
	   * event will result in an action/movement.
	   *
	   * Invoke this from an `onStartShouldSetResponder` event.
	   *
	   * `onStartShouldSetResponder` is used when the next move/end will trigger
	   * some UI movement/action, but when you want to yield priority to views
	   * nested inside of the view.
	   *
	   * There may be some cases where scroll views actually should return `true`
	   * from `onStartShouldSetResponder`: Any time we are detecting a standard tap
	   * that gives priority to nested views.
	   *
	   * - If a single tap on the scroll view triggers an action such as
	   *   recentering a map style view yet wants to give priority to interaction
	   *   views inside (such as dropped pins or labels), then we would return true
	   *   from this method when there is a single touch.
	   *
	   * - Similar to the previous case, if a two finger "tap" should trigger a
	   *   zoom, we would check the `touches` count, and if `>= 2`, we would return
	   *   true.
	   *
	   */
	  scrollResponderHandleStartShouldSetResponder: function scrollResponderHandleStartShouldSetResponder() {
	    return false;
	  },
	
	  /**
	   * There are times when the scroll view wants to become the responder
	   * (meaning respond to the next immediate `touchStart/touchEnd`), in a way
	   * that *doesn't* give priority to nested views (hence the capture phase):
	   *
	   * - Currently animating.
	   * - Tapping anywhere that is not the focused input, while the keyboard is
	   *   up (which should dismiss the keyboard).
	   *
	   * Invoke this from an `onStartShouldSetResponderCapture` event.
	   */
	  scrollResponderHandleStartShouldSetResponderCapture: function scrollResponderHandleStartShouldSetResponderCapture(e) {
	    // First see if we want to eat taps while the keyboard is up
	    // var currentlyFocusedTextInput = TextInputState.currentlyFocusedField();
	    // if (!this.props.keyboardShouldPersistTaps &&
	    //   currentlyFocusedTextInput != null &&
	    //   e.target !== currentlyFocusedTextInput) {
	    //   return true;
	    // }
	    return this.scrollResponderIsAnimating();
	  },
	
	  /**
	   * Invoke this from an `onResponderReject` event.
	   *
	   * Some other element is not yielding its role as responder. Normally, we'd
	   * just disable the `UIScrollView`, but a touch has already began on it, the
	   * `UIScrollView` will not accept being disabled after that. The easiest
	   * solution for now is to accept the limitation of disallowing this
	   * altogether. To improve this, find a way to disable the `UIScrollView` after
	   * a touch has already started.
	   */
	  scrollResponderHandleResponderReject: function scrollResponderHandleResponderReject() {
	    (0, _warning2.default)(false, "ScrollView doesn't take rejection well - scrolls anyway");
	  },
	
	  /**
	   * We will allow the scroll view to give up its lock iff it acquired the lock
	   * during an animation. This is a very useful default that happens to satisfy
	   * many common user experiences.
	   *
	   * - Stop a scroll on the left edge, then turn that into an outer view's
	   *   backswipe.
	   * - Stop a scroll mid-bounce at the top, continue pulling to have the outer
	   *   view dismiss.
	   * - However, without catching the scroll view mid-bounce (while it is
	   *   motionless), if you drag far enough for the scroll view to become
	   *   responder (and therefore drag the scroll view a bit), any backswipe
	   *   navigation of a swipe gesture higher in the view hierarchy, should be
	   *   rejected.
	   */
	  scrollResponderHandleTerminationRequest: function scrollResponderHandleTerminationRequest() {
	    return !this.state.observedScrollSinceBecomingResponder;
	  },
	
	  /**
	   * Invoke this from an `onTouchEnd` event.
	   *
	   * @param {SyntheticEvent} e Event.
	   */
	  scrollResponderHandleTouchEnd: function scrollResponderHandleTouchEnd(e) {
	    var nativeEvent = e.nativeEvent;
	    this.state.isTouching = nativeEvent.touches.length !== 0;
	    this.props.onTouchEnd && this.props.onTouchEnd(e);
	  },
	
	  /**
	   * Invoke this from an `onResponderRelease` event.
	   */
	  scrollResponderHandleResponderRelease: function scrollResponderHandleResponderRelease(e) {
	    this.props.onResponderRelease && this.props.onResponderRelease(e);
	
	    // By default scroll views will unfocus a textField
	    // if another touch occurs outside of it
	    var currentlyFocusedTextInput = _TextInputState2.default.currentlyFocusedField();
	    if (!this.props.keyboardShouldPersistTaps && currentlyFocusedTextInput != null && e.target !== currentlyFocusedTextInput && !this.state.observedScrollSinceBecomingResponder && !this.state.becameResponderWhileAnimating) {
	      this.props.onScrollResponderKeyboardDismissed && this.props.onScrollResponderKeyboardDismissed(e);
	      _TextInputState2.default.blurTextInput(currentlyFocusedTextInput);
	    }
	  },
	
	  scrollResponderHandleScroll: function scrollResponderHandleScroll(e) {
	    this.state.observedScrollSinceBecomingResponder = true;
	    this.props.onScroll && this.props.onScroll(e);
	  },
	
	  /**
	   * Invoke this from an `onResponderGrant` event.
	   */
	  scrollResponderHandleResponderGrant: function scrollResponderHandleResponderGrant(e) {
	    this.state.observedScrollSinceBecomingResponder = false;
	    this.props.onResponderGrant && this.props.onResponderGrant(e);
	    this.state.becameResponderWhileAnimating = this.scrollResponderIsAnimating();
	  },
	
	  /**
	   * Unfortunately, `onScrollBeginDrag` also fires when *stopping* the scroll
	   * animation, and there's not an easy way to distinguish a drag vs. stopping
	   * momentum.
	   *
	   * Invoke this from an `onScrollBeginDrag` event.
	   */
	  scrollResponderHandleScrollBeginDrag: function scrollResponderHandleScrollBeginDrag(e) {
	    this.props.onScrollBeginDrag && this.props.onScrollBeginDrag(e);
	  },
	
	  /**
	   * Invoke this from an `onScrollEndDrag` event.
	   */
	  scrollResponderHandleScrollEndDrag: function scrollResponderHandleScrollEndDrag(e) {
	    this.props.onScrollEndDrag && this.props.onScrollEndDrag(e);
	  },
	
	  /**
	   * Invoke this from an `onMomentumScrollBegin` event.
	   */
	  scrollResponderHandleMomentumScrollBegin: function scrollResponderHandleMomentumScrollBegin(e) {
	    this.state.lastMomentumScrollBeginTime = Date.now();
	    this.props.onMomentumScrollBegin && this.props.onMomentumScrollBegin(e);
	  },
	
	  /**
	   * Invoke this from an `onMomentumScrollEnd` event.
	   */
	  scrollResponderHandleMomentumScrollEnd: function scrollResponderHandleMomentumScrollEnd(e) {
	    this.state.lastMomentumScrollEndTime = Date.now();
	    this.props.onMomentumScrollEnd && this.props.onMomentumScrollEnd(e);
	  },
	
	  /**
	   * Invoke this from an `onTouchStart` event.
	   *
	   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
	   * order, after `ResponderEventPlugin`, we can detect that we were *not*
	   * permitted to be the responder (presumably because a contained view became
	   * responder). The `onResponderReject` won't fire in that case - it only
	   * fires when a *current* responder rejects our request.
	   *
	   * @param {SyntheticEvent} e Touch Start event.
	   */
	  scrollResponderHandleTouchStart: function scrollResponderHandleTouchStart(e) {
	    this.state.isTouching = true;
	    this.props.onTouchStart && this.props.onTouchStart(e);
	  },
	
	  /**
	   * Invoke this from an `onTouchMove` event.
	   *
	   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
	   * order, after `ResponderEventPlugin`, we can detect that we were *not*
	   * permitted to be the responder (presumably because a contained view became
	   * responder). The `onResponderReject` won't fire in that case - it only
	   * fires when a *current* responder rejects our request.
	   *
	   * @param {SyntheticEvent} e Touch Start event.
	   */
	  scrollResponderHandleTouchMove: function scrollResponderHandleTouchMove(e) {
	    this.props.onTouchMove && this.props.onTouchMove(e);
	  },
	
	  /**
	   * A helper function for this class that lets us quickly determine if the
	   * view is currently animating. This is particularly useful to know when
	   * a touch has just started or ended.
	   */
	  scrollResponderIsAnimating: function scrollResponderIsAnimating() {
	    var now = Date.now();
	    var timeSinceLastMomentumScrollEnd = now - this.state.lastMomentumScrollEndTime;
	    var isAnimating = timeSinceLastMomentumScrollEnd < IS_ANIMATING_TOUCH_START_THRESHOLD_MS || this.state.lastMomentumScrollEndTime < this.state.lastMomentumScrollBeginTime;
	    return isAnimating;
	  },
	
	  /**
	   * Returns the node that represents native view that can be scrolled.
	   * Components can pass what node to use by defining a `getScrollableNode`
	   * function otherwise `this` is used.
	   */
	  scrollResponderGetScrollableNode: function scrollResponderGetScrollableNode() {
	    return this.getScrollableNode ? this.getScrollableNode() : (0, _findNodeHandle2.default)(this);
	  },
	
	  /**
	   * A helper function to scroll to a specific point in the scrollview.
	   * This is currently used to help focus on child textviews, but can also
	   * be used to quickly scroll to any element we want to focus. Syntax:
	   *
	   * scrollResponderScrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
	   *
	   * Note: The weird argument signature is due to the fact that, for historical reasons,
	   * the function also accepts separate arguments as as alternative to the options object.
	   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
	   */
	  scrollResponderScrollTo: function scrollResponderScrollTo(x, y, animated) {
	    if (typeof x === 'number') {
	      console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');
	    } else {
	      var _ref = x || emptyObject;
	
	      x = _ref.x;
	      y = _ref.y;
	      animated = _ref.animated;
	    }
	    var node = this.scrollResponderGetScrollableNode();
	    _UIManager2.default.updateView(node, { style: { scrollBehavior: !animated ? 'auto' : 'smooth' } }, this);
	    node.scrollLeft = x || 0;
	    node.scrollTop = y || 0;
	  },
	
	  /**
	   * Deprecated, do not use.
	   */
	  scrollResponderScrollWithoutAnimationTo: function scrollResponderScrollWithoutAnimationTo(offsetX, offsetY) {
	    console.warn('`scrollResponderScrollWithoutAnimationTo` is deprecated. Use `scrollResponderScrollTo` instead');
	    this.scrollResponderScrollTo({ x: offsetX, y: offsetY, animated: false });
	  },
	
	  /**
	   * A helper function to zoom to a specific rect in the scrollview. The argument has the shape
	   * {x: number; y: number; width: number; height: number; animated: boolean = true}
	   *
	   * @platform ios
	   */
	  scrollResponderZoomTo: function scrollResponderZoomTo(rect, animated // deprecated, put this inside the rect argument instead
	  ) {
	    if (_Platform2.default.OS !== 'ios') {
	      (0, _invariant2.default)('zoomToRect is not implemented');
	    }
	  },
	
	  /**
	   * This method should be used as the callback to onFocus in a TextInputs'
	   * parent view. Note that any module using this mixin needs to return
	   * the parent view's ref in getScrollViewRef() in order to use this method.
	   * @param {any} nodeHandle The TextInput node handle
	   * @param {number} additionalOffset The scroll view's top "contentInset".
	   *        Default is 0.
	   * @param {bool} preventNegativeScrolling Whether to allow pulling the content
	   *        down to make it meet the keyboard's top. Default is false.
	   */
	  scrollResponderScrollNativeHandleToKeyboard: function scrollResponderScrollNativeHandleToKeyboard(nodeHandle, additionalOffset, preventNegativeScrollOffset) {
	    this.additionalScrollOffset = additionalOffset || 0;
	    this.preventNegativeScrollOffset = !!preventNegativeScrollOffset;
	    _UIManager2.default.measureLayout(nodeHandle, (0, _findNodeHandle2.default)(this.getInnerViewNode()), this.scrollResponderTextInputFocusError, this.scrollResponderInputMeasureAndScrollToKeyboard);
	  },
	
	  /**
	   * The calculations performed here assume the scroll view takes up the entire
	   * screen - even if has some content inset. We then measure the offsets of the
	   * keyboard, and compensate both for the scroll view's "contentInset".
	   *
	   * @param {number} left Position of input w.r.t. table view.
	   * @param {number} top Position of input w.r.t. table view.
	   * @param {number} width Width of the text input.
	   * @param {number} height Height of the text input.
	   */
	  scrollResponderInputMeasureAndScrollToKeyboard: function scrollResponderInputMeasureAndScrollToKeyboard(left, top, width, height) {
	    var keyboardScreenY = _Dimensions2.default.get('window').height;
	    if (this.keyboardWillOpenTo) {
	      keyboardScreenY = this.keyboardWillOpenTo.endCoordinates.screenY;
	    }
	    var scrollOffsetY = top - keyboardScreenY + height + this.additionalScrollOffset;
	
	    // By default, this can scroll with negative offset, pulling the content
	    // down so that the target component's bottom meets the keyboard's top.
	    // If requested otherwise, cap the offset at 0 minimum to avoid content
	    // shifting down.
	    if (this.preventNegativeScrollOffset) {
	      scrollOffsetY = Math.max(0, scrollOffsetY);
	    }
	    this.scrollResponderScrollTo({ x: 0, y: scrollOffsetY, animated: true });
	
	    this.additionalOffset = 0;
	    this.preventNegativeScrollOffset = false;
	  },
	
	  scrollResponderTextInputFocusError: function scrollResponderTextInputFocusError(e) {
	    console.error('Error measuring text field: ', e);
	  },
	
	  /**
	   * `componentWillMount` is the closest thing to a  standard "constructor" for
	   * React components.
	   *
	   * The `keyboardWillShow` is called before input focus.
	   */
	  componentWillMount: function componentWillMount() {
	    this.keyboardWillOpenTo = null;
	    this.additionalScrollOffset = 0;
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillShow', this.scrollResponderKeyboardWillShow);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillHide', this.scrollResponderKeyboardWillHide);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidShow', this.scrollResponderKeyboardDidShow);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidHide', this.scrollResponderKeyboardDidHide);
	  },
	
	  /**
	   * Warning, this may be called several times for a single keyboard opening.
	   * It's best to store the information in this method and then take any action
	   * at a later point (either in `keyboardDidShow` or other).
	   *
	   * Here's the order that events occur in:
	   * - focus
	   * - willShow {startCoordinates, endCoordinates} several times
	   * - didShow several times
	   * - blur
	   * - willHide {startCoordinates, endCoordinates} several times
	   * - didHide several times
	   *
	   * The `ScrollResponder` providesModule callbacks for each of these events.
	   * Even though any user could have easily listened to keyboard events
	   * themselves, using these `props` callbacks ensures that ordering of events
	   * is consistent - and not dependent on the order that the keyboard events are
	   * subscribed to. This matters when telling the scroll view to scroll to where
	   * the keyboard is headed - the scroll responder better have been notified of
	   * the keyboard destination before being instructed to scroll to where the
	   * keyboard will be. Stick to the `ScrollResponder` callbacks, and everything
	   * will work.
	   *
	   * WARNING: These callbacks will fire even if a keyboard is displayed in a
	   * different navigation pane. Filter out the events to determine if they are
	   * relevant to you. (For example, only if you receive these callbacks after
	   * you had explicitly focused a node etc).
	   */
	  scrollResponderKeyboardWillShow: function scrollResponderKeyboardWillShow(e) {
	    this.keyboardWillOpenTo = e;
	    this.props.onKeyboardWillShow && this.props.onKeyboardWillShow(e);
	  },
	
	  scrollResponderKeyboardWillHide: function scrollResponderKeyboardWillHide(e) {
	    this.keyboardWillOpenTo = null;
	    this.props.onKeyboardWillHide && this.props.onKeyboardWillHide(e);
	  },
	
	  scrollResponderKeyboardDidShow: function scrollResponderKeyboardDidShow(e) {
	    // TODO(7693961): The event for DidShow is not available on iOS yet.
	    // Use the one from WillShow and do not assign.
	    if (e) {
	      this.keyboardWillOpenTo = e;
	    }
	    this.props.onKeyboardDidShow && this.props.onKeyboardDidShow(e);
	  },
	
	  scrollResponderKeyboardDidHide: function scrollResponderKeyboardDidHide(e) {
	    this.keyboardWillOpenTo = null;
	    this.props.onKeyboardDidHide && this.props.onKeyboardDidHide(e);
	  }
	};
	
	var ScrollResponder = {
	  Mixin: ScrollResponderMixin
	};
	
	exports.default = ScrollResponder;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * This class is responsible for coordinating the "focused"
	 * state for TextInputs. All calls relating to the keyboard
	 * should be funneled through here
	 */
	var TextInputState = {
	  /**
	   * Internal state
	   */
	  _currentlyFocusedNode: null,
	
	  /**
	   * Returns the ID of the currently focused text field, if one exists
	   * If no text field is focused it returns null
	   */
	  currentlyFocusedField: function currentlyFocusedField() {
	    if (document.activeElement !== this._currentlyFocusedNode) {
	      this._currentlyFocusedNode = null;
	    }
	    return this._currentlyFocusedNode;
	  },
	
	  /**
	   * @param {Object} TextInputID id of the text field to focus
	   * Focuses the specified text field
	   * noop if the text field was already focused
	   */
	  focusTextInput: function focusTextInput(textFieldNode) {
	    if (textFieldNode !== null) {
	      this._currentlyFocusedNode = textFieldNode;
	      if (document.activeElement !== textFieldNode) {
	        _UIManager2.default.focus(textFieldNode);
	      }
	    }
	  },
	
	  /**
	   * @param {Object} textFieldNode id of the text field to focus
	   * Unfocuses the specified text field
	   * noop if it wasn't focused
	   */
	  blurTextInput: function blurTextInput(textFieldNode) {
	    if (textFieldNode !== null) {
	      this._currentlyFocusedNode = null;
	      if (document.activeElement === textFieldNode) {
	        _UIManager2.default.blur(textFieldNode);
	      }
	    }
	  }
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = TextInputState;

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TextInputState = __webpack_require__(62);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var dismissKeyboard = function dismissKeyboard() {
	    _TextInputState2.default.blurTextInput(_TextInputState2.default.currentlyFocusedField());
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = dismissKeyboard;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cancelIdleCallback = undefined;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _requestIdleCallback = function _requestIdleCallback(cb, options) {
	  return setTimeout(function () {
	    var start = Date.now();
	    cb({
	      didTimeout: false,
	      timeRemaining: function timeRemaining() {
	        return Math.max(0, 50 - (Date.now() - start));
	      }
	    });
	  }, 1);
	};
	
	// $FlowFixMe (TimeoutID type is not recognized by eslint)
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var _cancelIdleCallback = function _cancelIdleCallback(id) {
	  clearTimeout(id);
	};
	
	var isSupported = _ExecutionEnvironment.canUseDOM && typeof window.requestIdleCallback !== 'undefined';
	
	var requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
	var cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;
	
	exports.default = requestIdleCallback;
	exports.cancelIdleCallback = cancelIdleCallback;

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var AnimatedValue = __webpack_require__(9);
	var NativeAnimatedHelper = __webpack_require__(5);
	var findNodeHandle = __webpack_require__(11).default;
	
	var invariant = __webpack_require__(3);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	function attachNativeEvent(viewRef, eventName, argMapping) {
	  // Find animated values in `argMapping` and create an array representing their
	  // key path inside the `nativeEvent` object. Ex.: ['contentOffset', 'x'].
	  var eventMappings = [];
	
	  var traverse = function traverse(value, path) {
	    if (value instanceof AnimatedValue) {
	      value.__makeNative();
	
	      eventMappings.push({
	        nativeEventPath: path,
	        animatedValueTag: value.__getNativeTag()
	      });
	    } else if (typeof value === 'object') {
	      for (var _key in value) {
	        traverse(value[_key], path.concat(_key));
	      }
	    }
	  };
	
	  invariant(argMapping[0] && argMapping[0].nativeEvent, 'Native driven events only support animated values contained inside `nativeEvent`.');
	
	  // Assume that the event containing `nativeEvent` is always the first argument.
	  traverse(argMapping[0].nativeEvent, []);
	
	  var viewTag = findNodeHandle(viewRef);
	
	  eventMappings.forEach(function (mapping) {
	    NativeAnimatedHelper.API.addAnimatedEventToView(viewTag, eventName, mapping);
	  });
	
	  return {
	    detach: function detach() {
	      eventMappings.forEach(function (mapping) {
	        NativeAnimatedHelper.API.removeAnimatedEventFromView(viewTag, eventName, mapping.animatedValueTag);
	      });
	    }
	  };
	}
	
	var AnimatedEvent = function () {
	  function AnimatedEvent(argMapping) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, AnimatedEvent);
	
	    this._listeners = [];
	
	    this._argMapping = argMapping;
	    if (config.listener) {
	      this.__addListener(config.listener);
	    }
	    this._callListeners = this._callListeners.bind(this);
	    this._attachedEvent = null;
	    this.__isNative = shouldUseNativeDriver(config);
	
	    if (false) {
	      this._validateMapping();
	    }
	  }
	
	  AnimatedEvent.prototype.__addListener = function __addListener(callback) {
	    this._listeners.push(callback);
	  };
	
	  AnimatedEvent.prototype.__removeListener = function __removeListener(callback) {
	    this._listeners = this._listeners.filter(function (listener) {
	      return listener !== callback;
	    });
	  };
	
	  AnimatedEvent.prototype.__attach = function __attach(viewRef, eventName) {
	    invariant(this.__isNative, 'Only native driven events need to be attached.');
	
	    this._attachedEvent = attachNativeEvent(viewRef, eventName, this._argMapping);
	  };
	
	  AnimatedEvent.prototype.__detach = function __detach(viewTag, eventName) {
	    invariant(this.__isNative, 'Only native driven events need to be detached.');
	
	    this._attachedEvent && this._attachedEvent.detach();
	  };
	
	  AnimatedEvent.prototype.__getHandler = function __getHandler() {
	    var _this = this;
	
	    if (this.__isNative) {
	      return this._callListeners;
	    }
	
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var traverse = function traverse(recMapping, recEvt, key) {
	        if (typeof recEvt === 'number' && recMapping instanceof AnimatedValue) {
	          recMapping.setValue(recEvt);
	        } else if (typeof recMapping === 'object') {
	          for (var mappingKey in recMapping) {
	            /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	             * comment suppresses an error when upgrading Flow's support for
	             * React. To see the error delete this comment and run Flow. */
	            traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
	          }
	        }
	      };
	
	      if (!_this.__isNative) {
	        _this._argMapping.forEach(function (mapping, idx) {
	          traverse(mapping, args[idx], 'arg' + idx);
	        });
	      }
	      _this._callListeners.apply(_this, args);
	    };
	  };
	
	  AnimatedEvent.prototype._callListeners = function _callListeners() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    this._listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  AnimatedEvent.prototype._validateMapping = function _validateMapping() {
	    var traverse = function traverse(recMapping, recEvt, key) {
	      if (typeof recEvt === 'number') {
	        invariant(recMapping instanceof AnimatedValue, 'Bad mapping of type ' + typeof recMapping + ' for key ' + key + ', event value must map to AnimatedValue');
	        return;
	      }
	      invariant(typeof recMapping === 'object', 'Bad mapping of type ' + typeof recMapping + ' for key ' + key);
	      invariant(typeof recEvt === 'object', 'Bad event of type ' + typeof recEvt + ' for key ' + key);
	      for (var mappingKey in recMapping) {
	        traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
	      }
	    };
	  };
	
	  return AnimatedEvent;
	}();
	
	module.exports = { AnimatedEvent: AnimatedEvent, attachNativeEvent: attachNativeEvent };

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 * @preventMunge
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _require = __webpack_require__(31),
	    AnimatedEvent = _require.AnimatedEvent,
	    attachNativeEvent = _require.attachNativeEvent;
	
	var AnimatedAddition = __webpack_require__(143);
	var AnimatedDiffClamp = __webpack_require__(144);
	var AnimatedDivision = __webpack_require__(145);
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedModulo = __webpack_require__(146);
	var AnimatedMultiplication = __webpack_require__(147);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedProps = __webpack_require__(70);
	var AnimatedTracking = __webpack_require__(149);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedValueXY = __webpack_require__(33);
	var DecayAnimation = __webpack_require__(138);
	var SpringAnimation = __webpack_require__(139);
	var TimingAnimation = __webpack_require__(140);
	
	var createAnimatedComponent = __webpack_require__(142);
	
	var add = function add(a, b) {
	  return new AnimatedAddition(a, b);
	};
	
	var divide = function divide(a, b) {
	  return new AnimatedDivision(a, b);
	};
	
	var multiply = function multiply(a, b) {
	  return new AnimatedMultiplication(a, b);
	};
	
	var modulo = function modulo(a, modulus) {
	  return new AnimatedModulo(a, modulus);
	};
	
	var diffClamp = function diffClamp(a, min, max) {
	  return new AnimatedDiffClamp(a, min, max);
	};
	
	var _combineCallbacks = function _combineCallbacks(callback, config) {
	  if (callback && config.onComplete) {
	    return function () {
	      config.onComplete && config.onComplete.apply(config, arguments);
	      callback && callback.apply(undefined, arguments);
	    };
	  } else {
	    return callback || config.onComplete;
	  }
	};
	
	var maybeVectorAnim = function maybeVectorAnim(value, config, anim) {
	  if (value instanceof AnimatedValueXY) {
	    var configX = _extends({}, config);
	    var configY = _extends({}, config);
	    for (var key in config) {
	      var _config$key = config[key],
	          x = _config$key.x,
	          y = _config$key.y;
	
	      if (x !== undefined && y !== undefined) {
	        configX[key] = x;
	        configY[key] = y;
	      }
	    }
	    var aX = anim(value.x, configX);
	    var aY = anim(value.y, configY);
	    // We use `stopTogether: false` here because otherwise tracking will break
	    // because the second animation will get stopped before it can update.
	    return parallel([aX, aY], { stopTogether: false });
	  }
	  return null;
	};
	
	var spring = function spring(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    if (configuration.toValue instanceof AnimatedNode) {
	      singleValue.track(new AnimatedTracking(singleValue, configuration.toValue, SpringAnimation, singleConfig, callback));
	    } else {
	      singleValue.animate(new SpringAnimation(singleConfig), callback);
	    }
	  };
	  return maybeVectorAnim(value, config, spring) || {
	    start: function (_start) {
	      function start(_x) {
	        return _start.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = _extends({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var timing = function timing(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    if (configuration.toValue instanceof AnimatedNode) {
	      singleValue.track(new AnimatedTracking(singleValue, configuration.toValue, TimingAnimation, singleConfig, callback));
	    } else {
	      singleValue.animate(new TimingAnimation(singleConfig), callback);
	    }
	  };
	
	  return maybeVectorAnim(value, config, timing) || {
	    start: function (_start2) {
	      function start(_x2) {
	        return _start2.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start2.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = _extends({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var decay = function decay(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    singleValue.animate(new DecayAnimation(singleConfig), callback);
	  };
	
	  return maybeVectorAnim(value, config, decay) || {
	    start: function (_start3) {
	      function start(_x3) {
	        return _start3.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start3.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = _extends({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var sequence = function sequence(animations) {
	  var current = 0;
	  return {
	    start: function start(callback) {
	      var onComplete = function onComplete(result) {
	        if (!result.finished) {
	          callback && callback(result);
	          return;
	        }
	
	        current++;
	
	        if (current === animations.length) {
	          callback && callback(result);
	          return;
	        }
	
	        animations[current].start(onComplete);
	      };
	
	      if (animations.length === 0) {
	        callback && callback({ finished: true });
	      } else {
	        animations[current].start(onComplete);
	      }
	    },
	
	    stop: function stop() {
	      if (current < animations.length) {
	        animations[current].stop();
	      }
	    },
	
	    reset: function reset() {
	      animations.forEach(function (animation, idx) {
	        if (idx <= current) {
	          animation.reset();
	        }
	      });
	      current = 0;
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.sequence animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return false;
	    }
	  };
	};
	
	var parallel = function parallel(animations, config) {
	  var doneCount = 0;
	  // Make sure we only call stop() at most once for each animation
	  var hasEnded = {};
	  var stopTogether = !(config && config.stopTogether === false);
	
	  var result = {
	    start: function start(callback) {
	      if (doneCount === animations.length) {
	        callback && callback({ finished: true });
	        return;
	      }
	
	      animations.forEach(function (animation, idx) {
	        var cb = function cb(endResult) {
	          hasEnded[idx] = true;
	          doneCount++;
	          if (doneCount === animations.length) {
	            doneCount = 0;
	            callback && callback(endResult);
	            return;
	          }
	
	          if (!endResult.finished && stopTogether) {
	            result.stop();
	          }
	        };
	
	        if (!animation) {
	          cb({ finished: true });
	        } else {
	          animation.start(cb);
	        }
	      });
	    },
	
	    stop: function stop() {
	      animations.forEach(function (animation, idx) {
	        !hasEnded[idx] && animation.stop();
	        hasEnded[idx] = true;
	      });
	    },
	
	    reset: function reset() {
	      animations.forEach(function (animation, idx) {
	        animation.reset();
	        hasEnded[idx] = false;
	        doneCount = 0;
	      });
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.parallel animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return false;
	    }
	  };
	
	  return result;
	};
	
	var delay = function delay(time) {
	  // Would be nice to make a specialized implementation
	  return timing(new AnimatedValue(0), { toValue: 0, delay: time, duration: 0 });
	};
	
	var stagger = function stagger(time, animations) {
	  return parallel(animations.map(function (animation, i) {
	    return sequence([delay(time * i), animation]);
	  }));
	};
	
	var loop = function loop(animation) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$iterations = _ref.iterations,
	      iterations = _ref$iterations === undefined ? -1 : _ref$iterations;
	
	  var isFinished = false;
	  var iterationsSoFar = 0;
	  return {
	    start: function start(callback) {
	      var restart = function restart() {
	        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { finished: true };
	
	        if (isFinished || iterationsSoFar === iterations || result.finished === false) {
	          callback && callback(result);
	        } else {
	          iterationsSoFar++;
	          animation.reset();
	          animation.start(restart);
	        }
	      };
	      if (!animation || iterations === 0) {
	        callback && callback({ finished: true });
	      } else {
	        if (animation._isUsingNativeDriver()) {
	          animation._startNativeLoop(iterations);
	        } else {
	          restart(); // Start looping recursively on the js thread
	        }
	      }
	    },
	
	    stop: function stop() {
	      isFinished = true;
	      animation.stop();
	    },
	
	    reset: function reset() {
	      iterationsSoFar = 0;
	      isFinished = false;
	      animation.reset();
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.loop animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return animation._isUsingNativeDriver();
	    }
	  };
	};
	
	function forkEvent(event, listener) {
	  if (!event) {
	    return listener;
	  } else if (event instanceof AnimatedEvent) {
	    event.__addListener(listener);
	    return event;
	  } else {
	    return function () {
	      typeof event === 'function' && event.apply(undefined, arguments);
	      listener.apply(undefined, arguments);
	    };
	  }
	}
	
	function unforkEvent(event, listener) {
	  if (event && event instanceof AnimatedEvent) {
	    event.__removeListener(listener);
	  }
	}
	
	var event = function event(argMapping, config) {
	  var animatedEvent = new AnimatedEvent(argMapping, config);
	  if (animatedEvent.__isNative) {
	    return animatedEvent;
	  } else {
	    return animatedEvent.__getHandler();
	  }
	};
	
	/**
	 * The `Animated` library is designed to make animations fluid, powerful, and
	 * easy to build and maintain. `Animated` focuses on declarative relationships
	 * between inputs and outputs, with configurable transforms in between, and
	 * simple `start`/`stop` methods to control time-based animation execution.
	 *
	 * See http://facebook.github.io/react-native/docs/animated.html
	 */
	module.exports = {
	  /**
	   * Standard value class for driving animations.  Typically initialized with
	   * `new Animated.Value(0);`
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#value
	   */
	  Value: AnimatedValue,
	  /**
	   * 2D value class for driving 2D animations, such as pan gestures.
	   *
	   * See https://facebook.github.io/react-native/releases/next/docs/animatedvaluexy.html
	   */
	  ValueXY: AnimatedValueXY,
	  /**
	   * Exported to use the Interpolation type in flow.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#interpolation
	   */
	  Interpolation: AnimatedInterpolation,
	  /**
	   * Exported for ease of type checking. All animated values derive from this
	   * class.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#node
	   */
	  Node: AnimatedNode,
	
	  /**
	   * Animates a value from an initial velocity to zero based on a decay
	   * coefficient.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#decay
	   */
	  decay: decay,
	  /**
	   * Animates a value along a timed easing curve. The Easing module has tons of
	   * predefined curves, or you can use your own function.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#timing
	   */
	  timing: timing,
	  /**
	   * Animates a value according to an analytical spring model based on
	   * damped harmonic oscillation.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#spring
	   */
	  spring: spring,
	
	  /**
	   * Creates a new Animated value composed from two Animated values added
	   * together.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#add
	   */
	  add: add,
	
	  /**
	   * Creates a new Animated value composed by dividing the first Animated value
	   * by the second Animated value.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#divide
	   */
	  divide: divide,
	
	  /**
	   * Creates a new Animated value composed from two Animated values multiplied
	   * together.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#multiply
	   */
	  multiply: multiply,
	
	  /**
	   * Creates a new Animated value that is the (non-negative) modulo of the
	   * provided Animated value.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#modulo
	   */
	  modulo: modulo,
	
	  /**
	   * Create a new Animated value that is limited between 2 values. It uses the
	   * difference between the last value so even if the value is far from the
	   * bounds it will start changing when the value starts getting closer again.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#diffclamp
	   */
	  diffClamp: diffClamp,
	
	  /**
	   * Starts an animation after the given delay.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#delay
	   */
	  delay: delay,
	  /**
	   * Starts an array of animations in order, waiting for each to complete
	   * before starting the next. If the current running animation is stopped, no
	   * following animations will be started.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#sequence
	   */
	  sequence: sequence,
	  /**
	   * Starts an array of animations all at the same time. By default, if one
	   * of the animations is stopped, they will all be stopped. You can override
	   * this with the `stopTogether` flag.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#parallel
	   */
	  parallel: parallel,
	  /**
	   * Array of animations may run in parallel (overlap), but are started in
	   * sequence with successive delays.  Nice for doing trailing effects.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#stagger
	   */
	  stagger: stagger,
	  /**
	   * Loops a given animation continuously, so that each time it reaches the
	   * end, it resets and begins again from the start.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#loop
	   */
	  loop: loop,
	
	  /**
	   * Takes an array of mappings and extracts values from each arg accordingly,
	   * then calls `setValue` on the mapped outputs.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#event
	   */
	  event: event,
	
	  /**
	   * Make any React component Animatable.  Used to create `Animated.View`, etc.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#createanimatedcomponent
	   */
	  createAnimatedComponent: createAnimatedComponent,
	
	  /**
	   * Imperative API to attach an animated value to an event on a view. Prefer
	   * using `Animated.event` with `useNativeDrive: true` if possible.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#attachnativeevent
	   */
	  attachNativeEvent: attachNativeEvent,
	
	  /**
	   * Advanced imperative API for snooping on animated events that are passed in
	   * through props. Use values directly where possible.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#forkevent
	   */
	  forkEvent: forkEvent,
	  unforkEvent: unforkEvent,
	
	  __PropsOnlyForTests: AnimatedProps
	};

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var _ease = void 0;
	
	/**
	 * The `Easing` module implements common easing functions. This module is used
	 * by [Animate.timing()](docs/animate.html#timing) to convey physically
	 * believable motion in animations.
	 *
	 * You can find a visualization of some common easing functions at
	 * http://easings.net/
	 *
	 * ### Predefined animations
	 *
	 * The `Easing` module provides several predefined animations through the
	 * following methods:
	 *
	 * - [`back`](docs/easing.html#back) provides a simple animation where the
	 *   object goes slightly back before moving forward
	 * - [`bounce`](docs/easing.html#bounce) provides a bouncing animation
	 * - [`ease`](docs/easing.html#ease) provides a simple inertial animation
	 * - [`elastic`](docs/easing.html#elastic) provides a simple spring interaction
	 *
	 * ### Standard functions
	 *
	 * Three standard easing functions are provided:
	 *
	 * - [`linear`](docs/easing.html#linear)
	 * - [`quad`](docs/easing.html#quad)
	 * - [`cubic`](docs/easing.html#cubic)
	 *
	 * The [`poly`](docs/easing.html#poly) function can be used to implement
	 * quartic, quintic, and other higher power functions.
	 *
	 * ### Additional functions
	 *
	 * Additional mathematical functions are provided by the following methods:
	 *
	 * - [`bezier`](docs/easing.html#bezier) provides a cubic bezier curve
	 * - [`circle`](docs/easing.html#circle) provides a circular function
	 * - [`sin`](docs/easing.html#sin) provides a sinusoidal function
	 * - [`exp`](docs/easing.html#exp) provides an exponential function
	 *
	 * The following helpers are used to modify other easing functions.
	 *
	 * - [`in`](docs/easing.html#in) runs an easing function forwards
	 * - [`inOut`](docs/easing.html#inout) makes any easing function symmetrical
	 * - [`out`](docs/easing.html#out) runs an easing function backwards
	 */
	
	var Easing = function () {
	  function Easing() {
	    _classCallCheck(this, Easing);
	  }
	
	  /**
	   * A stepping function, returns 1 for any positive value of `n`.
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	  Easing.step0 = function step0(n) {
	    return n > 0 ? 1 : 0;
	  };
	
	  /**
	   * A stepping function, returns 1 if `n` is greater than or equal to 1.
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.step1 = function step1(n) {
	    return n >= 1 ? 1 : 0;
	  };
	
	  /**
	   * A linear function, `f(t) = t`. Position correlates to elapsed time one to
	   * one.
	   *
	   * http://cubic-bezier.com/#0,0,1,1
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.linear = function linear(t) {
	    return t;
	  };
	
	  /**
	   * A simple inertial interaction, similar to an object slowly accelerating to
	   * speed.
	   *
	   * http://cubic-bezier.com/#.42,0,1,1
	   */
	
	  Easing.ease = function ease(t) {
	    if (!_ease) {
	      _ease = Easing.bezier(0.42, 0, 1, 1);
	    }
	    return _ease(t);
	  };
	
	  /**
	   * A quadratic function, `f(t) = t * t`. Position equals the square of elapsed
	   * time.
	   *
	   * http://easings.net/#easeInQuad
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.quad = function quad(t) {
	    return t * t;
	  };
	
	  /**
	   * A cubic function, `f(t) = t * t * t`. Position equals the cube of elapsed
	   * time.
	   *
	   * http://easings.net/#easeInCubic
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.cubic = function cubic(t) {
	    return t * t * t;
	  };
	
	  /**
	   * A power function. Position is equal to the Nth power of elapsed time.
	   *
	   * n = 4: http://easings.net/#easeInQuart
	   * n = 5: http://easings.net/#easeInQuint
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.poly = function poly(n) {
	    /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an
	     * error caught by Flow 0.59 which was not caught before. Most likely, this
	     * error is because an exported function parameter is missing an
	     * annotation. Without an annotation, these parameters are uncovered by
	     * Flow. */
	    return function (t) {
	      return Math.pow(t, n);
	    };
	  };
	
	  /**
	   * A sinusoidal function.
	   *
	   * http://easings.net/#easeInSine
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.sin = function sin(t) {
	    return 1 - Math.cos(t * Math.PI / 2);
	  };
	
	  /**
	   * A circular function.
	   *
	   * http://easings.net/#easeInCirc
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.circle = function circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  };
	
	  /**
	   * An exponential function.
	   *
	   * http://easings.net/#easeInExpo
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.exp = function exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  };
	
	  /**
	   * A simple elastic interaction, similar to a spring oscillating back and
	   * forth.
	   *
	   * Default bounciness is 1, which overshoots a little bit once. 0 bounciness
	   * doesn't overshoot at all, and bounciness of N > 1 will overshoot about N
	   * times.
	   *
	   * http://easings.net/#easeInElastic
	   */
	
	  Easing.elastic = function elastic() {
	    var bounciness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var p = bounciness * Math.PI;
	    return function (t) {
	      return 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
	    };
	  };
	
	  /**
	   * Use with `Animated.parallel()` to create a simple effect where the object
	   * animates back slightly as the animation starts.
	   *
	   * Wolfram Plot:
	   *
	   * - http://tiny.cc/back_default (s = 1.70158, default)
	   */
	
	  Easing.back = function back(s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return function (t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  };
	
	  /**
	   * Provides a simple bouncing effect.
	   *
	   * http://easings.net/#easeInBounce
	   */
	
	  Easing.bounce = function bounce(t) {
	    if (t < 1 / 2.75) {
	      return 7.5625 * t * t;
	    }
	
	    if (t < 2 / 2.75) {
	      t -= 1.5 / 2.75;
	      return 7.5625 * t * t + 0.75;
	    }
	
	    if (t < 2.5 / 2.75) {
	      t -= 2.25 / 2.75;
	      return 7.5625 * t * t + 0.9375;
	    }
	
	    t -= 2.625 / 2.75;
	    return 7.5625 * t * t + 0.984375;
	  };
	
	  /**
	   * Provides a cubic bezier curve, equivalent to CSS Transitions'
	   * `transition-timing-function`.
	   *
	   * A useful tool to visualize cubic bezier curves can be found at
	   * http://cubic-bezier.com/
	   */
	
	  Easing.bezier = function bezier(x1, y1, x2, y2) {
	    var _bezier = __webpack_require__(141);
	    return _bezier(x1, y1, x2, y2);
	  };
	
	  /**
	   * Runs an easing function forwards.
	   */
	
	  Easing.in = function _in(easing) {
	    return easing;
	  };
	
	  /**
	   * Runs an easing function backwards.
	   */
	
	  Easing.out = function out(easing) {
	    return function (t) {
	      return 1 - easing(1 - t);
	    };
	  };
	
	  /**
	   * Makes any easing function symmetrical. The easing function will run
	   * forwards for half of the duration, then backwards for the rest of the
	   * duration.
	   */
	
	  Easing.inOut = function inOut(easing) {
	    return function (t) {
	      if (t < 0.5) {
	        return easing(t * 2) / 2;
	      }
	      return 1 - easing((1 - t) * 2) / 2;
	    };
	  };
	
	  return Easing;
	}();
	
	module.exports = Easing;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var invariant = __webpack_require__(3);
	var NativeModules = __webpack_require__(103);
	var NativeEventEmitter = __webpack_require__(124);
	
	var NativeAnimatedModule = NativeModules.NativeAnimatedModule;
	
	var __nativeAnimatedNodeTagCount = 1; /* used for animated nodes */
	var __nativeAnimationIdCount = 1; /* used for started animations */
	
	var nativeEventEmitter = void 0;
	
	/**
	 * Simple wrappers around NativeAnimatedModule to provide flow and autocmplete support for
	 * the native module methods
	 */
	var API = {
	  createAnimatedNode: function createAnimatedNode(tag, config) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.createAnimatedNode(tag, config);
	  },
	  startListeningToAnimatedNodeValue: function startListeningToAnimatedNodeValue(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.startListeningToAnimatedNodeValue(tag);
	  },
	  stopListeningToAnimatedNodeValue: function stopListeningToAnimatedNodeValue(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.stopListeningToAnimatedNodeValue(tag);
	  },
	  connectAnimatedNodes: function connectAnimatedNodes(parentTag, childTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.connectAnimatedNodes(parentTag, childTag);
	  },
	  disconnectAnimatedNodes: function disconnectAnimatedNodes(parentTag, childTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.disconnectAnimatedNodes(parentTag, childTag);
	  },
	  startAnimatingNode: function startAnimatingNode(animationId, nodeTag, config, endCallback) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.startAnimatingNode(animationId, nodeTag, config, endCallback);
	  },
	  stopAnimation: function stopAnimation(animationId) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.stopAnimation(animationId);
	  },
	  setAnimatedNodeValue: function setAnimatedNodeValue(nodeTag, value) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.setAnimatedNodeValue(nodeTag, value);
	  },
	  setAnimatedNodeOffset: function setAnimatedNodeOffset(nodeTag, offset) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.setAnimatedNodeOffset(nodeTag, offset);
	  },
	  flattenAnimatedNodeOffset: function flattenAnimatedNodeOffset(nodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.flattenAnimatedNodeOffset(nodeTag);
	  },
	  extractAnimatedNodeOffset: function extractAnimatedNodeOffset(nodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.extractAnimatedNodeOffset(nodeTag);
	  },
	  connectAnimatedNodeToView: function connectAnimatedNodeToView(nodeTag, viewTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.connectAnimatedNodeToView(nodeTag, viewTag);
	  },
	  disconnectAnimatedNodeFromView: function disconnectAnimatedNodeFromView(nodeTag, viewTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.disconnectAnimatedNodeFromView(nodeTag, viewTag);
	  },
	  dropAnimatedNode: function dropAnimatedNode(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.dropAnimatedNode(tag);
	  },
	  addAnimatedEventToView: function addAnimatedEventToView(viewTag, eventName, eventMapping) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.addAnimatedEventToView(viewTag, eventName, eventMapping);
	  },
	  removeAnimatedEventFromView: function removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag);
	  }
	};
	
	/**
	 * Styles allowed by the native animated implementation.
	 *
	 * In general native animated implementation should support any numeric property that doesn't need
	 * to be updated through the shadow view hierarchy (all non-layout properties).
	 */
	var STYLES_WHITELIST = {
	  opacity: true,
	  transform: true,
	  /* ios styles */
	  shadowOpacity: true,
	  shadowRadius: true,
	  /* legacy android transform properties */
	  scaleX: true,
	  scaleY: true,
	  translateX: true,
	  translateY: true
	};
	
	var TRANSFORM_WHITELIST = {
	  translateX: true,
	  translateY: true,
	  scale: true,
	  scaleX: true,
	  scaleY: true,
	  rotate: true,
	  rotateX: true,
	  rotateY: true,
	  perspective: true
	};
	
	function validateTransform(configs) {
	  configs.forEach(function (config) {
	    if (!TRANSFORM_WHITELIST.hasOwnProperty(config.property)) {
	      throw new Error('Property \'' + config.property + '\' is not supported by native animated module');
	    }
	  });
	}
	
	function validateStyles(styles) {
	  for (var key in styles) {
	    if (!STYLES_WHITELIST.hasOwnProperty(key)) {
	      throw new Error('Style property \'' + key + '\' is not supported by native animated module');
	    }
	  }
	}
	
	function validateInterpolation(config) {
	  var SUPPORTED_INTERPOLATION_PARAMS = {
	    inputRange: true,
	    outputRange: true,
	    extrapolate: true,
	    extrapolateRight: true,
	    extrapolateLeft: true
	  };
	  for (var key in config) {
	    if (!SUPPORTED_INTERPOLATION_PARAMS.hasOwnProperty(key)) {
	      throw new Error('Interpolation property \'' + key + '\' is not supported by native animated module');
	    }
	  }
	}
	
	function generateNewNodeTag() {
	  return __nativeAnimatedNodeTagCount++;
	}
	
	function generateNewAnimationId() {
	  return __nativeAnimationIdCount++;
	}
	
	function assertNativeAnimatedModule() {
	  invariant(NativeAnimatedModule, 'Native animated module is not available');
	}
	
	var _warnedMissingNativeAnimated = false;
	
	function shouldUseNativeDriver(config) {
	  if (config.useNativeDriver && !NativeAnimatedModule) {
	    if (!_warnedMissingNativeAnimated) {
	      console.warn('Animated: `useNativeDriver` is not supported because the native ' + 'animated module is missing. Falling back to JS-based animation. To ' + 'resolve this, add `RCTAnimation` module to this app, or remove ' + '`useNativeDriver`. ' + 'More info: https://github.com/facebook/react-native/issues/11094#issuecomment-263240420');
	      _warnedMissingNativeAnimated = true;
	    }
	    return false;
	  }
	
	  return config.useNativeDriver || false;
	}
	
	var NativeAnimatedHelper = {
	  API: API,
	  validateStyles: validateStyles,
	  validateTransform: validateTransform,
	  validateInterpolation: validateInterpolation,
	  generateNewNodeTag: generateNewNodeTag,
	  generateNewAnimationId: generateNewAnimationId,
	  assertNativeAnimatedModule: assertNativeAnimatedModule,
	  shouldUseNativeDriver: shouldUseNativeDriver,
	  get nativeEventEmitter() {
	    if (!nativeEventEmitter) {
	      nativeEventEmitter = new NativeEventEmitter(NativeAnimatedModule);
	    }
	    return nativeEventEmitter;
	  }
	};
	
	module.exports = NativeAnimatedHelper;

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function stiffnessFromOrigamiValue(oValue) {
	  return (oValue - 30) * 3.62 + 194;
	}
	
	function dampingFromOrigamiValue(oValue) {
	  return (oValue - 8) * 3 + 25;
	}
	
	function fromOrigamiTensionAndFriction(tension, friction) {
	  return {
	    stiffness: stiffnessFromOrigamiValue(tension),
	    damping: dampingFromOrigamiValue(friction)
	  };
	}
	
	function fromBouncinessAndSpeed(bounciness, speed) {
	  function normalize(value, startValue, endValue) {
	    return (value - startValue) / (endValue - startValue);
	  }
	
	  function projectNormal(n, start, end) {
	    return start + n * (end - start);
	  }
	
	  function linearInterpolation(t, start, end) {
	    return t * end + (1 - t) * start;
	  }
	
	  function quadraticOutInterpolation(t, start, end) {
	    return linearInterpolation(2 * t - t * t, start, end);
	  }
	
	  function b3Friction1(x) {
	    return 0.0007 * Math.pow(x, 3) - 0.031 * Math.pow(x, 2) + 0.64 * x + 1.28;
	  }
	
	  function b3Friction2(x) {
	    return 0.000044 * Math.pow(x, 3) - 0.006 * Math.pow(x, 2) + 0.36 * x + 2;
	  }
	
	  function b3Friction3(x) {
	    return 0.00000045 * Math.pow(x, 3) - 0.000332 * Math.pow(x, 2) + 0.1078 * x + 5.84;
	  }
	
	  function b3Nobounce(tension) {
	    if (tension <= 18) {
	      return b3Friction1(tension);
	    } else if (tension > 18 && tension <= 44) {
	      return b3Friction2(tension);
	    } else {
	      return b3Friction3(tension);
	    }
	  }
	
	  var b = normalize(bounciness / 1.7, 0, 20);
	  b = projectNormal(b, 0, 0.8);
	  var s = normalize(speed / 1.7, 0, 20);
	  var bouncyTension = projectNormal(s, 0.5, 200);
	  var bouncyFriction = quadraticOutInterpolation(b, b3Nobounce(bouncyTension), 0.01);
	
	  return {
	    stiffness: stiffnessFromOrigamiValue(bouncyTension),
	    damping: dampingFromOrigamiValue(bouncyFriction)
	  };
	}
	
	module.exports = {
	  fromOrigamiTensionAndFriction: fromOrigamiTensionAndFriction,
	  fromBouncinessAndSpeed: fromBouncinessAndSpeed
	};

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var NativeAnimatedHelper = __webpack_require__(5);
	
	// Important note: start() and stop() will only be called at most once.
	// Once an animation has been stopped or finished its course, it will
	// not be reused.
	var Animation = function () {
	  function Animation() {
	    _classCallCheck(this, Animation);
	  }
	
	  Animation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {};
	
	  Animation.prototype.stop = function stop() {
	    if (this.__nativeId) {
	      NativeAnimatedHelper.API.stopAnimation(this.__nativeId);
	    }
	  };
	
	  Animation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    // Subclasses that have corresponding animation implementation done in native
	    // should override this method
	    throw new Error('This animation type cannot be offloaded to native');
	  };
	  // Helper function for subclasses to make sure onEnd is only called once.
	
	
	  Animation.prototype.__debouncedOnEnd = function __debouncedOnEnd(result) {
	    var onEnd = this.__onEnd;
	    this.__onEnd = null;
	    onEnd && onEnd(result);
	  };
	
	  Animation.prototype.__startNativeAnimation = function __startNativeAnimation(animatedValue) {
	    animatedValue.__makeNative();
	    this.__nativeId = NativeAnimatedHelper.generateNewAnimationId();
	    NativeAnimatedHelper.API.startAnimatingNode(this.__nativeId, animatedValue.__getNativeTag(), this.__getNativeAnimationConfig(), this.__debouncedOnEnd.bind(this));
	  };
	
	  return Animation;
	}();
	
	module.exports = Animation;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var Animation = __webpack_require__(32);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	var DecayAnimation = function (_Animation) {
	  _inherits(DecayAnimation, _Animation);
	
	  function DecayAnimation(config) {
	    _classCallCheck(this, DecayAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._deceleration = config.deceleration !== undefined ? config.deceleration : 0.998;
	    _this._velocity = config.velocity;
	    _this._useNativeDriver = shouldUseNativeDriver(config);
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	    return _this;
	  }
	
	  DecayAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    return {
	      type: 'decay',
	      deceleration: this._deceleration,
	      velocity: this._velocity,
	      iterations: this.__iterations
	    };
	  };
	
	  DecayAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    this.__active = true;
	    this._lastValue = fromValue;
	    this._fromValue = fromValue;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._startTime = Date.now();
	    if (this._useNativeDriver) {
	      this.__startNativeAnimation(animatedValue);
	    } else {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  DecayAnimation.prototype.onUpdate = function onUpdate() {
	    var now = Date.now();
	
	    var value = this._fromValue + this._velocity / (1 - this._deceleration) * (1 - Math.exp(-(1 - this._deceleration) * (now - this._startTime)));
	
	    this._onUpdate(value);
	
	    if (Math.abs(this._lastValue - value) < 0.1) {
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	
	    this._lastValue = value;
	    if (this.__active) {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  DecayAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return DecayAnimation;
	}(Animation);
	
	module.exports = DecayAnimation;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedValueXY = __webpack_require__(33);
	var Animation = __webpack_require__(32);
	var SpringConfig = __webpack_require__(137);
	
	var invariant = __webpack_require__(3);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	function withDefault(value, defaultValue) {
	  if (value === undefined || value === null) {
	    return defaultValue;
	  }
	  return value;
	}
	
	var SpringAnimation = function (_Animation) {
	  _inherits(SpringAnimation, _Animation);
	
	  function SpringAnimation(config) {
	    _classCallCheck(this, SpringAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._overshootClamping = withDefault(config.overshootClamping, false);
	    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.001);
	    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.001);
	    _this._initialVelocity = withDefault(config.velocity, 0);
	    _this._lastVelocity = withDefault(config.velocity, 0);
	    _this._toValue = config.toValue;
	    _this._delay = withDefault(config.delay, 0);
	    _this._useNativeDriver = shouldUseNativeDriver(config);
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	
	    if (config.stiffness !== undefined || config.damping !== undefined || config.mass !== undefined) {
	      invariant(config.bounciness === undefined && config.speed === undefined && config.tension === undefined && config.friction === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
	      _this._stiffness = withDefault(config.stiffness, 100);
	      _this._damping = withDefault(config.damping, 10);
	      _this._mass = withDefault(config.mass, 1);
	    } else if (config.bounciness !== undefined || config.speed !== undefined) {
	      // Convert the origami bounciness/speed values to stiffness/damping
	      // We assume mass is 1.
	      invariant(config.tension === undefined && config.friction === undefined && config.stiffness === undefined && config.damping === undefined && config.mass === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
	      var springConfig = SpringConfig.fromBouncinessAndSpeed(withDefault(config.bounciness, 8), withDefault(config.speed, 12));
	      _this._stiffness = springConfig.stiffness;
	      _this._damping = springConfig.damping;
	      _this._mass = 1;
	    } else {
	      // Convert the origami tension/friction values to stiffness/damping
	      // We assume mass is 1.
	      var _springConfig = SpringConfig.fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));
	      _this._stiffness = _springConfig.stiffness;
	      _this._damping = _springConfig.damping;
	      _this._mass = 1;
	    }
	
	    invariant(_this._stiffness > 0, 'Stiffness value must be greater than 0');
	    invariant(_this._damping > 0, 'Damping value must be greater than 0');
	    invariant(_this._mass > 0, 'Mass value must be greater than 0');
	    return _this;
	  }
	
	  SpringAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    return {
	      type: 'spring',
	      overshootClamping: this._overshootClamping,
	      restDisplacementThreshold: this._restDisplacementThreshold,
	      restSpeedThreshold: this._restSpeedThreshold,
	      stiffness: this._stiffness,
	      damping: this._damping,
	      mass: this._mass,
	      initialVelocity: withDefault(this._initialVelocity, this._lastVelocity),
	      toValue: this._toValue,
	      iterations: this.__iterations
	    };
	  };
	
	  SpringAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    var _this2 = this;
	
	    this.__active = true;
	    this._startPosition = fromValue;
	    this._lastPosition = this._startPosition;
	
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._lastTime = Date.now();
	    this._frameTime = 0.0;
	
	    if (previousAnimation instanceof SpringAnimation) {
	      var internalState = previousAnimation.getInternalState();
	      this._lastPosition = internalState.lastPosition;
	      this._lastVelocity = internalState.lastVelocity;
	      // Set the initial velocity to the last velocity
	      this._initialVelocity = this._lastVelocity;
	      this._lastTime = internalState.lastTime;
	    }
	
	    var start = function start() {
	      if (_this2._useNativeDriver) {
	        _this2.__startNativeAnimation(animatedValue);
	      } else {
	        _this2.onUpdate();
	      }
	    };
	
	    //  If this._delay is more than 0, we start after the timeout.
	    if (this._delay) {
	      this._timeout = setTimeout(start, this._delay);
	    } else {
	      start();
	    }
	  };
	
	  SpringAnimation.prototype.getInternalState = function getInternalState() {
	    return {
	      lastPosition: this._lastPosition,
	      lastVelocity: this._lastVelocity,
	      lastTime: this._lastTime
	    };
	  };
	
	  /**
	   * This spring model is based off of a damped harmonic oscillator
	   * (https://en.wikipedia.org/wiki/Harmonic_oscillator#Damped_harmonic_oscillator).
	   *
	   * We use the closed form of the second order differential equation:
	   *
	   * x'' + (2ζ⍵_0)x' + ⍵^2x = 0
	   *
	   * where
	   *    ⍵_0 = √(k / m) (undamped angular frequency of the oscillator),
	   *    ζ = c / 2√mk (damping ratio),
	   *    c = damping constant
	   *    k = stiffness
	   *    m = mass
	   *
	   * The derivation of the closed form is described in detail here:
	   * http://planetmath.org/sites/default/files/texpdf/39745.pdf
	   *
	   * This algorithm happens to match the algorithm used by CASpringAnimation,
	   * a QuartzCore (iOS) API that creates spring animations.
	   */
	
	  SpringAnimation.prototype.onUpdate = function onUpdate() {
	    // If for some reason we lost a lot of frames (e.g. process large payload or
	    // stopped in the debugger), we only advance by 4 frames worth of
	    // computation and will continue on the next frame. It's better to have it
	    // running at faster speed than jumping to the end.
	    var MAX_STEPS = 64;
	    var now = Date.now();
	    if (now > this._lastTime + MAX_STEPS) {
	      now = this._lastTime + MAX_STEPS;
	    }
	
	    var deltaTime = (now - this._lastTime) / 1000;
	    this._frameTime += deltaTime;
	
	    var c = this._damping;
	    var m = this._mass;
	    var k = this._stiffness;
	    var v0 = -this._initialVelocity;
	
	    var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio
	    var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)
	    var omega1 = omega0 * Math.sqrt(1.0 - zeta * zeta); // exponential decay
	    var x0 = this._toValue - this._startPosition; // calculate the oscillation from x0 = 1 to x = 0
	
	    var position = 0.0;
	    var velocity = 0.0;
	    var t = this._frameTime;
	    if (zeta < 1) {
	      // Under damped
	      var envelope = Math.exp(-zeta * omega0 * t);
	      position = this._toValue - envelope * ((v0 + zeta * omega0 * x0) / omega1 * Math.sin(omega1 * t) + x0 * Math.cos(omega1 * t));
	      // This looks crazy -- it's actually just the derivative of the
	      // oscillation function
	      velocity = zeta * omega0 * envelope * (Math.sin(omega1 * t) * (v0 + zeta * omega0 * x0) / omega1 + x0 * Math.cos(omega1 * t)) - envelope * (Math.cos(omega1 * t) * (v0 + zeta * omega0 * x0) - omega1 * x0 * Math.sin(omega1 * t));
	    } else {
	      // Critically damped
	      var _envelope = Math.exp(-omega0 * t);
	      position = this._toValue - _envelope * (x0 + (v0 + omega0 * x0) * t);
	      velocity = _envelope * (v0 * (t * omega0 - 1) + t * x0 * (omega0 * omega0));
	    }
	
	    this._lastTime = now;
	    this._lastPosition = position;
	    this._lastVelocity = velocity;
	
	    this._onUpdate(position);
	    if (!this.__active) {
	      // a listener might have stopped us in _onUpdate
	      return;
	    }
	
	    // Conditions for stopping the spring animation
	    var isOvershooting = false;
	    if (this._overshootClamping && this._stiffness !== 0) {
	      if (this._startPosition < this._toValue) {
	        isOvershooting = position > this._toValue;
	      } else {
	        isOvershooting = position < this._toValue;
	      }
	    }
	    var isVelocity = Math.abs(velocity) <= this._restSpeedThreshold;
	    var isDisplacement = true;
	    if (this._stiffness !== 0) {
	      isDisplacement = Math.abs(this._toValue - position) <= this._restDisplacementThreshold;
	    }
	
	    if (isOvershooting || isVelocity && isDisplacement) {
	      if (this._stiffness !== 0) {
	        // Ensure that we end up with a round value
	        this._lastPosition = this._toValue;
	        this._lastVelocity = 0;
	        this._onUpdate(this._toValue);
	      }
	
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	    this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	  };
	
	  SpringAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    clearTimeout(this._timeout);
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return SpringAnimation;
	}(Animation);
	
	module.exports = SpringAnimation;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedValueXY = __webpack_require__(33);
	var Animation = __webpack_require__(32);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	var _easeInOut = void 0;
	function easeInOut() {
	  if (!_easeInOut) {
	    var Easing = __webpack_require__(136);
	    _easeInOut = Easing.inOut(Easing.ease);
	  }
	  return _easeInOut;
	}
	
	var TimingAnimation = function (_Animation) {
	  _inherits(TimingAnimation, _Animation);
	
	  function TimingAnimation(config) {
	    _classCallCheck(this, TimingAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._toValue = config.toValue;
	    _this._easing = config.easing !== undefined ? config.easing : easeInOut();
	    _this._duration = config.duration !== undefined ? config.duration : 500;
	    _this._delay = config.delay !== undefined ? config.delay : 0;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this._useNativeDriver = shouldUseNativeDriver(config);
	    return _this;
	  }
	
	  TimingAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    var frameDuration = 1000.0 / 60.0;
	    var frames = [];
	    for (var dt = 0.0; dt < this._duration; dt += frameDuration) {
	      frames.push(this._easing(dt / this._duration));
	    }
	    frames.push(this._easing(1));
	    return {
	      type: 'frames',
	      frames: frames,
	      toValue: this._toValue,
	      iterations: this.__iterations
	    };
	  };
	
	  TimingAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    var _this2 = this;
	
	    this.__active = true;
	    this._fromValue = fromValue;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	
	    var start = function start() {
	      // Animations that sometimes have 0 duration and sometimes do not
	      // still need to use the native driver when duration is 0 so as to
	      // not cause intermixed JS and native animations.
	      if (_this2._duration === 0 && !_this2._useNativeDriver) {
	        _this2._onUpdate(_this2._toValue);
	        _this2.__debouncedOnEnd({ finished: true });
	      } else {
	        _this2._startTime = Date.now();
	        if (_this2._useNativeDriver) {
	          _this2.__startNativeAnimation(animatedValue);
	        } else {
	          _this2._animationFrame = requestAnimationFrame(_this2.onUpdate.bind(_this2));
	        }
	      }
	    };
	    if (this._delay) {
	      this._timeout = setTimeout(start, this._delay);
	    } else {
	      start();
	    }
	  };
	
	  TimingAnimation.prototype.onUpdate = function onUpdate() {
	    var now = Date.now();
	    if (now >= this._startTime + this._duration) {
	      if (this._duration === 0) {
	        this._onUpdate(this._toValue);
	      } else {
	        this._onUpdate(this._fromValue + this._easing(1) * (this._toValue - this._fromValue));
	      }
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	
	    this._onUpdate(this._fromValue + this._easing((now - this._startTime) / this._duration) * (this._toValue - this._fromValue));
	    if (this.__active) {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  TimingAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    clearTimeout(this._timeout);
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return TimingAnimation;
	}(Animation);
	
	module.exports = TimingAnimation;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	/**
	 * BezierEasing - use bezier curve for transition easing function
	 * https://github.com/gre/bezier-easing
	 *
	 * @copyright 2014-2015 Gaëtan Renaudeau. MIT License.
	 * @noflow
	 */
	'use strict';
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A(aA1, aA2) {
	  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	}
	function B(aA1, aA2) {
	  return 3.0 * aA2 - 6.0 * aA1;
	}
	function C(aA1) {
	  return 3.0 * aA1;
	}
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier(aT, aA1, aA2) {
	  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	}
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope(aT, aA1, aA2) {
	  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	}
	
	function binarySubdivide(aX, aA, aB, mX1, mX2) {
	  var currentX,
	      currentT,
	      i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	    var currentSlope = getSlope(aGuessT, mX1, mX2);
	    if (currentSlope === 0.0) {
	      return aGuessT;
	    }
	    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	    aGuessT -= currentX / currentSlope;
	  }
	  return aGuessT;
	}
	
	module.exports = function bezier(mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    // eslint-disable-line yoda
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  if (mX1 !== mY1 || mX2 !== mY2) {
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  function getTForX(aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing(x) {
	    if (mX1 === mY1 && mX2 === mY2) {
	      return x; // linear
	    }
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _require = __webpack_require__(31),
	    AnimatedEvent = _require.AnimatedEvent;
	
	var AnimatedProps = __webpack_require__(70);
	var React = __webpack_require__(1);
	var ViewStylePropTypes = __webpack_require__(26).default;
	
	function createAnimatedComponent(Component) {
	  var AnimatedComponent = function (_React$Component) {
	    _inherits(AnimatedComponent, _React$Component);
	
	    function AnimatedComponent(props) {
	      _classCallCheck(this, AnimatedComponent);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this._invokeAnimatedPropsCallbackOnMount = false;
	      _this._eventDetachers = [];
	
	      _this._animatedPropsCallback = function () {
	        if (_this._component == null) {
	          // AnimatedProps is created in will-mount because it's used in render.
	          // But this callback may be invoked before mount in async mode,
	          // In which case we should defer the setNativeProps() call.
	          // React may throw away uncommitted work in async mode,
	          // So a deferred call won't always be invoked.
	          _this._invokeAnimatedPropsCallbackOnMount = true;
	        } else if (AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY || typeof _this._component.setNativeProps !== 'function') {
	          _this.forceUpdate();
	        } else if (!_this._propsAnimated.__isNative) {
	          _this._component.setNativeProps(_this._propsAnimated.__getAnimatedValue());
	        } else {
	          throw new Error('Attempting to run JS driven animation on animated ' + 'node that has been moved to "native" earlier by starting an ' + 'animation with `useNativeDriver: true`');
	        }
	      };
	
	      _this._setComponentRef = _this._setComponentRef.bind(_this);
	      return _this;
	    }
	
	    AnimatedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this._propsAnimated && this._propsAnimated.__detach();
	      this._detachNativeEvents();
	    };
	
	    AnimatedComponent.prototype.setNativeProps = function setNativeProps(props) {
	      this._component.setNativeProps(props);
	    };
	
	    AnimatedComponent.prototype.componentWillMount = function componentWillMount() {
	      this._attachProps(this.props);
	    };
	
	    AnimatedComponent.prototype.componentDidMount = function componentDidMount() {
	      if (this._invokeAnimatedPropsCallbackOnMount) {
	        this._invokeAnimatedPropsCallbackOnMount = false;
	        this._animatedPropsCallback();
	      }
	
	      this._propsAnimated.setNativeView(this._component);
	      this._attachNativeEvents();
	    };
	
	    AnimatedComponent.prototype._attachNativeEvents = function _attachNativeEvents() {
	      var _this2 = this;
	
	      // Make sure to get the scrollable node for components that implement
	      // `ScrollResponder.Mixin`.
	      var scrollableNode = this._component.getScrollableNode ? this._component.getScrollableNode() : this._component;
	
	      var _loop = function _loop(key) {
	        var prop = _this2.props[key];
	        if (prop instanceof AnimatedEvent && prop.__isNative) {
	          prop.__attach(scrollableNode, key);
	          _this2._eventDetachers.push(function () {
	            return prop.__detach(scrollableNode, key);
	          });
	        }
	      };
	
	      for (var key in this.props) {
	        _loop(key);
	      }
	    };
	
	    AnimatedComponent.prototype._detachNativeEvents = function _detachNativeEvents() {
	      this._eventDetachers.forEach(function (remove) {
	        return remove();
	      });
	      this._eventDetachers = [];
	    };
	
	    // The system is best designed when setNativeProps is implemented. It is
	    // able to avoid re-rendering and directly set the attributes that changed.
	    // However, setNativeProps can only be implemented on leaf native
	    // components. If you want to animate a composite component, you need to
	    // re-render it. In this case, we have a fallback that uses forceUpdate.
	
	
	    AnimatedComponent.prototype._attachProps = function _attachProps(nextProps) {
	      var oldPropsAnimated = this._propsAnimated;
	
	      this._propsAnimated = new AnimatedProps(nextProps, this._animatedPropsCallback);
	
	      // When you call detach, it removes the element from the parent list
	      // of children. If it goes to 0, then the parent also detaches itself
	      // and so on.
	      // An optimization is to attach the new elements and THEN detach the old
	      // ones instead of detaching and THEN attaching.
	      // This way the intermediate state isn't to go to 0 and trigger
	      // this expensive recursive detaching to then re-attach everything on
	      // the very next operation.
	      oldPropsAnimated && oldPropsAnimated.__detach();
	    };
	
	    AnimatedComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
	      this._attachProps(newProps);
	    };
	
	    AnimatedComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	      if (this._component !== this._prevComponent) {
	        this._propsAnimated.setNativeView(this._component);
	      }
	      if (this._component !== this._prevComponent || prevProps !== this.props) {
	        this._detachNativeEvents();
	        this._attachNativeEvents();
	      }
	    };
	
	    AnimatedComponent.prototype.render = function render() {
	      var props = this._propsAnimated.__getValue();
	      return React.createElement(Component, _extends({}, props, {
	        ref: this._setComponentRef
	        // The native driver updates views directly through the UI thread so we
	        // have to make sure the view doesn't get optimized away because it cannot
	        // go through the NativeViewHierachyManager since it operates on the shadow
	        // thread.
	        , collapsable: this._propsAnimated.__isNative ? false : props.collapsable
	      }));
	    };
	
	    AnimatedComponent.prototype._setComponentRef = function _setComponentRef(c) {
	      this._prevComponent = this._component;
	      this._component = c;
	    };
	
	    // A third party library can use getNode()
	    // to get the node reference of the decorated component
	
	
	    AnimatedComponent.prototype.getNode = function getNode() {
	      return this._component;
	    };
	
	    return AnimatedComponent;
	  }(React.Component);
	
	  AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY = false;
	
	  var propTypes = Component.propTypes;
	
	  AnimatedComponent.propTypes =  false ? process.env.NODE_ENV !== "production" ? {
	    style: function style(props, propName, componentName) {
	      if (!propTypes) {
	        return;
	      }
	
	      for (var key in ViewStylePropTypes) {
	        if (!propTypes[key] && props[key] !== undefined) {
	          console.warn('You are setting the style `{ ' + key + ': ... }` as a prop. You ' + 'should nest it in a style object. ' + 'E.g. `{ style: { ' + key + ': ... } }`');
	        }
	      }
	    }
	  } : {} : {};
	
	  return AnimatedComponent;
	}
	
	module.exports = createAnimatedComponent;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedAddition = function (_AnimatedWithChildren) {
	  _inherits(AnimatedAddition, _AnimatedWithChildren);
	
	  function AnimatedAddition(a, b) {
	    _classCallCheck(this, AnimatedAddition);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new AnimatedValue(a) : a;
	    _this._b = typeof b === 'number' ? new AnimatedValue(b) : b;
	    return _this;
	  }
	
	  AnimatedAddition.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedAddition.prototype.__getValue = function __getValue() {
	    return this._a.__getValue() + this._b.__getValue();
	  };
	
	  AnimatedAddition.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedAddition.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedAddition.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedAddition.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'addition',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedAddition;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedAddition;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedDiffClamp = function (_AnimatedWithChildren) {
	  _inherits(AnimatedDiffClamp, _AnimatedWithChildren);
	
	  function AnimatedDiffClamp(a, min, max) {
	    _classCallCheck(this, AnimatedDiffClamp);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = a;
	    _this._min = min;
	    _this._max = max;
	    _this._value = _this._lastValue = _this._a.__getValue();
	    return _this;
	  }
	
	  AnimatedDiffClamp.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedDiffClamp.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedDiffClamp.prototype.__getValue = function __getValue() {
	    var value = this._a.__getValue();
	    var diff = value - this._lastValue;
	    this._lastValue = value;
	    this._value = Math.min(Math.max(this._value + diff, this._min), this._max);
	    return this._value;
	  };
	
	  AnimatedDiffClamp.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	  };
	
	  AnimatedDiffClamp.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedDiffClamp.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'diffclamp',
	      input: this._a.__getNativeTag(),
	      min: this._min,
	      max: this._max
	    };
	  };
	
	  return AnimatedDiffClamp;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedDiffClamp;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedDivision = function (_AnimatedWithChildren) {
	  _inherits(AnimatedDivision, _AnimatedWithChildren);
	
	  function AnimatedDivision(a, b) {
	    _classCallCheck(this, AnimatedDivision);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new AnimatedValue(a) : a;
	    _this._b = typeof b === 'number' ? new AnimatedValue(b) : b;
	    return _this;
	  }
	
	  AnimatedDivision.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedDivision.prototype.__getValue = function __getValue() {
	    var a = this._a.__getValue();
	    var b = this._b.__getValue();
	    if (b === 0) {
	      console.error('Detected division by zero in AnimatedDivision');
	    }
	    return a / b;
	  };
	
	  AnimatedDivision.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedDivision.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedDivision.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedDivision.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'division',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedDivision;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedDivision;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	/* eslint no-bitwise: 0 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	var normalizeColor = __webpack_require__(19);
	
	var linear = function linear(t) {
	  return t;
	};
	
	/**
	 * Very handy helper to map input ranges to output ranges with an easing
	 * function and custom behavior outside of the ranges.
	 */
	function createInterpolation(config) {
	  if (config.outputRange && typeof config.outputRange[0] === 'string') {
	    return createInterpolationFromStringOutputRange(config);
	  }
	
	  var outputRange = config.outputRange;
	  checkInfiniteRange('outputRange', outputRange);
	
	  var inputRange = config.inputRange;
	  checkInfiniteRange('inputRange', inputRange);
	  checkValidInputRange(inputRange);
	
	  invariant(inputRange.length === outputRange.length, 'inputRange (' + inputRange.length + ') and outputRange (' + outputRange.length + ') must have the same length');
	
	  var easing = config.easing || linear;
	
	  var extrapolateLeft = 'extend';
	  if (config.extrapolateLeft !== undefined) {
	    extrapolateLeft = config.extrapolateLeft;
	  } else if (config.extrapolate !== undefined) {
	    extrapolateLeft = config.extrapolate;
	  }
	
	  var extrapolateRight = 'extend';
	  if (config.extrapolateRight !== undefined) {
	    extrapolateRight = config.extrapolateRight;
	  } else if (config.extrapolate !== undefined) {
	    extrapolateRight = config.extrapolate;
	  }
	
	  return function (input) {
	    invariant(typeof input === 'number', 'Cannot interpolation an input which is not a number');
	
	    var range = findRange(input, inputRange);
	    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight);
	  };
	}
	
	function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight) {
	  var result = input;
	
	  // Extrapolate
	  if (result < inputMin) {
	    if (extrapolateLeft === 'identity') {
	      return result;
	    } else if (extrapolateLeft === 'clamp') {
	      result = inputMin;
	    } else if (extrapolateLeft === 'extend') {
	      // noop
	    }
	  }
	
	  if (result > inputMax) {
	    if (extrapolateRight === 'identity') {
	      return result;
	    } else if (extrapolateRight === 'clamp') {
	      result = inputMax;
	    } else if (extrapolateRight === 'extend') {
	      // noop
	    }
	  }
	
	  if (outputMin === outputMax) {
	    return outputMin;
	  }
	
	  if (inputMin === inputMax) {
	    if (input <= inputMin) {
	      return outputMin;
	    }
	    return outputMax;
	  }
	
	  // Input Range
	  if (inputMin === -Infinity) {
	    result = -result;
	  } else if (inputMax === Infinity) {
	    result = result - inputMin;
	  } else {
	    result = (result - inputMin) / (inputMax - inputMin);
	  }
	
	  // Easing
	  result = easing(result);
	
	  // Output Range
	  if (outputMin === -Infinity) {
	    result = -result;
	  } else if (outputMax === Infinity) {
	    result = result + outputMin;
	  } else {
	    result = result * (outputMax - outputMin) + outputMin;
	  }
	
	  return result;
	}
	
	function colorToRgba(input) {
	  var int32Color = normalizeColor(input);
	  if (int32Color === null) {
	    return input;
	  }
	
	  int32Color = int32Color || 0;
	
	  var r = (int32Color & 0xff000000) >>> 24;
	  var g = (int32Color & 0x00ff0000) >>> 16;
	  var b = (int32Color & 0x0000ff00) >>> 8;
	  var a = (int32Color & 0x000000ff) / 255;
	
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	}
	
	var stringShapeRegex = /[0-9\.-]+/g;
	
	/**
	 * Supports string shapes by extracting numbers so new values can be computed,
	 * and recombines those values into new strings of the same shape.  Supports
	 * things like:
	 *
	 *   rgba(123, 42, 99, 0.36) // colors
	 *   -45deg                  // values with units
	 */
	function createInterpolationFromStringOutputRange(config) {
	  var outputRange = config.outputRange;
	  invariant(outputRange.length >= 2, 'Bad output range');
	  outputRange = outputRange.map(colorToRgba);
	  checkPattern(outputRange);
	
	  // ['rgba(0, 100, 200, 0)', 'rgba(50, 150, 250, 0.5)']
	  // ->
	  // [
	  //   [0, 50],
	  //   [100, 150],
	  //   [200, 250],
	  //   [0, 0.5],
	  // ]
	  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
	   * guard against this possibility.
	   */
	  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
	    return [];
	  });
	  outputRange.forEach(function (value) {
	    /* $FlowFixMe(>=0.18.0): `value.match()` can return `null`. Need to guard
	     * against this possibility.
	     */
	    value.match(stringShapeRegex).forEach(function (number, i) {
	      outputRanges[i].push(+number);
	    });
	  });
	
	  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
	   * guard against this possibility.
	   */
	  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
	    return createInterpolation(_extends({}, config, {
	      outputRange: outputRanges[i]
	    }));
	  });
	
	  // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
	  // round the opacity (4th column).
	  var shouldRound = isRgbOrRgba(outputRange[0]);
	
	  return function (input) {
	    var i = 0;
	    // 'rgba(0, 100, 200, 0)'
	    // ->
	    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
	    return outputRange[0].replace(stringShapeRegex, function () {
	      var val = +interpolations[i++](input);
	      var rounded = shouldRound && i < 4 ? Math.round(val) : Math.round(val * 1000) / 1000;
	      return String(rounded);
	    });
	  };
	}
	
	function isRgbOrRgba(range) {
	  return typeof range === 'string' && range.startsWith('rgb');
	}
	
	function checkPattern(arr) {
	  var pattern = arr[0].replace(stringShapeRegex, '');
	  for (var i = 1; i < arr.length; ++i) {
	    invariant(pattern === arr[i].replace(stringShapeRegex, ''), 'invalid pattern ' + arr[0] + ' and ' + arr[i]);
	  }
	}
	
	function findRange(input, inputRange) {
	  var i = void 0;
	  for (i = 1; i < inputRange.length - 1; ++i) {
	    if (inputRange[i] >= input) {
	      break;
	    }
	  }
	  return i - 1;
	}
	
	function checkValidInputRange(arr) {
	  invariant(arr.length >= 2, 'inputRange must have at least 2 elements');
	  for (var i = 1; i < arr.length; ++i) {
	    invariant(arr[i] >= arr[i - 1],
	    /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
	     * one or both of the operands may be something that doesn't cleanly
	     * convert to a string, like undefined, null, and object, etc. If you really
	     * mean this implicit string conversion, you can do something like
	     * String(myThing)
	     */
	    'inputRange must be monotonically increasing ' + arr);
	  }
	}
	
	function checkInfiniteRange(name, arr) {
	  invariant(arr.length >= 2, name + ' must have at least 2 elements');
	  invariant(arr.length !== 2 || arr[0] !== -Infinity || arr[1] !== Infinity,
	  /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
	   * one or both of the operands may be something that doesn't cleanly convert
	   * to a string, like undefined, null, and object, etc. If you really mean
	   * this implicit string conversion, you can do something like
	   * String(myThing)
	   */
	  name + 'cannot be ]-infinity;+infinity[ ' + arr);
	}
	
	var AnimatedInterpolation = function (_AnimatedWithChildren) {
	  _inherits(AnimatedInterpolation, _AnimatedWithChildren);
	
	  // Export for testing.
	  function AnimatedInterpolation(parent, config) {
	    _classCallCheck(this, AnimatedInterpolation);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._parent = parent;
	    _this._config = config;
	    _this._interpolation = createInterpolation(config);
	    return _this;
	  }
	
	  AnimatedInterpolation.prototype.__makeNative = function __makeNative() {
	    this._parent.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedInterpolation.prototype.__getValue = function __getValue() {
	    var parentValue = this._parent.__getValue();
	    invariant(typeof parentValue === 'number', 'Cannot interpolate an input which is not a number.');
	    return this._interpolation(parentValue);
	  };
	
	  AnimatedInterpolation.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedInterpolation.prototype.__attach = function __attach() {
	    this._parent.__addChild(this);
	  };
	
	  AnimatedInterpolation.prototype.__detach = function __detach() {
	    this._parent.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedInterpolation.prototype.__transformDataType = function __transformDataType(range) {
	    // Change the string array type to number array
	    // So we can reuse the same logic in iOS and Android platform
	    return range.map(function (value) {
	      if (typeof value !== 'string') {
	        return value;
	      }
	      if (/deg$/.test(value)) {
	        var degrees = parseFloat(value) || 0;
	        var radians = degrees * Math.PI / 180.0;
	        return radians;
	      } else {
	        // Assume radians
	        return parseFloat(value) || 0;
	      }
	    });
	  };
	
	  AnimatedInterpolation.prototype.__getNativeConfig = function __getNativeConfig() {
	    if (false) {
	      NativeAnimatedHelper.validateInterpolation(this._config);
	    }
	
	    return {
	      inputRange: this._config.inputRange,
	      // Only the `outputRange` can contain strings so we don't need to tranform `inputRange` here
	      outputRange: this.__transformDataType(this._config.outputRange),
	      extrapolateLeft: this._config.extrapolateLeft || this._config.extrapolate || 'extend',
	      extrapolateRight: this._config.extrapolateRight || this._config.extrapolate || 'extend',
	      type: 'interpolation'
	    };
	  };
	
	  return AnimatedInterpolation;
	}(AnimatedWithChildren);
	
	AnimatedInterpolation.__createInterpolation = createInterpolation;
	
	module.exports = AnimatedInterpolation;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedModulo = function (_AnimatedWithChildren) {
	  _inherits(AnimatedModulo, _AnimatedWithChildren);
	
	  function AnimatedModulo(a, modulus) {
	    _classCallCheck(this, AnimatedModulo);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = a;
	    _this._modulus = modulus;
	    return _this;
	  }
	
	  AnimatedModulo.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedModulo.prototype.__getValue = function __getValue() {
	    return (this._a.__getValue() % this._modulus + this._modulus) % this._modulus;
	  };
	
	  AnimatedModulo.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedModulo.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	  };
	
	  AnimatedModulo.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedModulo.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'modulus',
	      input: this._a.__getNativeTag(),
	      modulus: this._modulus
	    };
	  };
	
	  return AnimatedModulo;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedModulo;

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedMultiplication = function (_AnimatedWithChildren) {
	  _inherits(AnimatedMultiplication, _AnimatedWithChildren);
	
	  function AnimatedMultiplication(a, b) {
	    _classCallCheck(this, AnimatedMultiplication);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new AnimatedValue(a) : a;
	    _this._b = typeof b === 'number' ? new AnimatedValue(b) : b;
	    return _this;
	  }
	
	  AnimatedMultiplication.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedMultiplication.prototype.__getValue = function __getValue() {
	    return this._a.__getValue() * this._b.__getValue();
	  };
	
	  AnimatedMultiplication.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedMultiplication.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedMultiplication.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedMultiplication.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'multiplication',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedMultiplication;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedMultiplication;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	// Note(vjeux): this would be better as an interface but flow doesn't
	// support them yet
	
	var AnimatedNode = function () {
	  function AnimatedNode() {
	    _classCallCheck(this, AnimatedNode);
	  }
	
	  AnimatedNode.prototype.__attach = function __attach() {};
	
	  AnimatedNode.prototype.__detach = function __detach() {
	    if (this.__isNative && this.__nativeTag != null) {
	      NativeAnimatedHelper.API.dropAnimatedNode(this.__nativeTag);
	      this.__nativeTag = undefined;
	    }
	  };
	
	  AnimatedNode.prototype.__getValue = function __getValue() {};
	
	  AnimatedNode.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this.__getValue();
	  };
	
	  AnimatedNode.prototype.__addChild = function __addChild(child) {};
	
	  AnimatedNode.prototype.__removeChild = function __removeChild(child) {};
	
	  AnimatedNode.prototype.__getChildren = function __getChildren() {
	    return [];
	  };
	
	  /* Methods and props used by native Animated impl */
	
	  AnimatedNode.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      throw new Error('This node cannot be made a "native" animated node');
	    }
	  };
	
	  AnimatedNode.prototype.__getNativeTag = function __getNativeTag() {
	    NativeAnimatedHelper.assertNativeAnimatedModule();
	    invariant(this.__isNative, 'Attempt to get native tag from node not marked as "native"');
	    if (this.__nativeTag == null) {
	      var nativeTag = NativeAnimatedHelper.generateNewNodeTag();
	      NativeAnimatedHelper.API.createAnimatedNode(nativeTag, this.__getNativeConfig());
	      this.__nativeTag = nativeTag;
	    }
	    return this.__nativeTag;
	  };
	
	  AnimatedNode.prototype.__getNativeConfig = function __getNativeConfig() {
	    throw new Error('This JS animated node type cannot be used as native animated node');
	  };
	
	  AnimatedNode.prototype.toJSON = function toJSON() {
	    return this.__getValue();
	  };
	
	  return AnimatedNode;
	}();
	
	module.exports = AnimatedNode;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _require = __webpack_require__(31),
	    AnimatedEvent = _require.AnimatedEvent;
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedStyle = __webpack_require__(148);
	var NativeAnimatedHelper = __webpack_require__(5);
	var findNodeHandle = __webpack_require__(11).default;
	
	var invariant = __webpack_require__(3);
	
	var AnimatedProps = function (_AnimatedNode) {
	  _inherits(AnimatedProps, _AnimatedNode);
	
	  function AnimatedProps(props, callback) {
	    _classCallCheck(this, AnimatedProps);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    if (props.style) {
	      props = _extends({}, props, {
	        style: new AnimatedStyle(props.style)
	      });
	    }
	    _this._props = props;
	    _this._callback = callback;
	    _this.__attach();
	    return _this;
	  }
	
	  AnimatedProps.prototype.__getValue = function __getValue() {
	    var props = {};
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        if (!value.__isNative || value instanceof AnimatedStyle) {
	          // We cannot use value of natively driven nodes this way as the value we have access from
	          // JS may not be up to date.
	          props[key] = value.__getValue();
	        }
	      } else if (value instanceof AnimatedEvent) {
	        props[key] = value.__getHandler();
	      } else {
	        props[key] = value;
	      }
	    }
	    return props;
	  };
	
	  AnimatedProps.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    var props = {};
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        props[key] = value.__getAnimatedValue();
	      }
	    }
	    return props;
	  };
	
	  AnimatedProps.prototype.__attach = function __attach() {
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        value.__addChild(this);
	      }
	    }
	  };
	
	  AnimatedProps.prototype.__detach = function __detach() {
	    if (this.__isNative && this._animatedView) {
	      this.__disconnectAnimatedView();
	    }
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        value.__removeChild(this);
	      }
	    }
	    _AnimatedNode.prototype.__detach.call(this);
	  };
	
	  AnimatedProps.prototype.update = function update() {
	    this._callback();
	  };
	
	  AnimatedProps.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      this.__isNative = true;
	      for (var key in this._props) {
	        var value = this._props[key];
	        if (value instanceof AnimatedNode) {
	          value.__makeNative();
	        }
	      }
	      if (this._animatedView) {
	        this.__connectAnimatedView();
	      }
	    }
	  };
	
	  AnimatedProps.prototype.setNativeView = function setNativeView(animatedView) {
	    if (this._animatedView === animatedView) {
	      return;
	    }
	    this._animatedView = animatedView;
	    if (this.__isNative) {
	      this.__connectAnimatedView();
	    }
	  };
	
	  AnimatedProps.prototype.__connectAnimatedView = function __connectAnimatedView() {
	    invariant(this.__isNative, 'Expected node to be marked as "native"');
	    var nativeViewTag = findNodeHandle(this._animatedView);
	    invariant(nativeViewTag != null, 'Unable to locate attached view in the native tree');
	    NativeAnimatedHelper.API.connectAnimatedNodeToView(this.__getNativeTag(), nativeViewTag);
	  };
	
	  AnimatedProps.prototype.__disconnectAnimatedView = function __disconnectAnimatedView() {
	    invariant(this.__isNative, 'Expected node to be marked as "native"');
	    var nativeViewTag = findNodeHandle(this._animatedView);
	    invariant(nativeViewTag != null, 'Unable to locate attached view in the native tree');
	    NativeAnimatedHelper.API.disconnectAnimatedNodeFromView(this.__getNativeTag(), nativeViewTag);
	  };
	
	  AnimatedProps.prototype.__getNativeConfig = function __getNativeConfig() {
	    var propsConfig = {};
	    for (var propKey in this._props) {
	      var value = this._props[propKey];
	      if (value instanceof AnimatedNode) {
	        propsConfig[propKey] = value.__getNativeTag();
	      }
	    }
	    return {
	      type: 'props',
	      props: propsConfig
	    };
	  };
	
	  return AnimatedProps;
	}(AnimatedNode);
	
	module.exports = AnimatedProps;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedTransform = __webpack_require__(150);
	var AnimatedWithChildren = __webpack_require__(8);
	var NativeAnimatedHelper = __webpack_require__(5);
	var StyleSheet = __webpack_require__(4).default;
	
	var flattenStyle = StyleSheet.flatten;
	
	var AnimatedStyle = function (_AnimatedWithChildren) {
	  _inherits(AnimatedStyle, _AnimatedWithChildren);
	
	  function AnimatedStyle(style) {
	    _classCallCheck(this, AnimatedStyle);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    style = flattenStyle(style) || {};
	    if (style.transform) {
	      style = _extends({}, style, {
	        transform: new AnimatedTransform(style.transform)
	      });
	    }
	    _this._style = style;
	    return _this;
	  }
	
	  // Recursively get values for nested styles (like iOS's shadowOffset)
	
	
	  AnimatedStyle.prototype._walkStyleAndGetValues = function _walkStyleAndGetValues(style) {
	    var updatedStyle = {};
	    for (var key in style) {
	      var value = style[key];
	      if (value instanceof AnimatedNode) {
	        if (!value.__isNative) {
	          // We cannot use value of natively driven nodes this way as the value we have access from
	          // JS may not be up to date.
	          updatedStyle[key] = value.__getValue();
	        }
	      } else if (value && !Array.isArray(value) && typeof value === 'object') {
	        // Support animating nested values (for example: shadowOffset.height)
	        updatedStyle[key] = this._walkStyleAndGetValues(value);
	      } else {
	        updatedStyle[key] = value;
	      }
	    }
	    return updatedStyle;
	  };
	
	  AnimatedStyle.prototype.__getValue = function __getValue() {
	    return this._walkStyleAndGetValues(this._style);
	  };
	
	  // Recursively get animated values for nested styles (like iOS's shadowOffset)
	
	
	  AnimatedStyle.prototype._walkStyleAndGetAnimatedValues = function _walkStyleAndGetAnimatedValues(style) {
	    var updatedStyle = {};
	    for (var key in style) {
	      var value = style[key];
	      if (value instanceof AnimatedNode) {
	        updatedStyle[key] = value.__getAnimatedValue();
	      } else if (value && !Array.isArray(value) && typeof value === 'object') {
	        // Support animating nested values (for example: shadowOffset.height)
	        updatedStyle[key] = this._walkStyleAndGetAnimatedValues(value);
	      }
	    }
	    return updatedStyle;
	  };
	
	  AnimatedStyle.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this._walkStyleAndGetAnimatedValues(this._style);
	  };
	
	  AnimatedStyle.prototype.__attach = function __attach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof AnimatedNode) {
	        value.__addChild(this);
	      }
	    }
	  };
	
	  AnimatedStyle.prototype.__detach = function __detach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof AnimatedNode) {
	        value.__removeChild(this);
	      }
	    }
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedStyle.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof AnimatedNode) {
	        value.__makeNative();
	      }
	    }
	  };
	
	  AnimatedStyle.prototype.__getNativeConfig = function __getNativeConfig() {
	    var styleConfig = {};
	    for (var styleKey in this._style) {
	      if (this._style[styleKey] instanceof AnimatedNode) {
	        styleConfig[styleKey] = this._style[styleKey].__getNativeTag();
	      }
	      // Non-animated styles are set using `setNativeProps`, no need
	      // to pass those as a part of the node config
	    }
	    NativeAnimatedHelper.validateStyles(styleConfig);
	    return {
	      type: 'style',
	      style: styleConfig
	    };
	  };
	
	  return AnimatedStyle;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedStyle;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedNode = __webpack_require__(6);
	
	var AnimatedTracking = function (_AnimatedNode) {
	  _inherits(AnimatedTracking, _AnimatedNode);
	
	  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
	    _classCallCheck(this, AnimatedTracking);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    _this._value = value;
	    _this._parent = parent;
	    _this._animationClass = animationClass;
	    _this._animationConfig = animationConfig;
	    _this._callback = callback;
	    _this.__attach();
	    return _this;
	  }
	
	  AnimatedTracking.prototype.__getValue = function __getValue() {
	    return this._parent.__getValue();
	  };
	
	  AnimatedTracking.prototype.__attach = function __attach() {
	    this._parent.__addChild(this);
	  };
	
	  AnimatedTracking.prototype.__detach = function __detach() {
	    this._parent.__removeChild(this);
	    _AnimatedNode.prototype.__detach.call(this);
	  };
	
	  AnimatedTracking.prototype.update = function update() {
	    this._value.animate(new this._animationClass(_extends({}, this._animationConfig, {
	      toValue: this._animationConfig.toValue.__getValue()
	    })), this._callback);
	  };
	
	  return AnimatedTracking;
	}(AnimatedNode);
	
	module.exports = AnimatedTracking;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var AnimatedTransform = function (_AnimatedWithChildren) {
	  _inherits(AnimatedTransform, _AnimatedWithChildren);
	
	  function AnimatedTransform(transforms) {
	    _classCallCheck(this, AnimatedTransform);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._transforms = transforms;
	    return _this;
	  }
	
	  AnimatedTransform.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          value.__makeNative();
	        }
	      }
	    });
	  };
	
	  AnimatedTransform.prototype.__getValue = function __getValue() {
	    return this._transforms.map(function (transform) {
	      var result = {};
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          result[key] = value.__getValue();
	        } else {
	          result[key] = value;
	        }
	      }
	      return result;
	    });
	  };
	
	  AnimatedTransform.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this._transforms.map(function (transform) {
	      var result = {};
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          result[key] = value.__getAnimatedValue();
	        } else {
	          // All transform components needed to recompose matrix
	          result[key] = value;
	        }
	      }
	      return result;
	    });
	  };
	
	  AnimatedTransform.prototype.__attach = function __attach() {
	    var _this2 = this;
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          value.__addChild(_this2);
	        }
	      }
	    });
	  };
	
	  AnimatedTransform.prototype.__detach = function __detach() {
	    var _this3 = this;
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          value.__removeChild(_this3);
	        }
	      }
	    });
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedTransform.prototype.__getNativeConfig = function __getNativeConfig() {
	    var transConfigs = [];
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          transConfigs.push({
	            type: 'animated',
	            property: key,
	            nodeTag: value.__getNativeTag()
	          });
	        } else {
	          transConfigs.push({
	            type: 'static',
	            property: key,
	            value: value
	          });
	        }
	      }
	    });
	
	    NativeAnimatedHelper.validateTransform(transConfigs);
	    return {
	      type: 'transform',
	      transforms: transConfigs
	    };
	  };
	
	  return AnimatedTransform;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedTransform;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	var InteractionManager = __webpack_require__(102).default;
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var NativeAnimatedAPI = NativeAnimatedHelper.API;
	
	var _uniqueId = 1;
	
	/**
	 * Animated works by building a directed acyclic graph of dependencies
	 * transparently when you render your Animated components.
	 *
	 *               new Animated.Value(0)
	 *     .interpolate()        .interpolate()    new Animated.Value(1)
	 *         opacity               translateY      scale
	 *          style                         transform
	 *         View#234                         style
	 *                                         View#123
	 *
	 * A) Top Down phase
	 * When an Animated.Value is updated, we recursively go down through this
	 * graph in order to find leaf nodes: the views that we flag as needing
	 * an update.
	 *
	 * B) Bottom Up phase
	 * When a view is flagged as needing an update, we recursively go back up
	 * in order to build the new value that it needs. The reason why we need
	 * this two-phases process is to deal with composite props such as
	 * transform which can receive values from multiple parents.
	 */
	function _flush(rootNode) {
	  var animatedStyles = new Set();
	  function findAnimatedStyles(node) {
	    if (typeof node.update === 'function') {
	      animatedStyles.add(node);
	    } else {
	      node.__getChildren().forEach(findAnimatedStyles);
	    }
	  }
	  findAnimatedStyles(rootNode);
	  /* $FlowFixMe */
	  animatedStyles.forEach(function (animatedStyle) {
	    return animatedStyle.update();
	  });
	}
	
	/**
	 * Standard value for driving animations.  One `Animated.Value` can drive
	 * multiple properties in a synchronized fashion, but can only be driven by one
	 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
	 * or calling `setValue`) will stop any previous ones.
	 *
	 * See http://facebook.github.io/react-native/docs/animatedvalue.html
	 */
	
	var AnimatedValue = function (_AnimatedWithChildren) {
	  _inherits(AnimatedValue, _AnimatedWithChildren);
	
	  function AnimatedValue(value) {
	    _classCallCheck(this, AnimatedValue);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._startingValue = _this._value = value;
	    _this._offset = 0;
	    _this._animation = null;
	    _this._listeners = {};
	    return _this;
	  }
	
	  AnimatedValue.prototype.__detach = function __detach() {
	    this.stopAnimation();
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedValue.prototype.__getValue = function __getValue() {
	    return this._value + this._offset;
	  };
	
	  AnimatedValue.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	
	    if (Object.keys(this._listeners).length) {
	      this._startListeningToNativeValueUpdates();
	    }
	  };
	
	  /**
	   * Directly set the value.  This will stop any animations running on the value
	   * and update all the bound properties.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setvalue
	   */
	
	  AnimatedValue.prototype.setValue = function setValue(value) {
	    if (this._animation) {
	      this._animation.stop();
	      this._animation = null;
	    }
	    this._updateValue(value, !this.__isNative /* don't perform a flush for natively driven values */
	    );
	    if (this.__isNative) {
	      NativeAnimatedAPI.setAnimatedNodeValue(this.__getNativeTag(), value);
	    }
	  };
	
	  /**
	   * Sets an offset that is applied on top of whatever value is set, whether via
	   * `setValue`, an animation, or `Animated.event`.  Useful for compensating
	   * things like the start of a pan gesture.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setoffset
	   */
	
	  AnimatedValue.prototype.setOffset = function setOffset(offset) {
	    this._offset = offset;
	    if (this.__isNative) {
	      NativeAnimatedAPI.setAnimatedNodeOffset(this.__getNativeTag(), offset);
	    }
	  };
	
	  /**
	   * Merges the offset value into the base value and resets the offset to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#flattenoffset
	   */
	
	  AnimatedValue.prototype.flattenOffset = function flattenOffset() {
	    this._value += this._offset;
	    this._offset = 0;
	    if (this.__isNative) {
	      NativeAnimatedAPI.flattenAnimatedNodeOffset(this.__getNativeTag());
	    }
	  };
	
	  /**
	   * Sets the offset value to the base value, and resets the base value to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#extractoffset
	   */
	
	  AnimatedValue.prototype.extractOffset = function extractOffset() {
	    this._offset += this._value;
	    this._value = 0;
	    if (this.__isNative) {
	      NativeAnimatedAPI.extractAnimatedNodeOffset(this.__getNativeTag());
	    }
	  };
	
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to
	   * synchronously read the value because it might be driven natively.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#addlistener
	   */
	
	  AnimatedValue.prototype.addListener = function addListener(callback) {
	    var id = String(_uniqueId++);
	    this._listeners[id] = callback;
	    if (this.__isNative) {
	      this._startListeningToNativeValueUpdates();
	    }
	    return id;
	  };
	
	  /**
	   * Unregister a listener. The `id` param shall match the identifier
	   * previously returned by `addListener()`.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removelistener
	   */
	
	  AnimatedValue.prototype.removeListener = function removeListener(id) {
	    delete this._listeners[id];
	    if (this.__isNative && Object.keys(this._listeners).length === 0) {
	      this._stopListeningForNativeValueUpdates();
	    }
	  };
	
	  /**
	   * Remove all registered listeners.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removealllisteners
	   */
	
	  AnimatedValue.prototype.removeAllListeners = function removeAllListeners() {
	    this._listeners = {};
	    if (this.__isNative) {
	      this._stopListeningForNativeValueUpdates();
	    }
	  };
	
	  AnimatedValue.prototype._startListeningToNativeValueUpdates = function _startListeningToNativeValueUpdates() {
	    var _this2 = this;
	
	    if (this.__nativeAnimatedValueListener) {
	      return;
	    }
	
	    NativeAnimatedAPI.startListeningToAnimatedNodeValue(this.__getNativeTag());
	    this.__nativeAnimatedValueListener = NativeAnimatedHelper.nativeEventEmitter.addListener('onAnimatedValueUpdate', function (data) {
	      if (data.tag !== _this2.__getNativeTag()) {
	        return;
	      }
	      _this2._updateValue(data.value, false /* flush */);
	    });
	  };
	
	  AnimatedValue.prototype._stopListeningForNativeValueUpdates = function _stopListeningForNativeValueUpdates() {
	    if (!this.__nativeAnimatedValueListener) {
	      return;
	    }
	
	    this.__nativeAnimatedValueListener.remove();
	    this.__nativeAnimatedValueListener = null;
	    NativeAnimatedAPI.stopListeningToAnimatedNodeValue(this.__getNativeTag());
	  };
	
	  /**
	   * Stops any running animation or tracking. `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#stopanimation
	   */
	
	  AnimatedValue.prototype.stopAnimation = function stopAnimation(callback) {
	    this.stopTracking();
	    this._animation && this._animation.stop();
	    this._animation = null;
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Stops any animation and resets the value to its original.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#resetanimation
	   */
	
	  AnimatedValue.prototype.resetAnimation = function resetAnimation(callback) {
	    this.stopAnimation(callback);
	    this._value = this._startingValue;
	  };
	
	  /**
	   * Interpolates the value before updating the property, e.g. mapping 0-1 to
	   * 0-10.
	   */
	
	  AnimatedValue.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  /**
	   * Typically only used internally, but could be used by a custom Animation
	   * class.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#animate
	   */
	
	  AnimatedValue.prototype.animate = function animate(animation, callback) {
	    var _this3 = this;
	
	    var handle = null;
	    if (animation.__isInteraction) {
	      handle = InteractionManager.createInteractionHandle();
	    }
	    var previousAnimation = this._animation;
	    this._animation && this._animation.stop();
	    this._animation = animation;
	    animation.start(this._value, function (value) {
	      // Natively driven animations will never call into that callback, therefore we can always
	      // pass flush = true to allow the updated value to propagate to native with setNativeProps
	      _this3._updateValue(value, true /* flush */);
	    }, function (result) {
	      _this3._animation = null;
	      if (handle !== null) {
	        InteractionManager.clearInteractionHandle(handle);
	      }
	      callback && callback(result);
	    }, previousAnimation, this);
	  };
	
	  /**
	   * Typically only used internally.
	   */
	
	  AnimatedValue.prototype.stopTracking = function stopTracking() {
	    this._tracking && this._tracking.__detach();
	    this._tracking = null;
	  };
	
	  /**
	   * Typically only used internally.
	   */
	
	  AnimatedValue.prototype.track = function track(tracking) {
	    this.stopTracking();
	    this._tracking = tracking;
	  };
	
	  AnimatedValue.prototype._updateValue = function _updateValue(value, flush) {
	    this._value = value;
	    if (flush) {
	      _flush(this);
	    }
	    for (var _key in this._listeners) {
	      this._listeners[_key]({ value: this.__getValue() });
	    }
	  };
	
	  AnimatedValue.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'value',
	      value: this._value,
	      offset: this._offset
	    };
	  };
	
	  return AnimatedValue;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedValue;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var invariant = __webpack_require__(3);
	
	var _uniqueId = 1;
	
	/**
	 * 2D Value for driving 2D animations, such as pan gestures. Almost identical
	 * API to normal `Animated.Value`, but multiplexed.
	 *
	 * See http://facebook.github.io/react-native/docs/animatedvaluexy.html
	 */
	
	var AnimatedValueXY = function (_AnimatedWithChildren) {
	  _inherits(AnimatedValueXY, _AnimatedWithChildren);
	
	  function AnimatedValueXY(valueIn) {
	    _classCallCheck(this, AnimatedValueXY);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    var value = valueIn || { x: 0, y: 0 }; // fixme: shouldn't need `: any`
	    if (typeof value.x === 'number' && typeof value.y === 'number') {
	      _this.x = new AnimatedValue(value.x);
	      _this.y = new AnimatedValue(value.y);
	    } else {
	      invariant(value.x instanceof AnimatedValue && value.y instanceof AnimatedValue, 'AnimatedValueXY must be initalized with an object of numbers or ' + 'AnimatedValues.');
	      _this.x = value.x;
	      _this.y = value.y;
	    }
	    _this._listeners = {};
	    return _this;
	  }
	
	  /**
	   * Directly set the value. This will stop any animations running on the value
	   * and update all the bound properties.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setvalue
	   */
	
	  AnimatedValueXY.prototype.setValue = function setValue(value) {
	    this.x.setValue(value.x);
	    this.y.setValue(value.y);
	  };
	
	  /**
	   * Sets an offset that is applied on top of whatever value is set, whether
	   * via `setValue`, an animation, or `Animated.event`. Useful for compensating
	   * things like the start of a pan gesture.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setoffset
	   */
	
	  AnimatedValueXY.prototype.setOffset = function setOffset(offset) {
	    this.x.setOffset(offset.x);
	    this.y.setOffset(offset.y);
	  };
	
	  /**
	   * Merges the offset value into the base value and resets the offset to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#flattenoffset
	   */
	
	  AnimatedValueXY.prototype.flattenOffset = function flattenOffset() {
	    this.x.flattenOffset();
	    this.y.flattenOffset();
	  };
	
	  /**
	   * Sets the offset value to the base value, and resets the base value to
	   * zero. The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#extractoffset
	   */
	
	  AnimatedValueXY.prototype.extractOffset = function extractOffset() {
	    this.x.extractOffset();
	    this.y.extractOffset();
	  };
	
	  AnimatedValueXY.prototype.__getValue = function __getValue() {
	    return {
	      x: this.x.__getValue(),
	      y: this.y.__getValue()
	    };
	  };
	
	  /**
	   * Stops any animation and resets the value to its original.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#resetanimation
	   */
	
	  AnimatedValueXY.prototype.resetAnimation = function resetAnimation(callback) {
	    this.x.resetAnimation();
	    this.y.resetAnimation();
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Stops any running animation or tracking. `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#stopanimation
	   */
	
	  AnimatedValueXY.prototype.stopAnimation = function stopAnimation(callback) {
	    this.x.stopAnimation();
	    this.y.stopAnimation();
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to synchronously read
	   * the value because it might be driven natively.
	   *
	   * Returns a string that serves as an identifier for the listener.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#addlistener
	   */
	
	  AnimatedValueXY.prototype.addListener = function addListener(callback) {
	    var _this2 = this;
	
	    var id = String(_uniqueId++);
	    var jointCallback = function jointCallback(_ref) {
	      var number = _ref.value;
	
	      callback(_this2.__getValue());
	    };
	    this._listeners[id] = {
	      x: this.x.addListener(jointCallback),
	      y: this.y.addListener(jointCallback)
	    };
	    return id;
	  };
	
	  /**
	   * Unregister a listener. The `id` param shall match the identifier
	   * previously returned by `addListener()`.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removelistener
	   */
	
	  AnimatedValueXY.prototype.removeListener = function removeListener(id) {
	    this.x.removeListener(this._listeners[id].x);
	    this.y.removeListener(this._listeners[id].y);
	    delete this._listeners[id];
	  };
	
	  /**
	   * Remove all registered listeners.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removealllisteners
	   */
	
	  AnimatedValueXY.prototype.removeAllListeners = function removeAllListeners() {
	    this.x.removeAllListeners();
	    this.y.removeAllListeners();
	    this._listeners = {};
	  };
	
	  /**
	   * Converts `{x, y}` into `{left, top}` for use in style.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#getlayout
	   */
	
	  AnimatedValueXY.prototype.getLayout = function getLayout() {
	    return {
	      left: this.x,
	      top: this.y
	    };
	  };
	
	  /**
	   * Converts `{x, y}` into a useable translation transform.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#gettranslatetransform
	   */
	
	  AnimatedValueXY.prototype.getTranslateTransform = function getTranslateTransform() {
	    return [{ translateX: this.x }, { translateY: this.y }];
	  };
	
	  return AnimatedValueXY;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedValueXY;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var AnimatedWithChildren = function (_AnimatedNode) {
	  _inherits(AnimatedWithChildren, _AnimatedNode);
	
	  function AnimatedWithChildren() {
	    _classCallCheck(this, AnimatedWithChildren);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    _this._children = [];
	    return _this;
	  }
	
	  AnimatedWithChildren.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      this.__isNative = true;
	      for (var _iterator = this._children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var child = _ref;
	
	        child.__makeNative();
	        NativeAnimatedHelper.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	      }
	    }
	  };
	
	  AnimatedWithChildren.prototype.__addChild = function __addChild(child) {
	    if (this._children.length === 0) {
	      this.__attach();
	    }
	    this._children.push(child);
	    if (this.__isNative) {
	      // Only accept "native" animated nodes as children
	      child.__makeNative();
	      NativeAnimatedHelper.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	    }
	  };
	
	  AnimatedWithChildren.prototype.__removeChild = function __removeChild(child) {
	    var index = this._children.indexOf(child);
	    if (index === -1) {
	      console.warn("Trying to remove a child that doesn't exist");
	      return;
	    }
	    if (this.__isNative && child.__isNative) {
	      NativeAnimatedHelper.API.disconnectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	    }
	    this._children.splice(index, 1);
	    if (this._children.length === 0) {
	      this.__detach();
	    }
	  };
	
	  AnimatedWithChildren.prototype.__getChildren = function __getChildren() {
	    return this._children;
	  };
	
	  return AnimatedWithChildren;
	}(AnimatedNode);
	
	module.exports = AnimatedWithChildren;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	}; /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * From React 16.0.0
	 */
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = twoArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  twoArgumentPooler: twoArgumentPooler
	};
	
	exports.default = PooledClass;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-daf79f1499d05f22d111.js